var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _g4, _g5, _path10, _polygon, _path11, _rect2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g6, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _polygon2, _path58, _path59, _path60, _path61, _path62, _polygon3, _path63, _path64, _polygon4, _path65, _path66, _polygon5, _path67, _path68, _path69, _path70, _path71, _path72, _g7, _circle, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _polygon6, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g8, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _g9, _path102, _path103, _path104, _path105, _path106, _path107, _polygon7, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _g10, _rect3, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _rect4, _rect5, _path134, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path135, _path136, _path137, _rect12, _rect13, _rect14, _rect15, _path138, _path139, _path140, _path141, _path142, _circle2, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _g11, _g12, _rect16, _text, _g13, _g14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargeDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3840 960",
    enableBackground: "new 0 0 3840 960",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "story-header-bg"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "white-bg",
    fill: "#FFFFFF",
    width: 3840,
    height: 960
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M774.99,380.54c0.26-8.92-3.77-23.32-26.86-34.11c-0.61-0.29-1.29,0.26-1.13,0.92l8.84,37.37 c0.05,0.21,0.01,0.42-0.09,0.6l-10.95,18.12c-0.19,0.32-0.14,0.73,0.13,0.99c16.4,15.94,28.54,38.14,28.36,68.89 C773.51,459,774.59,393.87,774.99,380.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M708.56,335.55c-9.67-1.45-20.72-2.51-33.33-3.04c-0.98-0.04-1.7,0.9-1.42,1.83l5.04,16.61 c0.11,0.36,0.07,0.75-0.1,1.08l-7.22,13.66c-0.44,0.82,0.02,1.84,0.93,2.05c8.98,2.08,21.86,5.79,35.42,12.02 c0.68,0.31,1.48,0.05,1.84-0.6l8.01-14.44c0.19-0.34,0.23-0.73,0.12-1.1l-8.14-27.07C709.55,336.02,709.1,335.63,708.56,335.55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M672.52,333.97c-0.29-0.94-1.14-1.6-2.13-1.63c-0.42-0.01-0.84-0.03-1.26-0.04l-17.57-0.19 c-1.58-0.02-2.71,1.53-2.21,3.03l9.7,28.86c0.27,0.82,0.98,1.41,1.83,1.54c1.39,0.21,3.77,0.61,6.92,1.27 c1,0.21,2.03-0.27,2.51-1.18l7.07-13.36c0.28-0.54,0.34-1.16,0.17-1.74L672.52,333.97z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M700.47,352.22c0.05-6.19-1.02-12.23-3.05-17.88l6.66-7.03l-9.19-15.3l-9.82,2.95 c-4.33-4.29-9.45-7.87-15.22-10.45l-0.25-9.22l-17.32-4.32l-4.83,8.97c-5.34,0.11-10.57,1.04-15.51,2.7l-8.24-7.4l-15.3,9.19 l3.27,10.82c-3.58,3.6-6.66,7.74-9.1,12.35l-11.36,0.06l-4.32,17.32l9.49,5.11l0.22-0.62c-0.27,5.57,0.38,11.04,1.82,16.25 l-7.26,7.84l9.19,15.3l9.08-2.73c4.1,4.69,9.07,8.67,14.74,11.67l0.26,9.67l17.32,4.32l4.31-8c6.64,0.32,13.15-0.65,19.22-2.73 l6.76,6.4l15.3-9.19l-2.72-9.05c4.5-4.34,8.25-9.53,10.97-15.4l-0.76,0.91l10.54-0.2l4.32-17.32L700.47,352.22z M639.71,387.12 c-19.46-4.86-31.3-24.57-26.45-44.04c4.86-19.46,24.58-31.3,44.04-26.45c19.46,4.86,31.3,24.58,26.45,44.04 C678.89,380.14,659.17,391.98,639.71,387.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.9373,
    y1: -2731.2957,
    x2: 760.1532,
    y2: -2731.2957,
    gradientTransform: "matrix(0.1834 0.983 -0.983 0.1834 -2319.3381 129.5704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M450.73,260.74c0,0,24.69-4.35,46.77,7.47c28.39,15.2,53.81,49.51,35.01,102.62l-76.77-29.68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -1147.6791,
    y1: 957.0204,
    x2: -1021.9605,
    y2: 957.0204,
    gradientTransform: "matrix(0.752 -0.6591 0.6591 0.752 602.4982 -1110.7278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M392.57,390.97c0,0-14.16-18.2-15.25-43.23c-1.41-32.18,15.3-73.48,70.57-84.39l10,77.51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -3450.6494,
    y1: -2265.679,
    x2: -3324.8989,
    y2: -2265.679,
    gradientTransform: "matrix(-0.9529 -0.3032 0.3032 -0.9529 -2079.1296 -2801.6099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1677,
    style: {
      stopColor: "#FCFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    style: {
      stopColor: "#F2FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    style: {
      stopColor: "#E0F5FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5534,
    style: {
      stopColor: "#C8EEF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6698,
    style: {
      stopColor: "#A9E4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#83D8EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8914,
    style: {
      stopColor: "#56CAE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#23B9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M532.4,371.18c0,0-8.27,21.52-29.13,35.39c-26.82,17.83-71.02,25.41-108.92-16.27l61.39-49.16"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DDD7C5",
    d: "M530.05,365.73c-2.31-1.45-8.34-5.14-15.29-9.39c-11.22-6.87-24.83-15.2-29.01-17.95 c-6.77-4.44-6.46-1.96-10.63-0.63c-3.55,1.13-6.96,1.34-9.99,0.52c0,0.08,0.01,0.16,0.01,0.24c-0.06,3.81-3.2,6.85-7.01,6.79 c-3.36-0.05-6.12-2.5-6.68-5.69c-4.79,3.97-26.73,22.15-41.61,34.47c-6.68,5.54-11.94,9.89-13.58,11.25 c-4.44,3.67-1.41,8.42,3.96,5.33c2.4-1.38,8.58-5.03,15.7-9.22c11.51-6.78,25.47-15,29.92-17.44c7.2-3.95,4.86-4.83,5.71-9.16 c0.49-2.52,1.35-4.77,2.53-6.69l-3.25,72.38c0,0,3.61,0.4,7.19,0.43c5.64,0.05,6.58-0.54,6.6-0.4 c-0.23-8.5-2.15-59.92-2.74-75.41c5.7,2.32,31.65,12.89,49.25,20.06c7.91,3.22,14.14,5.76,16.07,6.55 C532.47,373.9,535.22,368.97,530.05,365.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD7C5",
    d: "M462.11,332.7c-1.36-9.56-4.79-33.63-7.2-50.57c-1.22-8.59-2.19-15.35-2.49-17.45 c-0.81-5.7-6.44-5.61-6.62,0.59c-0.08,2.77-0.2,9.94-0.35,18.21c-0.24,13.35-0.53,29.56-0.78,34.62 c-0.4,8.21,1.58,6.67,4.82,9.66c1.81,1.67,3.26,3.49,4.27,5.41c1.23-1.05,2.84-1.68,4.59-1.66 C459.74,331.54,461.03,331.97,462.11,332.7z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 567.2678,
    cy: 393.3435,
    r: 36.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1616,
    style: {
      stopColor: "#FAFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    style: {
      stopColor: "#EDF6FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    style: {
      stopColor: "#D8ECF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4714,
    style: {
      stopColor: "#CDE9F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5882,
    style: {
      stopColor: "#B0E1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    style: {
      stopColor: "#80D3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#3FC1E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M589.82,396.5c-7.02-15.71-22.14-48.51-22.54-49.39l0-0.02c0,0,0,0.01,0,0.01c0,0,0-0.01,0-0.01 l0,0.02c-0.41,0.88-15.52,33.68-22.54,49.39c-7.86,17.58-2.98,41.63,20.44,43.02l0,0.01c0.54,0.03,1.06,0.04,1.58,0.05 c0.18,0,0.35,0,0.53,0c0.18,0,0.35,0,0.53,0c0.52-0.01,1.05-0.02,1.58-0.05l0-0.01C592.79,438.14,597.67,414.08,589.82,396.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M634.76,331.33l-0.2,11.93c-8.16-10.02-18.26-17.96-30.04-23.61c-43.69-20.98-96.31-2.5-117.29,41.19 c-12.76,26.56-11.39,57.58,3.66,82.96l2.55-1.51c-14.54-24.53-15.87-54.49-3.54-80.16c20.27-42.22,71.12-60.08,113.34-39.8 c11.39,5.47,21.14,13.14,29.03,22.83l-11.16-0.48l-0.13,2.96l16.45,0.7l0.28-16.94L634.76,331.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M641.28,352.7l-2.52,1.55c15.26,24.77,16.87,55.2,4.29,81.4c-9.82,20.45-27.02,35.86-48.43,43.37 c-21.41,7.52-44.46,6.25-64.91-3.57c-11.4-5.47-21.17-13.17-29.07-22.88l10.85,2.63l0.7-2.88l-16-3.87l-3.55,16.57l2.89,0.62 l2.49-11.6c8.23,10.24,18.46,18.35,30.41,24.09c12.06,5.79,24.99,8.71,37.98,8.71c9.81,0,19.66-1.66,29.19-5.01 c22.15-7.78,39.95-23.72,50.11-44.89C658.73,409.83,657.07,378.34,641.28,352.7z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M743.95,344.61c-8.27-3.38-18.67-6.31-31.7-8.48c-0.63-0.11-1.16,0.49-0.97,1.1l8.05,26.76 c0.07,0.22,0.04,0.46-0.07,0.67l-8.54,15.41c-0.24,0.43-0.07,0.97,0.38,1.19c10.61,5.15,21.48,11.88,31.11,20.61 c0.4,0.36,1.03,0.28,1.32-0.19l10.12-16.67c0.12-0.19,0.15-0.43,0.1-0.65l-9.26-39.15C744.4,344.94,744.21,344.72,743.95,344.61 z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M713.86,419.41c-11.72,3.7-25.68,7.27-42.29,10.6c-1.1,0.22-2.03,0.97-2.47,2l-33.77,79 c-0.43,1.01-0.35,2.17,0.22,3.11l38.8,63.98c0.64,1.05,1.78,1.68,3.01,1.64c7.01-0.2,31.27-2.08,53.65-17.86 c1.48-1.05,1.87-3.09,0.89-4.62l-36.38-56.7c-0.54-0.85-0.68-1.89-0.39-2.85l22.99-74.04 C718.94,421.05,716.47,418.58,713.86,419.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M767.3,502.18c0.49,0.84,1.76,0.65,1.98-0.3c2.3-9.8,3.76-20.83,4.13-33.25c0,0,1.02-69.34,1.54-86.92 c0.29-9.77-3.33-18.44-10.68-24.61c0,0,13.06,11.43,5.82,26.51c-0.49,1.02-0.67,1.99-0.72,2.31l-14.68,92.78 c-0.15,0.97,0.03,1.97,0.53,2.82L767.3,502.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M767.16,507.13l-15-25.67c-0.28-0.48-0.39-1.04-0.3-1.59l12.93-81.69c0.35-2.24-2.31-3.7-3.98-2.18 c-7.13,6.48-18.41,13.18-35.74,19.59c-0.7,0.26-1.25,0.83-1.47,1.55l-25.01,80.54c-0.21,0.68-0.11,1.42,0.27,2.02l35.88,55.91 c0.79,1.24,2.51,1.49,3.62,0.52c11.93-10.43,22.67-25.45,29.06-47.09C767.58,508.39,767.49,507.7,767.16,507.13z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#027084",
    d: "M764.29,357.11c0.49,0.44,12.9,11.71,5.8,26.49c-0.49,1.02-0.67,1.99-0.72,2.31l-6.66,42.07 c6.48,12.27,10.48,26.86,10.56,44.2c0.01-0.29,0.03-0.57,0.04-0.86c0.14-8.36,0.44-26.48,0.76-44.55 c0.3-18.13,0.65-37.03,0.89-45.08c0.12-4.09-0.45-7.98-1.69-11.58c-1.4-3.82-3.81-7.89-7.74-11.92 C765.12,357.84,764.71,357.47,764.29,357.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M764.29,357.11c-0.01-0.01-0.02-0.01-0.02-0.01C764.28,357.1,764.28,357.11,764.29,357.11z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#027084",
    d: "M760.8,396c-3.62,3.29-8.32,6.64-14.33,9.98c5.31,5.39,10.13,11.47,14.18,18.32l4.14-26.12 C765.14,395.94,762.48,394.48,760.8,396z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.9,
    fill: "#C16032",
    points: "568.96,223.53 571.45,183.92 571.45,223.61 576.42,184.24 573.93,223.85 581.36,184.86 576.39,224.24 586.26,185.79 578.82,224.78 591.08,187.03 581.21,225.48 595.82,188.57 583.55,226.32 600.45,190.41 585.84,227.31 604.96,192.53 588.06,228.44 609.32,194.93 590.2,229.71 613.53,197.6 592.26,231.11 617.56,200.53 594.23,232.63 621.4,203.7 596.1,234.28 625.03,207.11 597.86,236.04 628.44,210.74 599.51,237.91 631.62,214.58 601.03,239.88 634.54,218.61 602.43,241.94 637.21,222.82 603.7,244.08 639.61,227.18 604.83,246.3 641.74,231.69 605.82,248.59 643.57,236.32 606.67,250.93 645.11,241.06 607.36,253.32 646.35,245.89 607.9,255.76 647.28,250.78 608.29,258.22 647.91,255.72 608.53,260.7 648.22,260.69 608.61,263.19 648.22,265.68 608.53,265.67 647.91,270.65 608.29,268.15 647.28,275.59 607.9,270.61 646.35,280.48 607.36,273.05 645.11,285.31 606.67,275.44 643.57,290.05 605.82,277.78 641.74,294.68 604.83,280.07 639.61,299.19 603.7,282.29 637.21,303.55 602.43,284.43 634.54,307.76 601.03,286.49 631.62,311.79 599.51,288.46 628.44,315.63 597.86,290.33 625.03,319.26 596.1,292.09 621.4,322.67 594.23,293.74 617.56,325.85 592.26,295.26 613.53,328.77 590.2,296.66 609.32,331.44 588.06,297.93 604.96,333.84 585.84,299.06 600.45,335.96 583.55,300.05 595.82,337.8 581.21,300.89 591.08,339.34 578.82,301.59 586.26,340.58 576.39,302.13 581.36,341.51 573.93,302.52 576.42,342.13 571.45,302.76 571.45,342.45 568.96,302.84 566.47,342.45 566.47,302.76 561.49,342.13 563.99,302.52 556.55,341.51 561.53,302.13 551.66,340.58 559.1,301.59 546.83,339.34 556.7,300.89 542.09,337.8 554.36,300.05 537.46,335.96 552.07,299.06 532.95,333.84 549.86,297.93 528.59,331.44 547.71,296.66 524.38,328.77 545.65,295.26 520.35,325.85 543.68,293.74 516.51,322.67 541.81,292.09 512.88,319.26 540.05,290.33 509.47,315.63 538.41,288.46 506.3,311.79 536.88,286.49 503.37,307.76 535.48,284.43 500.7,303.55 534.21,282.29 498.3,299.19 533.08,280.07 496.18,294.68 532.09,277.78 494.34,290.05 531.25,275.44 492.8,285.31 530.55,273.05 491.57,280.48 530.01,270.61 490.63,275.59 529.62,268.15 490.01,270.65 529.38,265.67 489.7,265.68 529.31,263.19 489.7,260.69 529.38,260.7 490.01,255.72 529.62,258.22 490.63,250.78 530.01,255.76 491.57,245.89 530.55,253.32 492.8,241.06 531.25,250.93 494.34,236.32 532.09,248.59 496.18,231.69 533.08,246.3 498.3,227.18 534.21,244.08 500.7,222.82 535.48,241.94 503.37,218.61 536.88,239.88 506.3,214.58 538.41,237.91 509.47,210.74 540.05,236.04 512.88,207.11 541.81,234.28 516.51,203.7 543.68,232.63 520.35,200.53 545.65,231.11 524.38,197.6 547.71,229.71 528.59,194.93 549.86,228.44 532.95,192.53 552.07,227.31 537.46,190.41 554.36,226.32 542.09,188.57 556.7,225.48 546.83,187.03 559.1,224.78 551.66,185.79 561.53,224.24 556.55,184.86 563.99,223.85 561.49,184.24 566.47,223.61 566.47,183.92  "
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEE4",
    d: "M458.13,345.31c3.81,0.06,6.95-2.98,7.01-6.79c0-0.08-0.01-0.16-0.01-0.24c-0.04-2.32-1.22-4.36-3.02-5.58 c-1.07-0.73-2.36-1.17-3.76-1.19c-1.75-0.03-3.35,0.6-4.59,1.66c-1.45,1.24-2.39,3.07-2.42,5.13c-0.01,0.45,0.03,0.89,0.11,1.32 C452.02,342.81,454.77,345.26,458.13,345.31z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1524.95,
    y: 168.06,
    opacity: 0.9,
    fill: "#C16032",
    width: 455.28,
    height: 792.27
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M210.86,268.85c0.26-0.01,0.51-0.03,0.76-0.04c0.3-0.24,0.63-0.49,0.96-0.75 C211.88,268.34,211.13,268.53,210.86,268.85z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M232.05,266.02c0.07,0.01,0.14,0.01,0.21,0.01C232.19,266.03,232.12,266.03,232.05,266.02z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M223.1,261.99c0.27-0.04,0.52-0.06,0.78-0.07c-0.01,0-0.03,0-0.04-0.01c-1.77-0.28-2.38,0.18-2.93,0.79 C221.71,262.34,222.46,262.09,223.1,261.99z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M230.29,264.2c0.02,0.02,0.03,0.04,0.05,0.06C230.33,264.24,230.31,264.22,230.29,264.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M231.04,265.71c0,0.02,0,0.04,0,0.05c0-0.02,0.01-0.03,0.03-0.03 C231.06,265.73,231.05,265.72,231.04,265.71C231.04,265.72,231.04,265.72,231.04,265.71z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M228.33,263.19c0.8,0.17,1.36,0.47,1.75,0.81c-0.56-0.49-1.4-0.91-2.59-1.29 C227.79,262.87,228.07,263.02,228.33,263.19z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M214.95,276.2c1.22-0.22,3.12-0.57,5.01-0.93c0.01-0.3,0-0.59,0-0.88c-0.06-0.01-0.11-0.01-0.17-0.02 c-2.63,0.81-5.01,1.6-6.15,2.07C213.64,276.44,214.15,276.35,214.95,276.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M215.7,265.77c-0.48,0.27-0.93,0.59-1.35,0.96C214.78,266.41,215.23,266.09,215.7,265.77z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M62.73,493.98l-0.12-0.01c-0.26-0.95-0.5-1.88-0.72-2.79c-3-9.7-4.04-8.48-5.59-6.23l-6,7.82L62.73,493.98 L62.73,493.98z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M214.34,274.03c-0.53,0.62-0.83,1.03-0.83,1.03L214.34,274.03z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M227.7,264.55c-1.11,0.41-2.91,2.87-3.9,8.62c-0.27,1.6-0.48,3.47-0.59,5.61c0.04,0.3,0.1,0.6,0.19,0.88 c-0.08-0.04-0.15-0.07-0.23-0.11c-0.03,0.74-0.05,1.5-0.06,2.3c-0.09,12.13,3.13,21.64,6.13,5.65 C232.23,271.52,230.87,263.39,227.7,264.55z M225.26,280.74C225.26,280.74,225.26,280.74,225.26,280.74l0.07,0.01 C225.33,280.74,225.3,280.74,225.26,280.74z M225.42,280.45c0.1-0.32,0.18-0.64,0.24-0.97 C225.57,279.91,225.48,280.24,225.42,280.45z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M230.57,264.54c-0.02-0.03-0.05-0.06-0.07-0.1C230.53,264.47,230.55,264.5,230.57,264.54z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M236.08,638.28C236.11,638.29,236.09,638.28,236.08,638.28L236.08,638.28z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M239.37,666.19c0.07,0.02,0.21,0.05,0.4,0.09C239.56,666.24,239.44,666.21,239.37,666.19z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M230.88,265.11c-0.01-0.03-0.03-0.06-0.04-0.09C230.86,265.05,230.87,265.08,230.88,265.11z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M231.86,265.99c-0.05-0.01-0.1-0.02-0.14-0.03C231.76,265.98,231.81,265.98,231.86,265.99z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M230.77,264.86c-0.03-0.06-0.06-0.11-0.1-0.17C230.71,264.75,230.74,264.81,230.77,264.86z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M51.64,750.95c0.01-0.08,0.02-0.17,0.02-0.25C51.65,750.79,51.65,750.87,51.64,750.95z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M100.86,733.64c-12.39-3.15-23.03-7.11-31.85-11.12c0,0,0,0,0,0.01 C76.6,726.09,87.29,730.27,100.86,733.64z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M58.54,869.46C58.54,869.46,58.54,869.46,58.54,869.46c1.28,16.42-0.65,68.8,0.61,79.42c0,0,0,0,0,0 C57.98,936.85,59.9,883.8,58.54,869.46z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M51.43,753.36c-1.3,15.87-0.47,31.23,1.1,48.64C50.66,776.1,50.72,762.83,51.43,753.36z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M162.33,739.87c-14.09,2.78-86.73,19.26-95.24,45.05c-0.05,23.8,0.96,51.78,4.46,78.83 c7.37,56.98,5.81,124.08,6.16,131.32c0,0,0,0,0,0c25.19,17.38,86.32,14.86,129.68,16.66c10.68,0.45,54.28-1.94,58.86-22.53 c12.23-54.89-7.64-171.19-24.73-252.54l-63.14,2.05C172.87,739.29,167.53,739.67,162.33,739.87z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M58.04,717.39c-0.13,0.46-0.25,0.91-0.37,1.37c0.21-0.6,0.4-1.05,0.56-1.3 C58.17,717.44,58.1,717.41,58.04,717.39z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M190.06,327.8c-0.26-0.16-0.52-0.33-0.78-0.49C189.54,327.47,189.8,327.63,190.06,327.8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M195.92,331.53c-0.95-0.61-1.92-1.22-2.91-1.85C194,330.31,194.97,330.92,195.92,331.53z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M199.57,333.86c-1.04-0.66-2.1-1.34-3.2-2.04C197.47,332.52,198.53,333.19,199.57,333.86z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M238.98,292.8c-2.68-4.53-3.86-6.21-4.86-9.23c-0.06,0.25-0.1,0.34-0.1,0.34s0.68-3.06,0.11-4.93 c-0.08-0.25-0.47-0.6-0.57-0.88c-0.34-0.98-2.54-2.94-2.68-1.96c-0.4,2.76,0.7,17.05-4.82,19.45 c-5.17,2.25-5.28-11.29-4.84-16.87c-1.37-0.49-4.14-1.48-5.18-1.75c-0.36-0.24-0.73-0.5-1.1-0.77 c-0.81,0.15-1.31,0.24-1.31,0.24c1.14-0.47,3.52-1.26,6.15-2.07c-0.93-0.12-2.51-0.25-5.1-0.33c-0.38,0.32-0.77,0.66-1.17,1.02 c0,0,0.3-0.42,0.83-1.03c-0.49-0.01-1.03-0.03-1.59-0.04l1.56-4.36c2.72-0.26,4.78-0.63,5.88-0.69 c0.14-0.54,1.16-0.86,1.56-1.24c1.91-1.82,3.12-3.83,5.49-3.6c0.28,0.03,2.94,0.13,3,0.2c0.02,0.02,0.03,0.04,0.05,0.06 c0.06,0.06,0.11,0.12,0.16,0.19c0.02,0.03,0.05,0.06,0.07,0.1c0.04,0.05,0.07,0.1,0.1,0.16c0.03,0.06,0.07,0.11,0.1,0.17 c0.03,0.05,0.05,0.11,0.08,0.16c0.01,0.03,0.03,0.06,0.04,0.09c0.1,0.27,0.14,0.49,0.15,0.6c0,0,0,0,0,0 c0.01,0,0.02,0.01,0.04,0.02c0.03,0,0.06,0.01,0.12,0.03c0.12,0.05,0.62,0.22,0.67,0.23c0.06,0.01,0.33,0.03,0.4,0.03 c0.13-0.01,2.37,0.2,1.79-2.06c0.15-1.54,1.38-3.43,1.47-4.94c-0.06-3.07,3.15-9.47,1.53-15.15 c-1.09-3.84-1.53-13.14-8.47-10.87c0,0,0.03-0.01,0.08-0.03c-0.03-0.08-0.07-0.15-0.1-0.23c-2.53,2.99-41.81-8.05-41.81-8.05 l-59.51,89.87l-1.26,30.56c-6.17,2.91-12.16,3.9-12.42,3.94c0.09,2.79-0.18,6.2-1.46,9.4c-1.62,4.04-2.46,5.78-5.81,6.54 c0,0,0.01,0,0.01,0.01c0.02,0,0.05-0.01,0.07-0.01c0.08,0.06,0.06,0.06-0.05,0.02c-4.44,2.24-8.72,3.8-11.72,4.35l6.75,3.53 c27.93,23.44,67.13,91.49,67.13,91.49c11.38-17.97,15.15-58.71,16.39-72.41c0.39-4.31-1.26-7.64-1.26-7.64 c0.02,0.01,0.04,0.01,0.05,0.02c-0.05-0.29-0.08-0.6-0.1-0.95c0.08-2.22-0.34-5.47-0.23-8.34c1.64-3.09-6.6-22.25,38.67-17.56 c11.14-0.31,10.92-7.67,9.86-12.95c-1.07-5.35,1.42-5.63,2.35-8.73c-4.84-4.43-9.88-9.89-10.52-10.73 c1.89-1.25,12.43-5.5,12.83-9.94c0.05,0.07,0.1,0.13,0.15,0.2c-2.38-5.2,2.21-5.37,6-7.61 C248.02,304.7,245.24,303.39,238.98,292.8z M231.76,306.54c0.04-0.44,0.09-0.72,0.09-0.72 C231.81,306.07,231.78,306.31,231.76,306.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M106.26,365.12L106.26,365.12c-0.35,0.06-0.7,0.11-1.07,0.16 C105.56,365.23,105.92,365.18,106.26,365.12z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M216.7,207.09c-12.62-13.92-29.94-18.14-58.4-15.01c0.28-0.04,0.55-0.09,0.83-0.12 c0,0-6.69-0.22-11.65,1.33c-0.12,0.11-0.23,0.19-0.35,0.27l0.21,0l-2.57,0.47l0.01-0.47c-0.1-0.05-0.21-0.11-0.32-0.17 c-0.02-0.01-0.03-0.02-0.05-0.03c-0.12-0.07-0.27-0.13-0.43-0.18c-3.35-0.16-6.41,0.07-9.21,0.61 c-3.97,0.99-8.99,3.03-14.16,6.64c-0.67,0.47-1.34,0.95-2.01,1.47c-2.64-1.43-6.27-2.5-10.95-3.59 c-21.86-5.09-34.11,9.3-38.47,20.98c-4.19,11.24-3.75,21.25-0.41,29.06c1.43,5.64,3.82,11.97,7.53,19.05 c0,0-0.96-4.45-1.73-10.28c4.19,4.33,9.61,7.16,15.55,8.03c0.19,9.42,1.91,18.08,4.79,24.73c0.3,0.69,0.61,1.37,0.93,2.02 c6.53,12.99,10.67,24.99,13.28,34.62c1.38,4.82,2.52,9.74,3.25,14.53c0.13,0.78,0.25,1.49,0.35,2.16l0,0 c0,0,0.66,2.51,0.77,5.95c0.27-0.04,6.25-1.03,12.42-3.94c7.46-3.51,15.17-9.83,13.34-20.66c-0.55-0.11-0.14-5.1-0.71-5.24 c-20.04-4.9-16.89-23.11-16.41-23.4c0.6-12.33,46.59-11.04,46.28,2.32c-0.04,1.63,2.98,2.44,2.65,3.98 c4.31-4.17,10.99-9.94,21.26-17.51c0.94-0.69,1.86-1.41,2.77-2.14c-6.07,8.34-10.45,16.93-11.83,19.77 c1.42-1.69,4.44-5.11,10.55-11.84c5.05-5.56,9.1-11.18,12.42-16.59c1.03-1.69,1.99-3.35,2.89-4.99c0.07-0.12,0.13-0.24,0.2-0.36 c10.55-12.59,17.54-26.55,19.23-35.81c0.03,0.07,0.07,0.15,0.1,0.23c1.04-0.32,11.61-2.84,5.56,29.82c0,0,1.75-1.1,1.74,3.34 C248.13,238.75,238.05,210.87,216.7,207.09z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#99857D",
    d: "M113.52,349.18c0.09,2.79-0.18,6.2-1.46,9.4c-1.63,4.08-2.47,5.82-5.91,6.57 c0.06-0.01,0.12-0.02,0.18-0.03c1.31,0.92,2.63,1.94,3.95,3.05c10.09-3.66,15.55-12.77,15.66-22.93 C119.77,348.14,113.78,349.13,113.52,349.18z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M225.26,280.74c0.04,0,0.07,0.01,0.07,0.01L225.26,280.74C225.26,280.74,225.26,280.74,225.26,280.74z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M223.21,278.79c-0.01,0.26-0.03,0.5-0.04,0.76c0.08,0.04,0.15,0.07,0.23,0.11 C223.31,279.39,223.25,279.09,223.21,278.79z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M225.66,279.49c-0.06,0.33-0.14,0.65-0.24,0.97C225.48,280.24,225.57,279.91,225.66,279.49z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M216.05,276.97c1.03,0.26,2.31,0.63,3.68,1.13c0.03-0.41,0.07-0.79,0.11-1.09 c0.07-0.59,0.11-1.17,0.12-1.73c-1.89,0.36-3.79,0.71-5.01,0.93C215.32,276.47,215.69,276.73,216.05,276.97z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M214.69,274.04c-0.11,0-0.23-0.01-0.34-0.01l-0.83,1.03C213.91,274.69,214.3,274.36,214.69,274.04z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M231.85,305.81c0,0-0.05,0.29-0.09,0.72C231.78,306.31,231.81,306.07,231.85,305.81z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#AB7D62",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M231.76,306.54 c0,0.03-0.01,0.06-0.01,0.09"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M230.65,323.51c-1.58,0.46-2.86-0.38-4.28-0.36c-0.02,0.06-1.11,1.53-1.12,1.59 c-0.13,0.9,2.46,2.66,4,3.49c0.36,0.19,0.57-0.53,0.85-0.39C228.55,326.92,228.07,325.04,230.65,323.51z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#669694",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M242.37,666.89 c0.02,0.01,0.05,0.01,0.07,0.02"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#669694",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M242.74,666.98 c0.04,0.01,0.08,0.02,0.12,0.03"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M50.84,712.91c-5.81-3.95-12.75-9-12.75-9S42.43,707.75,50.84,712.91z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M38.59,700.49c0.08-0.49,0.16-1.02,0.26-1.59C38.76,699.43,38.67,699.96,38.59,700.49z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M9.79,567.53c0.29-1.15,0.58-2.31,0.85-3.47C10.39,564.97,10.1,566.18,9.79,567.53z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M16.18,629.63c-0.89,0.41-1.93,0.8-3.14,1.14C14.18,630.47,15.23,630.09,16.18,629.63z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M14.32,546.08c0,0,1.5-1.56,3.8-4.1C16.5,543.61,15.15,545.03,14.32,546.08z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-62.48,600.66c-0.29-0.68-0.56-1.38-0.82-2.09C-63.04,599.28-62.77,599.97-62.48,600.66z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M-62.43,600.76c5.07,12,15.13,22.13,33.43,26.38c8.41,1.95,16.6,3.51,23.89,4.25 c-11.93-1.36-24.8-4.96-30.79-6.88C-46.06,621.25-56.7,613.91-62.43,600.76z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M21.34,622.19c0.06,0.5,0.17,1.61-0.34,2.92c0.38-0.77,0.64-1.62,0.8-2.55 c-0.11-0.13-0.21-0.27-0.31-0.41C21.44,622.17,21.39,622.18,21.34,622.19z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#659896",
    points: "62.73,493.98 72.68,494.95 62.73,493.98  "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M71.54,863.75c-3.5-27.04-4.5-55.02-4.46-78.83c8.51-25.8,81.15-42.27,95.24-45.05 c-23.71,0.92-44.27-1.86-61.47-6.23c-13.57-3.37-24.26-7.55-31.84-11.11c0,0,0,0,0-0.01c-4.01-1.82-7.65-3.65-10.9-5.41 c-0.03,0.09-0.05,0.18-0.07,0.27c0.06,0.03,0.13,0.06,0.18,0.07c-0.16,0.25-0.34,0.7-0.56,1.3c-3.13,11.36-5.02,21.79-6,31.94 c-0.01,0.08-0.02,0.17-0.02,0.25c-0.08,0.8-0.14,1.61-0.2,2.41c-0.72,9.47-0.77,22.74,1.1,48.64 c1.5,16.64,3.66,35.14,5.28,57.79c0.24,3.34,0.48,6.56,0.72,9.67c0,0,0,0,0,0c1.36,14.34-0.56,67.39,0.61,79.42c0,0,0,0,0,0 c3.23,27.45,5.95,37.15,5.95,37.15s4.7,3.57,12.61,9.03c0,0,0,0,0,0C77.35,987.83,78.91,920.73,71.54,863.75z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#254354",
    d: "M71.54,863.75c-3.5-27.04-4.5-55.02-4.46-78.83c8.51-25.8,81.15-42.27,95.24-45.05 c-23.71,0.92-44.27-1.86-61.47-6.23c-13.57-3.37-24.26-7.55-31.84-11.11c0,0,0,0,0-0.01c-4.01-1.82-7.65-3.65-10.9-5.41 c-0.03,0.09-0.05,0.18-0.07,0.27c0.06,0.03,0.13,0.06,0.18,0.07c-0.16,0.25-0.34,0.7-0.56,1.3c-3.13,11.36-5.02,21.79-6,31.94 c-0.01,0.08-0.02,0.17-0.02,0.25c-0.08,0.8-0.14,1.61-0.2,2.41c-0.72,9.47-0.77,22.74,1.1,48.64 c1.5,16.64,3.66,35.14,5.28,57.79c0.24,3.34,0.48,6.56,0.72,9.67c0,0,0,0,0,0c1.36,14.34-0.56,67.39,0.61,79.42c0,0,0,0,0,0 c3.23,27.45,5.95,37.15,5.95,37.15s4.7,3.57,12.61,9.03c0,0,0,0,0,0C77.35,987.83,78.91,920.73,71.54,863.75z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M162.33,739.87c0.36-0.07,0.7-0.14,0.98-0.19c-24.91,0.98-45.84-1.91-62.45-6.04 C118.05,738.01,138.61,740.79,162.33,739.87z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M69.01,722.53c-8.68-13.66-11.74-34.21-12.67-50.86l-9.28-4.42c-3.55,11.09-6.52,21.72-8.21,31.66 c-0.1,0.58-0.18,1.11-0.26,1.59c-0.18,1.15-0.36,2.29-0.5,3.42c0,0,6.94,5.05,12.75,9c2.16,1.33,4.58,2.74,7.28,4.21 C61.36,718.88,65,720.7,69.01,722.53z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M69.01,722.53c-8.68-13.66-11.74-34.21-12.67-50.86l-9.28-4.42c-3.55,11.09-6.52,21.72-8.21,31.66 c-0.1,0.58-0.18,1.11-0.26,1.59c-0.18,1.15-0.36,2.29-0.5,3.42c0,0,6.94,5.05,12.75,9c2.16,1.33,4.58,2.74,7.28,4.21 C61.36,718.88,65,720.7,69.01,722.53z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "56.34,671.66 56.34,671.66 46.55,667 46.55,667 47.06,667.24  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M6.96,576.97c0.02-0.14,0.04-0.29,0.06-0.43C7,576.68,6.98,576.82,6.96,576.97 c0.26-0.2,0.55-0.39,0.85-0.57c0.46-2.38,0.88-4.56,1.02-4.96c-0.02-0.15,0.04-0.45,0.16-0.91c0.27-0.98,0.54-1.98,0.8-3 c0.31-1.35,0.6-2.57,0.85-3.47c2.16-9.09,3.67-17.98,3.67-17.98c0.83-1.05,2.18-2.48,3.8-4.1c0.39-0.43,0.79-0.87,1.22-1.35 l-0.52-3.58c-4.26,2.89-8.42,4.77-11.59,3.47c-10.32-4.24-5.02,17.58-3.95,37.16c0.79,0.25,1.39,0.63,1.85,1.06 C5.61,578.14,6.2,577.55,6.96,576.97z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M6.96,576.97c0.02-0.14,0.04-0.29,0.06-0.43C7,576.68,6.98,576.82,6.96,576.97 c0.26-0.2,0.55-0.39,0.85-0.57c0.46-2.38,0.88-4.56,1.02-4.96c-0.02-0.15,0.04-0.45,0.16-0.91c0.27-0.98,0.54-1.98,0.8-3 c0.31-1.35,0.6-2.57,0.85-3.47c2.16-9.09,3.67-17.98,3.67-17.98c0.83-1.05,2.18-2.48,3.8-4.1c0.39-0.43,0.79-0.87,1.22-1.35 l-0.52-3.58c-4.26,2.89-8.42,4.77-11.59,3.47c-10.32-4.24-5.02,17.58-3.95,37.16c0.79,0.25,1.39,0.63,1.85,1.06 C5.61,578.14,6.2,577.55,6.96,576.97z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "19.36,540.77 19.36,540.77 18.82,537.06 18.82,537.06 19.34,540.64  "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M278.53,518.2c-15.01-90.06-30.73-103.19-45.44-114.03c0,0-11.69-7.09-49.46-19.68 c-0.02-0.01-0.04-0.01-0.05-0.02c0,0-0.12,2.63-0.51,6.94c-1.23,13.7-5.17,44.44-16.55,62.41c0,0-28.29-62.22-56.22-85.66 c-1.32-1.11-2.63-2.13-3.95-3.05c-0.06,0.01-0.12,0.02-0.18,0.03c-0.95,0.21-2.08,0.34-3.49,0.42c0,0,0,0,0,0 c-2.35,0.23-4.94,0.37-7.74,0.48c-3.75,0.15-7.86,0.23-12.17,0.37c-23.64,0.75-53.61,3.15-67.18,26.32 c-18.91,32.3-8.73,29.46-34.92,73.11c-6.73,11.22-12.2,21.48-16.53,30.26c-2.28,2.68-5.94,7.44-10.25,14.77 c0,0,0,0.01-0.01,0.01c-5.99,12.03-12.51,35.01-6.82,50.03c0.17,0.26,0.35,0.63,0.53,1.15c0.07,0.2,0.14,0.42,0.21,0.62 c0.61,1.31,1.31,2.55,2.14,3.69c8.09,11.18,16.36,39.65,25,48.05c2.65-1.8,5.03-17.47,6.81-20c3.44-11.27,9.78-14.9,12.53-15.81 c4.36-1.45,7.18-1.52,9-0.94c-1.07-19.58-6.38-41.4,3.95-37.16c3.16,1.3,11.39,0.19,15.64-2.7l-6.65-40.49 c-0.69-4.31-1.14-4.6,1.9-3.36l32.19-1.22l6-7.82c1.55-2.25,2.59-3.47,5.59,6.23c0.26,0.85,0.54,1.78,0.83,2.8l9.68,0.95 c0.08,0.95,0.16,1.89,0.27,2.81l19.79,5.74c2.95,1.2,2.84,2.56,2.97,6.53l22.56,184.87c0.13,4.02-1.93,1.85-4.93,0l-60.24-30.23 c0.93,16.65,5.58,47.71,14.26,61.38c8.82,4.01,19.93,8.73,32.32,11.88c16.61,4.12,38.21,5.15,63.91,1.77 c-0.28,0.05,1.35,3.7,0.98,3.77c5.2-0.2,8.58-4.16,14.08-4.74l63.14-2.05l9.72-0.32c0.87-14.72-15.17-98.08-15.17-98.08 c41.34,31.5,49.58-11.8,51.18-24.61C290.2,590.05,292.41,601.53,278.53,518.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M72.68,494.95v2.79c-2.79-24.55,5.02-63.73,3.26-60.8c-2.18,3.64-5.82,29.1-8.73,15.28 c-2.91-13.82-5.09-18.19-5.09-18.19c0,24.72-5.26,36.23-0.23,57.13c0,0.01,0,0.01,0,0.02c0.26,0.85,1.8,5.34,2.09,6.36 L72.68,494.95z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#161616",
    points: "73.17,495 73.17,495 72.68,494.95  "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M21.34,622.19c-8.45,1.8-17.21-2.15-22.17-8.1c-3.67-4.4-5.06-7.88-5.57-9.55 c-1.42-4.07-1.64-8.21-0.27-11.71c3.32-8.48,7.47-9.92,9.82-9.97c0.04-0.14,0.06-0.3,0.11-0.43c0.06-0.15,0.12-0.31,0.18-0.47 c-0.03-1.4-0.08-2.82-0.16-4.26c-1.82-0.58-4.63-0.51-9,0.94c-2.75,0.92-9.09,4.54-12.53,15.81c-1.78,2.54-4.16,18.2-6.81,20 c-8.65-8.4-16.92-36.87-25-48.05c-0.83-1.15-1.53-2.39-2.14-3.69c-0.07-0.21-0.14-0.42-0.21-0.62 c-0.18-0.51-0.36-0.88-0.53-1.15c-5.69-15.02,0.83-38.01,6.82-50.03c0,0,0-0.01,0.01-0.01c-4.53,7.71-9.79,18.25-14.93,32.22 c-4.05,11.01-9.61,35.43-2.24,55.48c0.27,0.71,0.53,1.41,0.82,2.09c0.01,0.03,0.03,0.07,0.04,0.1 c5.73,13.15,16.38,20.48,26.52,23.74c6,1.93,18.86,5.52,30.79,6.88c7.17,0.73,13.45,0.66,18.15-0.61 c1.21-0.34,2.25-0.73,3.14-1.14c2.21-1.06,3.86-2.54,4.83-4.52C21.51,623.8,21.4,622.69,21.34,622.19z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M21.71,622.78c-8.45,1.8-17.67-2.52-22.63-8.48c-3.67-4.4-5.06-7.88-5.57-9.55 c-1.42-4.07-1.64-8.21-0.27-11.71c3.32-8.48,7.47-9.92,9.82-9.97c0.04-0.14,0.06-0.3,0.11-0.43c0.06-0.15,0.12-0.31,0.18-0.47 c-0.03-1.4-0.08-2.82-0.16-4.26c-1.82-0.58-4.63-0.51-9,0.94c-2.75,0.92-9.09,4.54-12.53,15.81c-1.78,2.54-4.16,18.2-6.81,20 c-8.65-8.4-16.92-36.87-25-48.05c-0.83-1.15-1.53-2.39-2.14-3.69c-0.07-0.21-0.14-0.42-0.21-0.62 c-0.18-0.51-0.36-0.88-0.53-1.15c-5.69-15.02,0.83-38.01,6.82-50.03c0,0,0-0.01,0.01-0.01c-4.53,7.71-9.79,18.25-14.93,32.22 c-4.05,11.01-9.61,35.43-2.24,55.48c0.27,0.71,0.53,1.41,0.82,2.09c0.01,0.03,0.03,0.07,0.04,0.1 c5.73,13.15,16.38,20.48,26.52,23.74c6,1.93,18.96,5.3,30.89,6.66c7.17,0.73,13.27,0.73,17.98-0.54 c1.21-0.34,2.3-0.72,3.18-1.13c2.21-1.06,3.9-2.4,4.86-4.38C21.41,624.02,21.77,623.28,21.71,622.78z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M5.13,578.75c-0.46-0.44-1.06-0.81-1.85-1.06c0.08,1.44,0.13,2.86,0.16,4.26 C3.82,580.95,4.28,579.84,5.13,578.75z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M144.2,195.79l2.7,0.01c0.15,0,0.3,0.02,0.45,0.06l-0.01-2.3l-0.21,0l-2.34,0.01l-0.5,0L144.2,195.79z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M149.1,271.27l-0.2-73.38c0-0.99-0.66-1.82-1.55-2.04c-0.14-0.04-0.29-0.06-0.45-0.06l-2.7-0.01l-0.08,0 c-1.11,0-2.01,0.94-2.01,2.1l-0.36,73.51c1.54-0.25,3.11-0.36,4.72-0.33C147.36,271.1,148.24,271.16,149.1,271.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.063,
    y1: 213.734,
    x2: 175.1208,
    y2: 235.6399,
    gradientTransform: "matrix(0.9997 0.0235 -0.0235 0.9997 -44.4344 5.4548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5156,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.5156
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7501,
    style: {
      stopColor: "#090909",
      stopOpacity: 0.7501
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#161615",
      stopOpacity: 0.9271
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M149.1,271.27l-0.2-73.38c0-0.99-0.66-1.82-1.55-2.04c-0.14-0.04-0.29-0.06-0.45-0.06l-2.7-0.01 l-0.08,0c-1.11,0-2.01,0.94-2.01,2.1l-0.36,73.51c1.54-0.25,3.11-0.36,4.72-0.33C147.36,271.1,148.24,271.16,149.1,271.27z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#99857D",
    d: "M138.57,319.34c0.57,0.14,0.16,5.13,0.71,5.24c7.04,1.41,12.44,0.51,16.55-1.47 c0.01,0,0.02-0.01,0.02-0.01c4.22-2.04,7.09-5.21,9.06-8.16c8.19,5.38,28.21,18.49,33.05,21.39c4.05,2.42,5.99,1.52,5.49-0.03 c-0.32-0.18-30.6-20.34-37.19-24.53c-0.52,0.68-36.29-8.13-44.51-13.56C121.39,303.28,122.73,315.47,138.57,319.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M120.08,296.26c0.01-0.22,0.02-0.44,0.03-0.65c-0.12-0.02-0.19-0.02-0.21-0.01 c-0.48,0.29-2.33,23.73,17.71,28.62c0.57,0.14,1.13,0.25,1.68,0.36c-0.55-0.11-0.14-5.1-0.71-5.24 c-15.84-3.87-17.19-16.06-16.82-21.14C120.67,297.48,120.06,296.83,120.08,296.26z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#41637C",
    cx: 145.79,
    cy: 296.8,
    r: 25.73
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.0678,
    y1: 296.8644,
    x2: 171.6636,
    y2: 296.8644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4913,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.7387
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.931
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M120.08,296.26c-0.12,4.9,1.14,9.51,3.42,13.46c0.62,1.08,1.32,2.11,2.08,3.08 c0.51,0.65,1.05,1.27,1.62,1.87c1.71,1.79,3.67,3.34,5.84,4.58c1.73,0.99,3.58,1.78,5.53,2.36c2.13,0.62,4.37,0.99,6.69,1.04 c0.49,0.01,0.98,0.01,1.47-0.01c0.15-0.01,0.31-0.02,0.46-0.02c0.34-0.02,0.67-0.04,1-0.07c0.18-0.02,0.35-0.03,0.52-0.05 c0.31-0.03,0.62-0.07,0.93-0.12c0.17-0.03,0.34-0.05,0.51-0.08c0.33-0.05,0.65-0.12,0.97-0.19c0.14-0.03,0.29-0.06,0.43-0.09 c0.46-0.1,0.91-0.21,1.35-0.34c0,0,0.01,0,0.01,0c0.46-0.13,0.92-0.28,1.37-0.43c0.11-0.04,0.21-0.08,0.32-0.12 c0.34-0.12,0.67-0.25,1.01-0.39c0.13-0.05,0.26-0.11,0.39-0.17c0.31-0.13,0.62-0.27,0.92-0.42c0.12-0.06,0.25-0.12,0.37-0.18 c0.32-0.16,0.64-0.33,0.96-0.5c0.09-0.05,0.18-0.1,0.27-0.15c0.83-0.47,1.63-0.98,2.4-1.54c0.04-0.03,0.07-0.06,0.11-0.08 c0.34-0.25,0.67-0.5,1-0.77c0.08-0.06,0.15-0.12,0.23-0.19c0.29-0.24,0.58-0.49,0.86-0.74c0.07-0.07,0.15-0.14,0.22-0.2 c0.29-0.27,0.58-0.55,0.86-0.83c0.05-0.05,0.1-0.1,0.15-0.15c0.67-0.69,1.31-1.42,1.9-2.19c-4.03-2.56-7.34-4.67-9.41-5.99 c-2.78,3.11-6.84,5.04-11.34,4.93c-8.13-0.19-14.57-6.94-14.38-15.08c0.19-8.13,6.94-14.57,15.08-14.38 c8.13,0.19,14.57,6.94,14.38,15.08c-0.05,2.14-0.56,4.15-1.42,5.96c2.2,1.48,5.46,3.66,9.27,6.17c1.21-2.19,2.12-4.58,2.65-7.1 c0.33-1.54,0.52-3.14,0.56-4.77c0.31-13.36-9.58-24.58-22.56-26.2c-0.86-0.11-1.74-0.17-2.63-0.19 c-1.61-0.04-3.19,0.08-4.72,0.33c-11.83,1.9-21.04,11.87-21.64,24.2h0C120.1,295.82,120.08,296.04,120.08,296.26z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M159.17,303.17c0.86-1.81,1.37-3.83,1.42-5.96c0.19-8.13-6.25-14.88-14.38-15.08 c-8.13-0.19-14.88,6.25-15.08,14.38c-0.19,8.13,6.25,14.88,14.38,15.08c4.49,0.11,8.56-1.82,11.34-4.93 C157.78,305.62,158.56,304.45,159.17,303.17z M145.71,303.67c-3.76-0.09-6.73-3.21-6.65-6.96c0.09-3.76,3.21-6.73,6.97-6.65 c3.76,0.09,6.73,3.21,6.65,6.96C152.58,300.78,149.46,303.76,145.71,303.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.8294,
    y1: 286.8571,
    x2: 182.3631,
    y2: 286.8571,
    gradientTransform: "matrix(0.9997 0.0235 -0.0235 0.9997 -44.4344 5.4548)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4913,
    style: {
      stopColor: "#020202",
      stopOpacity: 0.4913
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    style: {
      stopColor: "#0A0A09",
      stopOpacity: 0.7387
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    style: {
      stopColor: "#171716",
      stopOpacity: 0.931
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E1E1C"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M159.17,303.17c0.86-1.81,1.37-3.83,1.42-5.96c0.19-8.13-6.25-14.88-14.38-15.08 c-8.13-0.19-14.88,6.25-15.08,14.38c-0.19,8.13,6.25,14.88,14.38,15.08c4.49,0.11,8.56-1.82,11.34-4.93 C157.78,305.62,158.56,304.45,159.17,303.17z M145.71,303.67c-3.76-0.09-6.73-3.21-6.65-6.96c0.09-3.76,3.21-6.73,6.97-6.65 c3.76,0.09,6.73,3.21,6.65,6.96C152.58,300.78,149.46,303.76,145.71,303.67z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M152.67,297.02c0.09-3.76-2.89-6.88-6.65-6.96c-3.76-0.09-6.88,2.89-6.97,6.65 c-0.09,3.76,2.89,6.88,6.65,6.96C149.46,303.76,152.58,300.78,152.67,297.02z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M202.46,335.69c0.34,0.22,0.68,0.41,1,0.59l0,0C203.13,336.1,202.8,335.91,202.46,335.69z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M193.01,329.68c-0.97-0.62-1.96-1.25-2.95-1.88C191.06,328.43,192.04,329.06,193.01,329.68z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M202.46,335.69c-0.92-0.59-1.89-1.21-2.88-1.84C200.56,334.49,201.53,335.1,202.46,335.69z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M196.37,331.82c-0.15-0.1-0.3-0.19-0.45-0.29C196.07,331.63,196.22,331.72,196.37,331.82z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M166.27,312.65L166.27,312.65L166.27,312.65c6.58,4.19,15.04,9.57,23.02,14.65 C181.31,322.23,172.85,316.84,166.27,312.65z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M105.8,228.04c16.03-34.23,38.11-34.34,38.11-34.34l0.87-0.14c-0.02-0.01-0.35-0.19-0.37-0.2 c-0.12-0.07-0.27-0.13-0.43-0.18c-2.37-0.58-6.4-0.05-9.21,0.61c-3.97,0.99-8.99,3.03-14.16,6.64 C108.22,210.66,105.8,228.04,105.8,228.04z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#41637C",
    points: "156.86,306.66 166.27,312.65 168.44,309.34 159.17,303.17  "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M159.17,303.17c-0.61,1.28-1.39,2.45-2.32,3.49c2.07,1.32,5.38,3.43,9.41,5.99l0,0 c6.58,4.19,15.05,9.58,23.02,14.65c0.26,0.17,0.52,0.33,0.78,0.49c1,0.63,1.98,1.26,2.95,1.88c0.99,0.63,1.96,1.25,2.91,1.85 c0.15,0.1,0.3,0.19,0.45,0.29c1.1,0.7,2.16,1.38,3.2,2.04c0.99,0.63,1.96,1.25,2.88,1.84c0.34,0.22,0.68,0.41,1,0.59l0,0 c6.62,3.68,8.74-0.69,3.26-3.46c-3.17-1.6-5.27-3.06-13.29-7.77c-7.97-4.67-17.53-10.82-24.97-15.72 C164.63,306.83,161.37,304.65,159.17,303.17z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M29.5,618.12c0.03,0.41-0.05-0.13,0.84-0.84l-0.05-0.38C29.76,617.39,29.48,617.85,29.5,618.12z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M28.3,603.03l-0.06-0.43c-0.34,0.08-0.54,0.12-0.54,0.12C27.29,602.91,27.57,603.01,28.3,603.03z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M18.12,541.99c-2.3,2.53-3.8,4.1-3.8,4.1c0.26,2.77-1.53,10.46-3.67,17.98c0,0,0,0,0,0 c-0.28,1.16-0.56,2.32-0.85,3.47c-0.64,2.82-1.36,6.27-1.98,8.87c0.62-0.39,1.33-0.75,2.16-1.09c0,0,0.39-0.14,1.06-0.37 c2.12-2.04,9.82-9.4,11.68-10.33l0.16,0.68l-0.82-5.71l0.02-0.01l-1.3-9.01l-1.42-9.78C18.93,541.18,18.52,541.59,18.12,541.99 C18.12,541.99,18.12,541.99,18.12,541.99z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.81,585.73l-0.01-0.08c-0.49,0.28-1.25,0.72-2.42,1.37C24.95,586.14,25.57,585.83,25.81,585.73z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M33.69,613.31c-1.77,0.39-2.6,2.85-3.4,3.59l0.05,0.38c0.59-0.46,2.69,1.06,4.44,0.67 c4.42-0.98,13.59-3.24,16.99-3.97c3.4-0.73,13.84-7.49,13.84-7.49l-0.3-0.16c0,0-9.33,0.08-13.91,1.71 S36.64,612.65,33.69,613.31z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M56.34,671.66L56.34,671.66l60.9,29.03c3,1.85,5.48-0.02,5.35-4.05L103.68,507 c-0.13-3.97-2.74-8.37-5.69-9.57L73.17,495l0,0l-0.49-0.05l-9.95-0.97l-12.42-1.22l-33.11-3.24c-3.05-1.24-5.11,1.45-4.42,5.77 l6.04,41.77l0,0l0.54,3.71l0,0l1.42,9.78l1.3,9.01l-0.02,0.01l0.82,5.71l0.5,7.74c6.11-2.16,14.09-4.92,17.52-6.17 c6.41-2.34,11.08-3.04,13.96,0c1.59,1.34,2.14,2.44,0.74,3.28c-0.01,0.01-1.4,1.22-1.41,1.23c-2.23,2.7-7.06,2.05-12.62,4.63 c-7.29,3.39-15.75,5.95-15.75,5.95s-0.64,3.38-1.22,3.72l0,0c0.15-0.07-0.81,0-0.81,0l0.53,0.82c0.02-0.01,0.65,0.22,0.65,0.22 l0.48,3.32c0.6-0.02,2.15,1.97,2.86,1.93c0,0,19.36-2.77,28.63-4.17c7.66-1.15,10.85-2.59,12.92-0.41 c2.06,1.48,1.88,3.29,0.07,3.91c-0.39,0.14-0.57,0.44-1.05,0.59c-2.07,1.38-4.42,1.22-7.98,1.93 c-4.71,0.95-19.9,3.17-28.77,5.12c-1.98,0.43-2.21,1.59-3.27,1.82c-0.27,0.06-1.89,1.79-2.08,1.84l0.37,1.09 c0.2,0.01,1.74,0.3,2,0.3c2.76-0.06,8.86-0.37,12.84-1.17c5.76-1.16,25.26-6.98,30.11-6.92c2.27,0.03,2.72,2.01,2.93,3.79 c0.98,1.5,0,2.3-1.29,2.92c-0.92,0.44-0.45-0.33-1.64,0.12c-0.11,0.05-1.86,1-1.97,1.05c-3.19,1.36-6.84,3.1-6.84,3.1 s2.02,0.38,2.78,1.65c1.09,0.97,2.05,1.72,1.13,2.43c-0.43,0.33-1.04,0.5-1.6,0.89c-1.1,0.87-3.26,1.61-5.62,2.92 c-4.58,2.55-9.65,2.93-14.01,4.85c-3.52,1.55-9.57,2.64-13.96,3.51c-0.28,0.06-0.78,0.1-1.04,0.15l2.2,13.79l0.1-0.03 l2.81,19.41c0.52,3.23,2.46,6.44,4.76,7.85l5.7,2.72l0,0L56.34,671.66z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M24.41,589.09c0.59,0.01,1.29,0.01,2.07-0.02l-0.36-2.58c0,0-0.01,0-0.03,0.01l0.35,2.51 C25.67,589.04,25,589.07,24.41,589.09z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M46.81,621.03c4.36-1.92,9.96-3.09,14.54-5.64c2.35-1.31,4.06-2.16,5.16-3.02 c0.22-0.16,4-1.48,1.26-4.47c-0.76-1.27-2.46-1.58-2.46-1.58l0.3,0.16c0,0-12.52,4.83-15.92,5.56 c-3.4,0.73-11.59,2.86-16.01,3.84c-1.75,0.39-2.76,0.92-3.34,1.39c-0.9,0.71-0.81,1.25-0.84,0.84 c-0.02-0.27,0.26-0.73,0.79-1.22c0.79-0.74,2.15-1.57,3.92-1.97c2.95-0.66,13.38-3.05,17.97-4.69 c4.58-1.64,13.13-3.92,13.13-3.92s3.72-0.82,6.96-2.03c6.78-2.53,3.85-4.23,4.08-5.8c0.25-1.56-1.57-3.22-3.84-3.25 c-4.85-0.06-25.02,5.12-30.78,6.28c-3.99,0.8-9.98,1.44-12.74,1.5c-0.27,0.01-0.49,0-0.7,0c-0.72-0.02-1-0.11-0.6-0.3 c0,0,0.2-0.05,0.54-0.12c0.19-0.04,0.4-0.09,0.67-0.15c1.06-0.24,2.73-0.61,4.7-1.05c8.86-1.95,23.78-5.11,28.49-6.06 c3.55-0.72,6.86-1.72,8.93-3.1c4.31-2.29,1.09-5.23,1.06-5.92c-1.58-2.02-6.71-2.25-14.37-1.1c-9.27,1.4-29.3,3.76-29.3,3.76 c-0.7,0.04-1.35,0.06-1.94,0.08c-0.78,0.02-1.48,0.03-2.07,0.02c-4.34,0.12-4.04-0.41-1.03-2.07c1.17-0.65,1.93-1.08,2.42-1.37 c0.58-0.34,0.78-0.46,0.78-0.46s8.6-4.5,15.89-7.89c5.56-2.58,12.29-4.19,14.52-6.89c1.84-1.08,0.45-4.42-0.49-4.76 c-2.88-3.04-9.95-3.4-16.37-1.06c-3.42,1.25-9.95,3.57-16.06,5.74l-1.2-5.04l-0.16-0.68c-1.86,0.93-9.55,8.28-11.68,10.33 c-0.67,0.24-1.06,0.37-1.06,0.37c-0.83,0.34-1.54,0.71-2.16,1.09c0,0,0,0,0,0c-0.3,0.19-0.58,0.37-0.84,0.57c0,0,0,0-0.01,0 c-0.76,0.57-1.35,1.17-1.83,1.78c-0.85,1.09-1.31,2.2-1.69,3.2c-0.06,0.16-0.12,0.32-0.18,0.47c-0.05,0.14-0.08,0.29-0.11,0.43 c-2.35,0.04-6.5,1.49-9.82,9.97c-1.37,3.5-1.15,7.65,0.27,11.71c-0.21-0.69-0.27-1.08-0.27-1.08s1.55,9.12,11.8,15.71 c10.21,6.56,16.53,3.23,16.36,2.99c-0.06-0.08-0.06-0.08,0,0c0.1,0.14,0.2,0.27,0.31,0.41c1.58,1.94,4.41,3.54,7.8,3.08 c0.53-0.07,1.18-0.18,1.9-0.31c0.26-0.05,0.54-0.1,0.82-0.16C36.72,624.3,43.29,622.58,46.81,621.03z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M24.41,589.09c0.59-0.02,1.26-0.04,2.03-0.08l-0.35-2.51l-0.12-0.82c0,0-0.01-0.01-0.16,0.06 c-0.24,0.11-0.86,0.41-2.44,1.29C20.37,588.68,20.07,589.21,24.41,589.09z"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M226.98,624.26l-31.35-55.93c4.17-0.26,11.5-1.7,11.98-2.03c1.66-0.91,3.69-1.11,5.17-2.36 c6.22-5.28,1.47-6.66,1.47-6.66s11.3-1.64,5.07-7.65c-6.23-6.01-12.13-11.88-17.64-16.5c-5.51-4.62-8.99-7.12-11.06-9.87 c-2.06-2.75-4.04-6.77-8.46-6.04c0,0-0.9-1.86-2.88-3.18c-1.98-1.32-5.49-1.44-8.41,0.32s-12.96,7.1-18.87,9.5 c-5.91,2.4-8.5,4.46-12.47,7.23c-3.98,2.77-8.16,4.76-12.52,6.44c-2.23,0.86-4.8,1.62-6.61,2.59c-1.48,0.69-2.58,1.44-2.38,2.35 c0.03,0.13,0.06,0.27,0.1,0.4c0,0.28,0.05,0.57,0.17,0.88c0,0,1.98,7.31,11.29,4.25c5.9-1.95,20.14-7.96,20.14-7.96l0.14,1.5 c0.01-0.02,0.02-0.04,0.03-0.06c-0.06,0.25-0.12,0.51-0.18,0.8c-0.38,1.77,0.17,3.57,1.43,5.49c0,0-2.77,1.59-4.41,3.59 c-0.84,1.02-1.25,2.85-1.02,4.56c0.01,0.16,0.01,0.31,0.03,0.49c0.44,4.27,4.03,3.87,6.55,5.29c2.52,1.42,5.66,3.49,7.85,4.14 c1.88,0.57,3.2-1.16,3.94-3.1c0.47,0.25,0.9,0.46,1.27,0.62c-0.01,0.01-0.02,0.02-0.02,0.04l0.92,0.34 c0.28,0.11,0.44,0.16,0.44,0.16s-1.27,2.78,2.35,4.96s7.05,3.74,8.81,3.79c1.75,0.06,4.97-2.03,4.97-2.03s2.41-1.85,5.77-2.47 c2.63,1.85,16.78,24.62,23.54,34.68C222.89,618.9,226.98,624.26,226.98,624.26z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M161.86,534.96c1.37-0.91,4.61-3.56,8.03-5.74c2.37-1.52,5.02-2.65,5.98-3.38 c2.35-1.77,4.53-7.86,3.09-7.12c-1.44,0.74-2.26-0.44-1.96-1.09c0,0-3.73,1.94-7.51,4.45c-3.78,2.51-8.28,5.91-10.69,7.23 c-2.34,1.27-6.36,3.49-8.84,0.67c-0.09-0.15-0.18-0.29-0.26-0.44c-1.19,1.04-2.8,2.6-3.42,3.78c-0.6,1.15-3.1-0.77-3.55,2.83 c-0.02,0.16-0.04,0.31-0.05,0.49c-0.28,4.28,3.32,4.49,5.57,6.31c2.25,1.82,5,4.38,7.04,5.4c1.76,0.87,3.35-0.6,4.41-2.4 C158.47,545.03,159.54,536.51,161.86,534.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M130.38,523.43c4.72-0.86,15.31-2.31,20-3.82s15.56-8.49,18.31-9.88c2.75-1.39,4.61-1.86,3.03-0.79 c-1.59,1.07-3.39,1.99-9.74,5.24c-6.29,3.21-11.55,6.74-12.72,8.45c-0.1,0.24-0.21,0.49-0.31,0.76 c-0.67,1.68-0.43,3.55,0.49,5.65c0,0-3,1.1-4.95,2.8c-1,0.87-1.71,2.6-1.77,4.33c0.46-3.6,2.96-1.68,3.55-2.83 c0.62-1.19,2.23-2.74,3.42-3.78c0.08,0.15,0.17,0.29,0.26,0.44c2.48,2.82,6.2,2.48,8.54,1.21c2.41-1.31,8.08-4.52,11.86-7.03 s5.54-5.03,5.54-5.03c-0.3,0.64-0.87,1.71,0.57,0.97c1.44-0.74-0.19,0.66-2.53,2.43c-0.96,0.73-3.12,2.13-5.49,3.65 c-3.41,2.18-7.27,4.59-8.64,5.5c-2.32,1.55-3.51,1.96-4.9,4.92c0,0,0-0.03,0-0.04c-0.24,0.77-0.42,1.83-0.18,3.03 c-1.05-1.77-2.14-2.43-3.35-1.38c-1.41,1.22-1.41,5.03,0.15,6.26c1.56,1.23,2.25,3.53,3.37,3.02c1.03-0.47,1.42-3.24,0.84-5.58 c0.03,0.05,0.06,0.1,0.1,0.15c1.18,1.65,2.66,2.98,3.88,3.91c0.42,0.32,0.81,0.6,1.15,0.83c1.75-2.28,6.58-4.33,11.02-6.75 c4.45-2.44,7.11-5.98,7.11-5.98c-1.11,3.83-5.92,6.46-9.53,8.42s-6.54,3.9-7.37,5.07c0,0-1.72,2.52,1.49,5.28 c3.21,2.76,6.33,4.86,8.05,5.22c1.72,0.35,5.24-1.17,5.24-1.17s0.73-0.26,1.17-1.23c0.45-0.97,1.77-0.72,1.77-0.72 s0.77,2.57,2.87-2.05c0,0,1.14,2.86,4.06,3.07c2.91,0.21,4.49-1.5,5.74-2.6c1.25-1.1,1.61,5.69,6.83,8.54 c5.22,2.84,8.61,4.92,8.61,4.92s-0.03,0.01-0.08,0.04c1.79-0.62,3.58-1.41,5.24-2.4c7.02-4.17,10.41-11.44,10.41-11.44 s-1.99-3.76-7.12-10.73c-5.13-6.97-9.97-13.74-14.63-19.22c-4.66-5.48-7.67-8.53-9.25-11.58c-1.58-3.05-2.85-7.35-7.32-7.37 c0,0-0.58-1.98-2.31-3.61c-1.73-1.63-5.17-2.34-8.35-1.09c-3.18,1.24-13.96,4.83-20.19,6.21c-6.23,1.38-9.12,2.97-13.51,5.04 c-4.39,2.07-8.84,3.32-13.42,4.25c-2.35,0.47-5.01,0.79-6.95,1.45c0.64-0.18-2.56,3.58-2.71,2.34 c-0.04,0.27-0.05,0.57,0.02,0.89C119.73,524.82,127.45,523.97,130.38,523.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M162.07,547.55l-0.41-0.23C161.92,547.47,162.07,547.55,162.07,547.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M200.05,559.7c-5.22-2.84-4.44-10.78-5.7-9.68c-1.25,1.1-5.32,4.15-8.24,3.94 c-2.91-0.21-3.67-4.59-3.67-4.59c-2.1,4.62-6.58,6.27-6.58,6.27s2.59-0.95,2.15,0.01c-0.45,0.97-1.17,1.23-1.17,1.23 s4.7,1.98,8.54,2.39c2.5,0.26,4.33,1.99,6.32,4.36c1.99,2.37,4.08,4.98,4.08,4.98c6.23,0.8,11.38-1.44,12.05-1.75 c0.05-0.02,0.08-0.04,0.08-0.04S205.27,562.54,200.05,559.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M169.43,542.48c3.61-1.97,8.42-4.59,9.53-8.42c0,0-2.66,3.54-7.11,5.98c-4.43,2.43-9.27,4.47-11.02,6.75 c-0.01,0.01-0.02,0.02-0.03,0.03l0.85,0.49l0.41,0.23C162.9,546.38,165.82,544.45,169.43,542.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M128.15,525.65c6.15-0.93,21.19-4.47,21.19-4.47l-0.11,1.5c0.01-0.02,0.03-0.03,0.04-0.05 c1.16-1.7,6.42-5.23,12.72-8.45c6.35-3.24,8.15-4.17,9.74-5.24c1.59-1.07-0.27-0.6-3.03,0.79c-2.75,1.39-14.6,7.29-19.29,8.8 s-14.32,3.04-19.04,3.9c-2.94,0.53-10.63,2.38-12.62-2.87C117.74,519.57,118.47,527.12,128.15,525.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5D8",
    d: "M121.06,521.13c2.83-0.02,6.3-1.78,5.51-3.79c-0.79-2.01-1.67-2.22-4.1-1.7 c-0.7,0.15-1.41,0.31-2.05,0.48c-1.57,0.43-2.78,0.99-2.74,1.92c0.01,0.13,0.02,0.27,0.04,0.42 C117.87,519.7,118.53,521.15,121.06,521.13z"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M218.76,545.45c0,0,9.65-1.54,4.94,7.9L218.76,545.45z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M239.3,308.48c2.02,0,3.03-1.4,2.1-1.48c-2.72-0.23-4.74,0.54-5.68,1.63 C234.79,309.73,237.28,308.48,239.3,308.48z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M236.54,310.5c-1.97,0.22-5.03-0.24-4.79-3.88C231.6,308.53,231.69,312.98,236.54,310.5z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M223.55,322.74c0.04-0.66,0.26-1.36,0.46-1.99c1.03-3.37,4.89-10.4,4.89-10.4 c0.04-0.26-7.3,11.41-9.39,19.81c-1.67,6.75,0.85-2.11,2.95-4.2c0.03,0.02,0.05,0.04,0.08,0.06c0,0,5.18,7.3,11.63,9.95 c0,0,3.01-2.61-0.88-5.66c-1.35-1.06-1.63-1.39-3.98-2.99c-1.54-0.83-3.5-2.06-3.37-2.96c0.01-0.06-0.02,0.06,0,0 c1.42-0.02,3.13-0.38,4.71-0.84c0.56-0.16,1.11-0.36,1.64-0.59c0,0,7.88-2.79,4.34-7.43c-0.05-0.07-0.09-0.13-0.15-0.2 C236.47,315.14,229.73,320.44,223.55,322.74z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M189.18,352.98c-15.32-5.11-19.77-7.55-23.76-16.21c0,0,6.37,13.53,10.59,21.09 c4.22,7.55,7.35,13.23,7.13,21.23c0,0,4.34-18.73,13.75-19.42c13.48-0.99,25.88-1.91,25.88-1.91c-0.28-0.03-0.55-0.07-0.82-0.1 C209.92,356.25,204.17,357.97,189.18,352.98z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M212.93,277.2c-0.78,0.31-1.63,1.32-3.26,1.4C209.67,278.6,212.35,279.34,212.93,277.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M211.23,277.14c1-0.49,1.16-0.72,1.16-0.72c-1.79,0.23-2.79-0.16-3.11-0.39 C208.97,275.8,209.83,277.83,211.23,277.14z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#AB7D62",
    d: "M214.34,274.03"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M230.66,271.54v0.12C230.73,271.6,230.73,271.56,230.66,271.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M223.84,272.96c-0.01,0.07-0.03,0.14-0.04,0.21c0,0,0,0,0,0l0.01,0 C223.82,273.08,223.83,273.01,223.84,272.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M228.34,263.19c-1.11-0.98-5.56,7.3-5.53,9.06c0,0-2.84,5.15-2.84,7.42c0,0.2-0.37,0.92-0.36,1.07 c-2.44,0.09-1.67,2.5-1.71,2.8c-1.5,12.13,9.56,21.35,14.1,4.45C236.23,272.28,230.89,265.42,228.34,263.19z M230.68,271.54 c0.07,0.02,0.07,0.06,0,0.12V271.54z"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB0",
    d: "M219.96,274.68c0-0.06,0-0.15,0-0.29c0,0-0.08-0.02-0.17-0.02c-2.7,0-5.46,1.73-6.58,2.19 c0,0,0.51-0.09,1.31-0.24c1.22-0.22,3.55-0.69,5.43-1.05C219.96,274.97,219.96,274.97,219.96,274.68z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M219.95,274.39c-0.06-0.01-0.11-0.01-0.17-0.02c-2.63,0.81-5.01,1.6-6.15,2.07c0,0,0.51-0.09,1.31-0.24 c1.22-0.22,3.12-0.57,5.01-0.93C219.96,274.97,219.96,274.68,219.95,274.39z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M226.23,258.3c-5.68-1.14-10.23,4.54-13.63,8.52c-0.72,0.84-1.29,1.5-1.74,2.02 c0.26-0.01,0.51-0.03,0.76-0.04c3.1-2.45,8.43-6.35,11.49-6.81c2.14-0.32,3.9,0.34,5.22,1.2c0.79,0.17,1.19,0.93,1.57,1.3 c0.8,0.77,0.99,1.29,1,1.48c0-0.06,0.19-0.25,0.29-0.2C232.16,264.11,231.67,259.39,226.23,258.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M232.75,279.33c0.04-0.03,0.08-0.06,0.12-0.09c-0.07-0.23-0.14-0.45-0.21-0.64 c-0.25,0.29-0.47,0.55-0.67,0.78C232.25,279.36,232.5,279.34,232.75,279.33z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M234.23,262.82c6.05-32.67-4.53-30.14-5.56-29.82c-0.05,0.02-0.08,0.03-0.08,0.03 c4.72,10.93,5.6,21.18,5.7,26.33c-0.09,1.51-0.22,3.05-0.36,4.59c-0.27,0.83-0.71,1.85-1.26,2.02c-0.14,0.04-0.27,0.06-0.4,0.06 c-0.07,0-0.14,0-0.21-0.01c-0.07-0.01-0.13-0.01-0.19-0.03c-0.05-0.01-0.1-0.02-0.14-0.03c-0.23-0.06-0.41-0.15-0.53-0.2 c-0.06-0.02-0.09-0.03-0.12-0.03c-0.02,0-0.03,0.01-0.03,0.03c0-0.01,0-0.03,0-0.05c-0.01-0.11-0.05-0.33-0.15-0.6 c-0.01-0.03-0.02-0.06-0.04-0.09c-0.02-0.05-0.05-0.1-0.08-0.16c-0.03-0.06-0.06-0.11-0.1-0.17c-0.03-0.05-0.06-0.1-0.1-0.16 c-0.02-0.03-0.26-0.32-0.28-0.34c-0.06-0.07-0.13-0.13-0.21-0.2c-0.4-0.34-0.96-0.64-1.75-0.81c-0.23-0.05-0.48-0.09-0.76-0.12 c-2.38-0.23-5,2.06-6.91,3.88c-0.4,0.38-0.64,0.86-0.78,1.4c-1.4,0.08-4.35,0.24-8.27,0.46c-0.25,0.01-0.5,0.03-0.76,0.04 c-0.55,0.03-1.13,0.06-1.72,0.1c-0.9,1.64-1.85,3.3-2.89,4.99c1.81,0.01,3.68,0.02,5.6,0.05c0.92,0.01,1.74,0.03,2.48,0.05 c0.12,0,0.23,0.01,0.34,0.01c2.59,0.08,4.17,0.22,5.1,0.33c0.06,0.01,0.11,0.01,0.17,0.02c0.01,0.29,0.01,0.58,0,0.88 c-0.01,0.56-0.04,1.14-0.12,1.73c-0.04,0.31-0.07,0.68-0.11,1.09c-0.44,5.57-0.14,19.71,5.41,18.75 c5.97-1.03,6.32-15.93,6.72-18.7c0.14-0.98,0.45-0.54,0.8,0.44c0.07,0.2,0.14,0.41,0.21,0.64c0.57,1.87,1.15,4.68,1.15,4.68 s0.03-0.09,0.1-0.34c0.15-0.61,0.48-2.22,0.9-5.98c0.07-0.6,0.14-1.28,0.21-2c0.21-2.08,0.44-4.64,0.68-7.85 c0.05-0.61,0.06-1.12,0.06-1.59C235.98,261.72,234.23,262.82,234.23,262.82z M229.24,287.51c-2.99,15.99-6.22,6.47-6.13-5.65 c0.01-0.8,0.03-1.56,0.06-2.3c0.01-0.26,0.03-0.51,0.04-0.76c0.11-2.15,0.32-4.01,0.59-5.61c0.98-5.75,2.78-8.21,3.9-8.62 C230.87,263.39,232.23,271.52,229.24,287.51z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C2B1A",
    d: "M225.26,280.74l0.07,0.01c0,0,0.04-0.11,0.09-0.29c0.06-0.22,0.15-0.55,0.24-0.97 c0.26-1.29,0.47-3.39-0.25-5.36c0,0,2.52-0.84,5.04-2.31c1.32-0.77-2.34,0.12-6.65,1.36c-0.27,1.6-0.48,3.47-0.59,5.61 c0.04,0.3,0.1,0.6,0.19,0.88C224.03,279.99,224.66,280.35,225.26,280.74z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CFBEB0",
    points: "168.44,309.34 207.49,333.27 210.86,335.28 209.67,337.51 206.91,337.81 203.45,336.28 166.27,312.65  "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#41637C",
    d: "M159.17,303.17c-0.61,1.28-1.39,2.45-2.32,3.49c2.07,1.32,5.38,3.43,9.41,5.99l0,0 c6.58,4.19,15.05,9.58,23.02,14.65c0.26,0.17,0.52,0.33,0.78,0.49c1,0.63,1.98,1.26,2.95,1.88c0.99,0.63,1.96,1.25,2.91,1.85 c0.15,0.1,0.3,0.19,0.45,0.29c1.1,0.7,2.16,1.38,3.2,2.04c0.99,0.63,1.96,1.25,2.88,1.84c0.34,0.22,0.68,0.41,1,0.59l0,0 c6.62,3.68,8.74-0.69,3.26-3.46c-3.17-1.6-5.27-3.06-13.29-7.77c-7.97-4.67-17.53-10.82-24.97-15.72 C164.63,306.83,161.37,304.65,159.17,303.17z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#33190D",
    d: "M109.14,326.52c1.38,4.82,2.52,9.74,3.25,14.53c0.13,0.78,0.25,1.49,0.35,2.16l0,0 c0,0,0.66,2.51,0.77,5.95c0.27-0.04,6.25-1.03,12.42-3.94c0.01-0.65,0-1.3-0.04-1.96c-0.94-16.97-22.99-41.98-30.98-53.38 c0.3,0.69,0.61,1.37,0.93,2.02C102.39,304.89,106.53,316.89,109.14,326.52z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E6869",
    d: "M106.15,365.14c-0.76,0.17-1.66,0.29-2.72,0.37c-0.24,0.02-0.5,0.04-0.77,0.06 c-1.95,0.19-4.07,0.32-6.33,0.42c-0.49,0.03-0.96,0.06-1.38,0.06c-0.01,0-0.02,0-0.03,0c-3.75,0.15-7.86,0.23-12.17,0.37 c0,0,0,0,0,0c11.27,4.21,20.52,4.3,27.53,1.75c-1.32-1.11-2.63-2.13-3.95-3.05C106.27,365.12,106.21,365.13,106.15,365.14z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M53.24,564.91c-1.89,0.41-3.36,0.92-4.4,1.36c-1.01,0.43-1.42,1.64-0.87,2.6 c0.72,1.26,1.67,2.9,2.18,3.71c0.89,1.41,4.75-0.9,6.85-2.17c0.01-0.01,0.03-0.02,0.04-0.02c1.4-0.85,1.06-3.39-0.53-4.73 C55.71,564.98,54.6,564.61,53.24,564.91z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M64.09,587.69c-0.41,1.38,0.5,3.21,1.07,4.79c0.47,1.31,3.52,0.53,5.87-0.23 c0.48-0.16,0.94-0.31,1.33-0.44c1.8-0.62,2.02-4.01-0.27-5.47c-0.61-0.39-1.34-0.69-2.27-0.69 C65.64,585.63,64.5,586.31,64.09,587.69z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M72.69,596.84c-4.15,0.5-5.2,1.31-5.44,2.73c-0.24,1.42,0.89,3.12,1.64,4.62 c0.44,0.87,2.02,0.56,3.7-0.06c1.2-0.44,2.45-1.04,3.36-1.49c1.29-0.62,1.37-2.67,0.39-4.16 C75.65,597.42,74.42,596.63,72.69,596.84z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6D9",
    d: "M64.61,607.34c-3.09,1.04-3.75,1.82-3.71,2.94c0.04,1.12,1.17,2.24,1.98,3.26 c0.58,0.73,2.2-0.17,3.62-1.17c0.56-0.39,1.09-0.8,1.51-1.12c0.92-0.71,0.59-2.38-0.49-3.35 C66.83,607.27,65.82,606.93,64.61,607.34z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M21.71,623.05c0.05-0.02,0.15-0.4,0.1-0.49c-1.44-2.22-4.11-4.02-6.17-6.61 c-2.06-2.59-1.64-5.8-3.16-7.05c-0.97-0.8-2.1-2.02-2.9-3.64c-2.83-1.08-6.48-1.96-10.01-1.32c-5.03,0.91-5.84,0.52-5.84,0.52 s0.06,0.39,0.27,1.08c0.5,1.67,1.9,5.15,5.57,9.55C4.53,621.05,16.53,625.25,21.71,623.05z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5D8",
    d: "M122.47,515.86c-0.7,0.15-1.41,0.31-2.05,0.48c-1.57,0.43-2.78,0.99-2.74,1.92"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "479.35,558.09 479.36,558.09 479.36,558.09  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M364.28,473c0,0,0.02,0.04,0.07,0.12c-0.01-0.05-0.04-0.11-0.09-0.19C364.27,472.98,364.28,473,364.28,473z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M490.83,606.54c-1.27,0.77-2.89,1.64-4.19,2.45C488.1,608.2,489.51,607.48,490.83,606.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M482.62,537.97c-0.35,1.06-5.8,6.1-5.8,6.1c-6.06,6.68-7.19,12.72-9.54,23.98 c-2.35,11.26-7.35,18.26-3.89,25.32s3.06,8.96-5.6,12.18c-3.85,1.43-6.45,6.01-8.92,8.07c2.73,2.65,5.58,5.65,7.99,8.7 c0.77-0.46,3.05-0.61,4.05-1.17c8.25-4.62,20.16-11.03,26.43-14.16c6.27-3.14,5.35-5.11,10.47-9.9c5.12-4.79,6.56-7.66,7.8-8.41 c1.24-0.74,0.85-5.84,1.27-7.33s0,0,0.41-1.49l2.23-4.62c0,0-0.06,0.16-0.17,0.44c0.14-0.31,0.27-0.61,0.4-0.89 c0.74-1.63-2.96-5.93-7.41-0.44s-4.3,8.45-6.82,10.37c-2.52,1.93-6.37,5.34-7.26,6.08c-0.46,0.39-2.78,0.89-5.48,1.48 c-0.61-0.3-3.01-1.43-5.19-1.55c-1.25-0.07-2.64,0.05-3.59-2.33c-0.36-0.81-0.48-1.82-0.26-3.01c0.59-3.26-0.74-9.34,1.19-14.52 c0.12-0.33,0.23-0.67,0.35-1c0.1,0.06,3.91,0.48,4.02,0.55c-0.09-0.1-1.22-1.34-1.22-1.34l-0.82-2.16l0,0l2.04-2.93 c0,0,1.75,0.1,3.57,0.59c1.82,0.49,2.83,2.65,4.56,3.47s3.37-0.71,3.37-0.71s-0.07,0.41-0.31,0.88c0.35-0.57,0.43-1.2,0.17-1.59 c-0.66-1.02-2.11-2.54-3.4-3.4s-2.26-2.8-4.2-3.77c-1.23-0.62-2.2-1.1-3.44-1.32c-0.1,0.01-0.19,0.03-0.29,0.04 c0,0,0.01-0.03,0.04-0.07c0,0,0,0,0,0c0,0,0,0,0,0c0.39-0.68,2.72-4.04,3.5-5.51c0,1.82,1.61,1.93,2.93,2.62 c2.76,1.44,7.52,2.28,7.89-0.42c0,0-0.01,0.07-0.03,0.17c1.11-2.54-1.66-3.61-3.28-3.91c-1.72-0.32-1.94-2.05-3.88-2.26 c-0.55-0.06-1.07-0.15-1.71-0.25c0.56-0.85,1.16-1.66,1.84-2.42c2.52-2.82,7.33-10.67,3.41-12.75 c-2.52-1.33-5.78,2.22-6.97,3.26C481.83,538.76,483.07,536.62,482.62,537.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M443.79,602.87c-0.54,1.2-1.38,2.67-2.18,4c0.04,0.04,0.09,0.08,0.13,0.11 C442.47,605.79,443.22,604.37,443.79,602.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M466.61,553.13c2.42-1.19,3.33-1.82,4.45-5.47c-1.46,0.32-2.57,0.9-3.47,1.64 C464.65,552.99,465.13,554.73,466.61,553.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M485.11,568.5c-2.32-1.28-4.52-3.19-4.52-3.19S482.72,567.23,485.11,568.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M482.45,570.62c0,0-0.01,0.36-0.23,0.73c0.43-0.53,0.58-1.17,0.41-1.46c-0.36-0.66-2.04-2.26-3.13-3.2 c-0.34-0.3-0.73-0.6-1.1-0.88l-0.34,0.08C479.53,567.46,482.05,570.16,482.45,570.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M479.29,571.93c0.67,0.27,1.25,0.3,1.73,0.18C480.58,572.18,480.02,572.14,479.29,571.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M467.86,548.92c0.04-0.04,0.07-0.08,0.11-0.12C467.97,548.8,467.93,548.84,467.86,548.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M467.79,549c0.03-0.03,0.05-0.06,0.07-0.08C467.84,548.94,467.81,548.97,467.79,549z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M487.98,566.41c-1.73-0.83-3.14-2.89-4.95-3.38c-1.82-0.5-5.61-0.41-5.61-0.41l-0.91,3.63l0,0 l-1.07,3.63c0,0,0.04,0.06,0.14,0.16c0.32,0.35,1.31,1.19,3.71,1.89c0.73,0.21,1.29,0.25,1.73,0.18 c0.66-0.1,1.02-0.43,1.21-0.76c0.22-0.37,0.23-0.73,0.23-0.73c-0.41-0.46-2.93-3.16-4.39-4.73l0.34-0.08l2.2-0.51 c0,0,2.2,1.92,4.52,3.19c0.78,0.43,1.56,0.78,2.29,0.97c1.8,0.46,2.67-0.48,3.07-1.26c0.24-0.47,0.31-0.88,0.31-0.88 S489.71,567.24,487.98,566.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M480.47,592.65c-0.25,0.03-0.52,0.11-0.78,0.2C481.04,592.54,482,592.46,480.47,592.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M410.01,624.98c10.79-8.73,21.87-17.18,28.3-20.65C432.24,607.42,421.75,615.36,410.01,624.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M677.35,646.35c0.01,0.07,0.01,0.15,0.01,0.22C677.36,646.5,677.36,646.43,677.35,646.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M677.2,645.73C677.2,645.73,677.21,645.73,677.2,645.73C677.21,645.73,677.2,645.73,677.2,645.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M677.28,646c0.01,0.04,0.02,0.08,0.03,0.12C677.3,646.08,677.3,646.04,677.28,646z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M664.76,662.34c-6.58,3.74-19.63,10.39-26.56,13.46l-0.01,0.02c6.93-3.07,19.99-9.72,26.57-13.46 c6.58-3.74,9.91-10.59,11.91-13.58c0.24-0.36,0.4-0.7,0.52-1.04c-0.11,0.33-0.28,0.67-0.52,1.02 C674.67,651.74,671.33,658.59,664.76,662.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M677.37,646.75c0,0.14-0.02,0.29-0.04,0.43C677.35,647.03,677.37,646.89,677.37,646.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M677.31,647.25c-0.03,0.14-0.06,0.28-0.11,0.42C677.25,647.53,677.29,647.38,677.31,647.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M676.88,645.1C676.88,645.1,676.88,645.1,676.88,645.1c0.87-1.05,1.95-2.4,3.21-4 c0.83-1.06,1.23-1.97,1.37-2.74c-0.14,0.77-0.54,1.67-1.36,2.73C678.83,642.68,677.75,644.03,676.88,645.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M634.19,676.91c-4.49,1.13-22.55,6.94-27.47,7.76c-4.92,0.82-7,0.59-12.56,2.71 c-5.56,2.11-5.83,2.33-7.99,3.95c-0.8,0.6-2.89,2.33-5.22,4.26c0,0.01,0,0.01,0,0.02c2.33-1.93,4.42-3.66,5.22-4.26 c2.16-1.62,2.43-1.84,7.99-3.95c5.56-2.11,7.64-1.89,12.56-2.71c4.92-0.82,22.99-6.63,27.47-7.76c1.71-0.43,3.02-0.88,4.1-1.37 l0.01-0.02C637.21,676.02,635.9,676.48,634.19,676.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M575.36,665.28c0.39,0.2,0.71,0.56,0.95,1.12c0.48,1.08,0.9,2.16,1.3,3.24 c5.37-0.59,14.19-3.02,20.83-17.17c8.45-17.99,43.91-9.93,51.87-13.86c6.88-3.4,13.46-7.32,24.65-12.47 c-3.77,0.48-9.18,2.49-10.95,2.87c-2.68,0.58-10.34,3.58-10.34,3.58s-13.1,1.7-20.09,1.81c-5.83,0.09-13.78,1.38-15.5,1.2 c-0.04,0.19-0.06,0.32-0.06,0.32s-1.59,0.11,0.01-3.54c1.6-3.65,4.64-6.87,7.92-8.91c3.28-2.04,4.39-2.43,9.01-4.65 s3.93-6.52,4.29-7.8c0.01,0.01,0.02,0.03,0.04,0.04c-0.99-1.53-2.87-2.03-3.92-1.37c-2.21,1.38-6.69,3.24-10.39,4.75 c-3.7,1.51-7.14,3.34-10.82,6.03c-3.68,2.69-9.44,3.56-13.57,6.35c-4.13,2.79-6.02,4.61-9.49,8.06 c-3.47,3.45-7.78,5.18-10.28,11.83c-2.5,6.65-4.06,7.51-6.34,9.47c-0.69,0.6-2.03,1.66-3.7,2.95 C572.36,660.33,573.97,662.25,575.36,665.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M679.9,634.99c1.1-1.58,1.58-2.85,1.69-3.88C681.48,632.14,680.99,633.41,679.9,634.99 C679.89,634.99,679.9,634.99,679.9,634.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M679.9,634.99C679.9,634.99,679.89,634.99,679.9,634.99c1.09-1.58,1.58-2.85,1.69-3.88 c0.35-3.11-2.71-3.98-2.71-3.98c-1.2-1.56-2.99-1.9-4.94-1.66c-0.02,0.01-0.03,0.01-0.05,0.02 c-11.19,5.15-17.44,7.03-24.32,10.42c-7.97,3.93-44.88-3.54-53.34,14.45c-6.65,14.15-13.26,18.68-18.63,19.28 c1.05,2.87,0.18,6.7,0.74,9.46c0.6,3.01-0.05,6.53,0.1,9.31c0.17,3.14,2.72,4.5,2.5,7.18c2.33-1.93,4.42-3.66,5.22-4.26 c2.16-1.62,2.43-1.84,7.99-3.95c5.56-2.11,7.64-1.89,12.56-2.71c4.92-0.82,22.99-6.63,27.47-7.76c1.71-0.43,3.02-0.88,4.11-1.38 l-0.01,0.02l-0.09,0.24c0,0,0,0,0.01,0c6.93-3.07,19.99-9.71,26.56-13.46c6.58-3.74,9.91-10.59,11.91-13.58 c0.23-0.35,0.4-0.69,0.52-1.02c0.01-0.02,0.02-0.04,0.02-0.06c0.05-0.14,0.08-0.28,0.11-0.42c0-0.02,0.01-0.04,0.01-0.07 c0.03-0.15,0.04-0.29,0.04-0.43c0-0.06,0-0.11-0.01-0.17c0-0.08-0.01-0.15-0.01-0.22c-0.01-0.08-0.02-0.16-0.04-0.23 c-0.01-0.04-0.02-0.08-0.03-0.12c-0.02-0.09-0.05-0.18-0.08-0.26c0,0,0,0,0-0.01c-0.08-0.22-0.19-0.43-0.32-0.62 c0,0,0-0.01-0.01-0.01c0.87-1.06,1.95-2.42,3.21-4.02c0.83-1.05,1.23-1.96,1.36-2.73C681.86,636.08,679.96,635.02,679.9,634.99z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M291.55,613.27c8.22-0.54,20.45-3.78,30.59-5.5c-2.77-9.22-9.74-32.54-4.61-39.96 c-0.22,0.15,13.82-9.82,24.55-6.24c-0.78-0.02,7.48,0.8,11.33,1.22c7.05,0.78,11.91-5.21,12.8-12.51 c1.08-8.91-1.78-10.85,1.38-14.2c1.12-1.19,2.43-2.41,2.83-3.8c-0.09,0.19-0.19,0.37-0.32,0.55c0,0-2.96-10.24-2.53-10.76 c2.53-3.06,3.97-5.54,4.29-6.13c-0.22-0.36-0.48-0.73-0.82-1.13c-2.42-2.94-2.36-6.46-1.93-8.67c0.93-4.82,5.86-5.88,8.15-5.97 c0.05,0,0.13-0.03,0.17-0.06c2.63-1.87,2.23-4.4-2.54-10.76c-4.57-6.1-9.21-13.87-10.3-15.71c-0.15-0.26-0.18-0.57-0.08-0.85 l-0.09-4.74l3-3.3l0.01,0.01c-1.44-3.32-4-6.77-3.34-8.75c0.14-0.41,0.23-0.86,0.27-1.34c-0.01,0.05-0.02,0.08-0.02,0.08 c-0.54-0.54-1.12-1.06-1.78-1.39c0,0-0.01,0-0.01,0c-1.01,0.91-1.73,1.4-1.9,1.51c-0.02,0.02-0.05,0.01-0.06-0.01 c-0.13-0.16-0.73-0.81-2.06-0.82c0,0,0,0,0,0c-0.54,0.38-1.13,0.86-1.77,1.51c0,0,0.25-0.59,0.68-1.4 c-0.82,0.17-1.82,0.54-3.04,1.25c-3.66,2.12-9.39,2.89-13.77,3.25c-1.09,0.09-2.1,0.15-2.97,0.21 c-0.28,0.06-0.55,0.12-0.99,0.14c-0.07,0-0.15,0.02-0.23,0.04c-0.09,0.03-0.18,0.05-0.28,0.08c-0.01,0-0.02,0.01-0.03,0.01 c-0.02,0.01-0.04,0.02-0.06,0.02c-0.6,0.23-1.27,0.71-1.45,1.2c-1.12,1.92-3.2,5.74-4.83,9.99c-0.75,2.03-1.37,4.14-1.73,6.18 c-0.32,1.83-0.9,3.42-1.61,4.82c-0.07,0.15-0.14,0.29-0.22,0.43c-0.07,0.14-0.15,0.27-0.22,0.41c-2.86,5.15-7.73,7.78-7.73,7.78 l0-17.78c-1.45,0.99-2.88,1.88-4.25,2.58c0,0,0.12-0.28,0.28-0.68c-0.01,0-0.01,0.01-0.02,0.01c0,0,0.08-0.18,0.19-0.46 c0.37-1.02,0.77-2.35,0.3-2.35c-0.33,0-1.27,0.8-2.49,1.93c-0.39,0.36-3.61,3.37-4.08,3.79c-0.39,0.35-0.77,0.68-1.15,1 c0,0,0.19-0.33,0.38-0.78c-0.04,0.04,0.05-0.19,0.23-0.61c0.13-0.42,0.22-0.86,0.14-1.19c-0.32-0.16-0.4-0.39-0.76-0.46 c-0.25-0.05-0.75,0.05-1,0.06c-0.46,0.14-1.03,0.39-1.74,0.75c-0.35,0.18-0.65,0.33-0.92,0.44c-0.04,0.03-0.08,0.07-0.12,0.11 c-0.88,0.76-2.15-0.3-1.51-1.27c0.01-0.02,0.03-0.04,0.04-0.06c0.06-0.08,0.1-0.17,0.12-0.27c0.53-2.07,2.06-5.63,1.65-8.9 c0,0-3.09,0.37-6.33,8.84c-3.24,8.47-10.32,41.59-17.2,57.85c-4.07,9.63-14.64,19.21-39.32,15.38c0,0,0,0,0,0 c-0.59,23.92-12.16,37.13-17.27,41.83C227.34,593.51,243.8,614.1,291.55,613.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6D6CF",
    d: "M375.57,501.15c0.12-0.06,0.23-0.11,0.34-0.17c-0.62,0.27-1.2,0.54-1.71,0.79 C374.63,501.58,375.09,501.37,375.57,501.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M318.83,523.78c-0.01-0.23-0.01-0.35-0.01-0.35S318.82,523.56,318.83,523.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M369.79,466.45l0.23,0.17C370.02,466.62,369.94,466.55,369.79,466.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M423.99,806.34c0.08-0.12,0.16-0.25,0.24-0.37c-1.99-0.7-4.02-1.49-6.11-2.37 C421.88,805.38,423.99,806.34,423.99,806.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M395.89,792.6c-7.55-4.03-16.13-8.71-26.21-13.98C379.25,783.93,388.16,788.64,395.89,792.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M156.85,987.09c0.75,0.71,1.53,1.4,2.32,2.07c-0.76-0.92-1.46-1.88-2.11-2.86 C156.93,986.81,156.85,987.09,156.85,987.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M176.83,810.11c0.09,0.5,0.18,1.02,0.26,1.53c-3.31-24.56-7.99-43.04-12.17-62.15 C168.68,768.98,172.99,789.43,176.83,810.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M178.73,825.5c3.43,47.86-11.14,116.89-18.22,146.82C167.91,943.3,183.55,874.2,178.73,825.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M156.77,698.44c-0.73-8.34-1.23-17.38-1.41-27.38C155.21,679.57,155.74,688.74,156.77,698.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M254.03,1016.14c25.46,1.02,51.37-0.58,73.33-2.86C307.48,1015.14,280.69,1016.86,254.03,1016.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M341.54,828.78c3.99,40.54,13.39,65.83,12.08,94.05c-1.98,42.44-16.66,50.27-1.31,87.67 c15.71-2.38,32.37-5.71,32.37-5.71s-29.33-101.83-23.9-230.88c-1.35-0.79-2.64-1.59-3.83-2.42 C356.95,771.49,335.89,771.43,341.54,828.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M425.9,806.54c-0.23-0.08-0.46-0.15-0.69-0.23C425.44,806.38,425.67,806.46,425.9,806.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M577.61,669.64c-0.4-1.08-0.82-2.16-1.3-3.24c-0.25-0.56-0.57-0.92-0.95-1.12 c-5.27-2.69-28.35,21.61-57.35,55.95c-31.13,36.87-40.82,10.71-45.74,5.79c-4.92-4.92-13.44-7.06-12.62-4.6 c0.82,2.46-10.54-4.56-10.54,6.09c0,10.65-9.36-5.64-9.36-5.64s1.29,26.58-20.49,10.84c-16.97-12.27-32.52-43.61-32.52-43.61 c-12.53-27.02-50-85.97-85.19-84.11c-3.21,0.17-6.3,0.28-9.27,0.33c-47.75,0.84-64.94-12.8-68.81-16.64 c-0.63-0.63-0.91-0.99-0.91-0.99c-36.97,9.57-67.74,38.42-67.24,79.3c0.01,1.04,0.03,2.06,0.05,3.08 c0.19,10.01,0.69,19.05,1.41,27.38c1.73,19.8,4.78,35.64,8.15,51.06c4.18,19.11,8.86,37.58,12.17,62.15 c0.56,4.18,1.09,8.52,1.56,13.08c0.03,0.26,0.06,0.52,0.07,0.77c2.05,55.95-11.71,118.26-18.22,146.82 c-1.97,8.64-3.66,13.67-3.66,13.67c0.07,0.1,0.14,0.2,0.21,0.31c0.65,0.98,1.36,1.94,2.11,2.86 c15.95,19.42,55.26,25.9,94.86,26.98c26.66,0.72,53.45-1,73.33-2.86c19.18-1.8,31.93-3.74,31.93-3.74 c-0.05-0.11-0.09-0.22-0.13-0.33c-15.35-37.39-1.76-44.22,0.22-86.66c1.31-28.21-7.48-53.9-11.47-94.43 c-5.65-57.35,9.05-56.62,9.05-56.62c1.2,0.82,2.48,1.63,3.83,2.42c0.97,0.56,1.97,1.12,3.02,1.66c2.02,1.04,3.97,2.05,5.88,3.05 c10.08,5.27,18.65,9.95,26.21,13.98c8.46,4.51,15.65,8.21,22.23,11c2.09,0.88,4.12,1.67,6.11,2.37 c0.33,0.11,0.65,0.23,0.98,0.34c0.23,0.08,0.46,0.16,0.69,0.23c13.64,4.46,25.74,4.35,43.52-1.29 c27.29-8.65,47.64-37.51,71.96-59.07c26.54-23.54,36.7-36.08,36.7-36.08s2.15-5.81,2.85-14.49c0-0.01,0-0.01,0-0.02 C581.53,688.36,581.1,679.16,577.61,669.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M417.48,697.91c1.37-7.06,8.49-18.33,10.99-25.64c4.05-11.89,10.72-23.68,15.33-33.36 c4.38-9.21,6.21-17.25,6.95-21.77c0.4-2.44-1.64-2.74-1.64-2.74c-0.79-0.93,0.68-2.93,0.11-3.77c-1.47-2.13-2.42-3.9-3.83-5.09 c-0.04-0.04-3.73,1.35-3.78,1.32c-2.02-1.71-3.31-2.54-3.31-2.54c-6.43,3.47-17.51,11.92-28.3,20.65 c-15.3,12.38-30.01,25.3-30.01,25.3c0.06,0.06-0.06,2.43,0,2.49c1.61,1.62,2.44,3.71,4.61,6.14 c6.21,6.93,12.93,20.02,19.21,27.62C409.86,693.85,417.48,697.91,417.48,697.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0948F",
    d: "M292.28,606.31c2.99-0.2,6.1-0.46,9.33-0.8c-1.96-20.77,6.63-31.91,15.88-37.64 c4.04-2.5,8.2-3.97,11.67-4.77c5.54-1.27,9.05-1.58,12.16-1.48c0.31,0.01,0.62,0.02,0.92,0.04c3.32,0.19,6.34,0.8,11.17,1.13 c3.2,0.22,5.56-0.83,6.99-1.75c1.05-0.68,1.6-1.3,1.6-1.3c-0.04,0.02-0.09,0.04-0.13,0.06c-15.56,7.4-9.27-23.58-10.04-40.7 c-0.7-15.55-2.61-20.47-6.5-30.63c-3.86-10.1-9.59-22.68-6.33-29.71c-0.47,0.03-0.91,0.06-1.32,0.08 c-0.28,0.06-0.55,0.12-0.99,0.14c-0.07,0-0.15,0.02-0.23,0.04c-0.09,0.03-0.18,0.05-0.28,0.08c-0.01,0-0.02,0.01-0.03,0.01 c-0.02,0.01-0.04,0.02-0.06,0.02c-0.6,0.23-1.27,0.71-1.45,1.2c-1.12,1.92-3.2,5.74-4.83,9.99c-0.75,2.03-1.37,4.14-1.73,6.18 c-0.32,1.83-0.9,3.42-1.61,4.82c-0.07,0.15-0.14,0.29-0.22,0.43c-0.07,0.14-0.15,0.27-0.22,0.41c-2.86,5.15-7.73,7.78-7.73,7.78 l0-17.78c-1.45,0.99-2.88,1.88-4.25,2.58c0,0,0.12-0.28,0.28-0.68c-0.01,0-0.01,0.01-0.02,0.01c0,0,0.08-0.18,0.19-0.46 c0.37-1.02,0.77-2.35,0.3-2.35c-0.75,0-4.48,3.99-7.72,6.73c0,0,0.19-0.33,0.38-0.78c-0.04,0.04-0.08,0.07-0.13,0.11 c0,0,0.17-0.3,0.35-0.72c0.41-1.3,0.33-2.77-3.35-0.85c-5.73,2.99,0-3.99-0.75-9.96c0,0-3.09,0.37-6.33,8.84 c-3.24,8.47-10.32,41.59-17.2,57.85c-4.09,9.67-14.73,19.29-39.63,15.33c0.08,1.9,0.18,3.75-0.03,5.52 c-1.44,12.24-6.44,23.9-11.46,30.3c-2.09,2.67-4.06,4.68-5.51,6.03C227.25,593.44,244.4,607.15,292.28,606.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M679.19,627.97c-0.43,1.64-2.59,3.52-2.59,3.52s-2.09-0.65-1.24-2.33c0.92-1.81,1.76-2.44,1.76-2.44 s-3.08,2.33-2.41,3.92c0.67,1.6,1.24,1.36,1.24,1.36s-1.41,2.04-3.5,3.42c-2.1,1.38-2.63,0.81-2.63,0.81s-0.59,1.54-4.79,4.38 c-2.36,1.59-3.66,2.53-5,3.27c-0.74,0.24-1.19-0.48-1.19-0.48s0.34,0.9-0.72,1.38c0,0-0.25,0.15-1.83,0.7 c-3.69,1.29-12.72,4.19-16.92,5.42c-2.31,0.68-3.28,0.32-3.61,0.06c0.03,0.05,0.06,0.12,0.09,0.21 c0.05,0.14,0.13,0.32,0.23,0.52c0.58,0.59,1.24,1.33,1.95,2.24c-0.25-0.97-0.34-1.87,0.2-1.96c1.21-0.21,10.85-3.29,15.4-4.74 s6.11-1.7,7.62-3.14c1.51-1.44,8.21-5.44,10.33-7.07c2.12-1.63,4.18-3.43,5.8-5.11C679.02,630.24,679.49,626.84,679.19,627.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M681.47,630.16c0,0-0.05,2.39-1.75,4.5c-0.88,1.1-1.59,1.65-2.06,1.94c-0.33-0.28-1.08-1.09-0.45-2.33 c0.78-1.54,2.78-4.43,2.78-4.43s-2.16,3.02-3.23,4.42c-1.02,1.35,0,1.8,0.05,3.08c-0.31,0.74-1.08,2.46-2.74,5.57 c-0.16,0.31-0.34,0.58-0.52,0.87c-0.75,0.5-1.22-0.61-1.3-0.06c-0.06,0.49-0.07,1.26-0.16,1.99c-1.68,1.88-3.66,3.28-5.57,4.98 c-0.36,0.32-0.73,0.63-1.11,0.93c-0.44,0.21-0.71,0.06-0.88-0.17c0.07,0.29,0.09,0.61-0.02,0.85c-2.25,1.64-4.64,2.89-6.55,3.66 c-2.49,1.01-7.09,2.89-10.58,4.61c-2.58,1.28-4.31,0.72-5.04,0.34c0.32,0.66,0.65,1.35,0.97,2.09l0.66,1.14 c0,0,0.01-0.92,6.2-3.9c6.19-2.99,8.4-3.86,12.27-5.81c3.88-1.96,8.96-6.98,10.38-9.11c1.42-2.13,3.23-5.59,3.92-6.89 c0.69-1.3,3.17-3.43,3.17-3.43s0.01-0.01,0.01-0.01c0.01-0.02,0.05-0.08,0.11-0.18C680.42,634.13,681.77,631.75,681.47,630.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A0D",
    d: "M233.63,1010.79c49.86-2.37,66.51-14.85,6.76-24.07c-85.11-13.13-60.19-21.22-32.88-33.7 c27.77-12.7-21.26-7.54-3.96-56.98c10.6-30.28-4.14-63.65-16.62-96.55c-8.12-21.41-15.73-42.5-21.63-60.48 c-5.97-34.25-10.55-76.24,4.46-102.45c18.65-32.59,35.92-37.25,52.79-47.89c0,0-3.6,0.6-9.45,2.93 c-10.82,4.29-29.36,14.48-47.31,37.72c-0.57,0.74-1.11,1.53-1.62,2.35c-2.19,3.44-3.91,7.52-5.22,12.11 c-2.57,9.02-3.55,19.97-3.48,31.73c0.03,5.75,0.32,11.69,0.8,17.69c0.29,3.62,0.64,7.26,1.05,10.9 c0.62,5.5,0.73,11.96,3.5,24.88c0.21,0.97,0.42,1.96,0.64,2.99c0.84,4.68,1.72,9.21,2.6,13.51c0.38,1.84,0.75,3.63,1.13,5.38 c0.47,2.2,0.94,4.34,1.41,6.38c0.92,4.71,1.77,9.61,2.74,14.57c7.5,38.32,8.83,56.47,9.28,76.01 c1.03,44.74-21.75,139.29-21.75,139.29s2.94,5.77,9.94,9.21C180.15,1002.86,204.58,1012.17,233.63,1010.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B5743",
    d: "M356.95,771.49L356.95,771.49L356.95,771.49c0,0-14.7-0.73-9.05,56.62 c3.99,40.54,12.79,66.22,11.47,94.43c-1.75,37.62-12.63,47.26-4.38,75.02c0.23,0.57,0.34,0.89,0.34,0.89 s12.11-43.07,0.28-147.69C349.18,793.85,358.18,778.1,356.95,771.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5B51",
    d: "M678.74,642.41c-0.28-0.44-0.96-1.67-0.56-2.38c0.49-0.88,2.58-2.93,2.58-2.93 c-0.93,0.86-2.18,1.75-2.81,2.64c-0.2,0.29-0.32,0.89-0.25,1.15c0.21,0.84,0.61,1.56,0.77,1.82c-1.67,1.79-2.58,3.26-5.01,5.95 c-0.55,0.61-1.2,1.33-1.91,2.1c-3.28,3.57-7.77,8.34-8.91,9.59c-1.38,1.51-16.7,9.8-16.7,9.8l0,0c0,0,14.56-7.04,17.53-9.1 c1.5-1.04,9.42-10.52,11.19-13.23l1.38-1.7c-0.76,1.07-1.14,1.98-0.74,2.58c0.37,0.55,0.69,0.84,0.82,0.95c0,0,0,0,0.01,0 c0.03,0.03,0.06,0.05,0.06,0.05l0.15-0.36c0,0-0.01-0.01-0.01-0.01c0,0,0,0-0.01,0c-0.09-0.05-0.79-0.5-0.67-1.45 c0.11-0.83,0.62-1.91,0.81-2.28l3.22-3.97l0.42-0.52l0,0c0,0,0,0,0,0c-0.02,0.01-0.03,0.03-0.04,0.04 C679.55,641.59,679.12,642.01,678.74,642.41z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M362.87,469.3c-0.49,0.56-0.88,1-1.19,1.36c-0.95,0.92-1.39,1.28-2.41,2.63c-0.75,1,1.02-0.95,2.15-1.5 c0.24,0.05,0.56,0.11,1,0.21c1.21,0.27,1.67,0.67,1.84,0.94c0.05,0.08,0.07,0.14,0.09,0.19c0.01,0.05,0.02,0.09,0.02,0.09 s0.01-0.02,0.02-0.03c0.1-0.15,1.16-1.84,0.92-5.09l1.03-1.61c1.74-0.87,2.97-0.33,3.45-0.03l-2.34-1.7l-0.01-0.01 C367.44,464.74,365.21,466.62,362.87,469.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M358.75,474.3c-0.21,1.25-3.13,3.54-3.13,3.54C358.23,476.9,358.57,476.31,358.75,474.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M357.19,474.3c0,0-1.56,1.04-2.81,0.94C354.38,475.23,356.04,476.8,357.19,474.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M371.97,500.65c-3.29,0.59-3.06-0.94-3.88-3.65c-0.82-2.71-2.24-9.06-2.59-9.06 c-0.35,0,2.46,8.67,3.73,17.01c0.03,0.19,0.06,0.37,0.08,0.56c0,0,0-1.43,4.87-3.84c0.51-0.25,1.09-0.52,1.71-0.79 c0.26-0.11,0.5-0.22,0.78-0.34c0.45-0.19,0.6-0.31,0.52-0.39C376.96,499.91,374.47,500.2,371.97,500.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M366.49,523.42c-0.58-0.5,2.03-8.27,1.33-6.57c-1.46,3.58-4.41,10.02-4.92,11.92 c-0.51,1.93,0.74-3,2.51-3.33c3.64,1.21,4.68,7.39,4.68,7.39c0.13-0.18,0.22-0.36,0.32-0.55c1.48-2.96-1.49-6.96-2.66-8.36 c0.63-0.42,1.32-0.95,2.03-1.59c2.48-2.23,3.66-4.26,2.15-6.53c0,0-0.03,0.05-0.07,0.13c-0.33,0.59-1.76,3.06-4.29,6.13 C367.14,522.58,366.79,523.03,366.49,523.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M342.08,561.56c-10.74-3.58-16.1-8.59-19.68-20.04c-3.11-9.94-3.52-16.24-3.57-17.74 c0.09,3.47,0.71,31.83-1.64,44.25c0,0,0.12-0.09,0.35-0.23c1.72-1.12,9.85-5.95,22.25-6.24 C340.54,561.55,341.3,561.54,342.08,561.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M315.56,499.73c-1.98-3.75-0.67-4.64,0.27-6.67c0.94-2.04-0.08-2.54-0.08-2.54 c-1.96,3.1-4.67,2.16-5.93,3.63c-1.26,1.48,2.26,7.05,4.11,9.24C315.78,505.58,317.54,503.48,315.56,499.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M313.12,475.87c-0.38-0.62-0.87-1.36-1.53-2.03c-0.24,0.22-3.91-2.62-3.91-2.62s-2.65,1.3-2.72,1.32 c-0.07,0.02-1.97,2.27-1.97,2.27s-1.23,0.59-1.09,0c-1.47,2.12-2.08,5.04-2.68,7.33c0,0,1.73-3.93,4.19-5.97 c-0.28,0.12,2.67-1.71,2.67-1.71s0.3,0.42,0,0.52c0.24-0.01,0.49,0.01,0.74,0.06c0.35,0.07,0.69,0.19,1.02,0.35 c-0.03-0.13,1.32,0,1.32,0l0.51,0.26c-0.22,0.2-0.43,0.4-0.65,0.6c1.54,1.54,2.1,4.2,0.12,6.61c-2.77,3.36-3.75,4.82-4.36,7.41 c-0.61,2.6,1.25,4.98,1.25,4.98s0.39-1.99,1.01-4.39c0.63-2.4,3.54,0.87,6.34-2.1C316.18,485.79,314.25,477.73,313.12,475.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#715845",
    d: "M311.15,509.89c0,0-9.92-10.7-10.71-20.03C300.44,489.86,301.56,506.4,311.15,509.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M280.06,532.46c6.88-16.26,13.96-49.38,17.2-57.85c3.24-8.47,6.33-8.84,6.33-8.84 c0.42,3.34-1.19,6.99-1.68,9.04c-0.34,1.4-0.17,2.05,1.51,1.36c0.27-0.11,0.57-0.25,0.92-0.44c0.7-0.37,1.27-0.61,1.74-0.75 c1.17-0.37,1.64-0.09,1.75,0.41c0.08,0.34-0.01,0.77-0.14,1.19c-0.07,0.21-0.15,0.42-0.23,0.61c-0.19,0.45-0.38,0.78-0.38,0.78 c0.64-0.54,1.29-1.12,1.94-1.72c0.9-0.82,1.78-1.66,2.58-2.41c1.56-1.47,2.81-2.59,3.2-2.59c0.46,0,0.07,1.34-0.3,2.35 c-0.06,0.16-0.12,0.31-0.17,0.45c-0.15,0.4-0.28,0.68-0.28,0.68c1.37-0.7,2.8-1.6,4.25-2.58l0,17.78c0,0,4.87-2.62,7.73-7.78 c0.07-0.13,0.15-0.27,0.22-0.41c0.07-0.14,0.15-0.28,0.22-0.43c0.61-1.25,1.09-2.63,1.35-4.15c0.4-2.27,1.13-4.62,1.99-6.85 c1.63-4.25,3.71-8.06,4.83-9.99c0.19-0.49,0.86-0.97,1.45-1.2c0.02-0.01,0.04-0.02,0.06-0.02c0.01,0,0.02-0.01,0.03-0.01 c0.1-0.03,0.19-0.06,0.28-0.08c0.08-0.02,0.16-0.03,0.23-0.04c0.44-0.03,0.71-0.08,0.99-0.14c0.33-0.07,0.68-0.15,1.38-0.21 c0.1-0.18,0.19-0.37,0.29-0.55c5.55-32.19,0.97-44.36,0.97-44.36c5.01,10.48,3.87,27.15,2.85,35.64 c10.01-28.62-4.13-54.73-4.13-54.73c15.59,22.42,6.82,56.77,6.82,56.77c16.32-45.32-16.57-70.66-16.57-70.66 c20.47,13.4,25.34,40.2,25.34,40.2c-1.97-34.77-32.19-48.73-38.37-51.23c-30.43-5.06-61.73,3.05-61.73,3.05s-5.02,0.4-10.12,3.29 l0.61-0.87l0.37-0.53c0,0-20.91,7.27-37.27,24.54c0,0,8.39-6.79,18.59-11.91c1.07-0.54,2.16-1.06,3.27-1.55 c-10.69,6.63-24.19,15.6-33.24,34.94c-3.96,8.47-5.67,15.96-6.02,22.39c0,0.02,0,0.04,0,0.05c-0.01,0.13-0.01,0.26-0.01,0.39 c-0.21,4.78,0.33,8.96,1.24,12.53c2.48,11.45,9.04,26.28,21.88,42.9c0,0-5.84-10.26-9.52-22.28c-0.01-0.04-0.02-0.08-0.04-0.12 c0.35,0.47,0.69,0.93,1.03,1.39c2.58,3.52,4.65,6.54,4.65,6.54s3.22,4.2,10.95,15.41c7.72,11.21,12.88,20.68,12.88,20.68 c7.38,15.46,6.43,27.18,6.57,27.2c0.13,0.02,0.26,0.04,0.39,0.06C265.42,551.67,275.98,542.09,280.06,532.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M339.05,458.64c0,0,12.33-0.18,18.4-4.5c6.07-4.31,8.02-10.81,8.02-10.81l2.76-34.68 c0,0-10.05-15.44-11.04-18.41s-7.92-8.12-7.92-8.12l-19.63-7.92L339.05,458.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M254.52,372.77c0,0,31.3-8.12,61.73-3.05c6.17,2.5,36.4,16.46,38.37,51.23c0,0-4.87-26.8-25.34-40.2 c0,0,32.89,25.34,16.57,70.66c0,0,8.77-34.35-6.82-56.77c0,0,14.14,26.11,4.13,54.73c1.02-8.48,2.16-25.16-2.85-35.64 c0,0,4.58,12.18-0.97,44.36c-0.1,0.18-0.19,0.37-0.29,0.55c-0.69,0.06-1.05,0.14-1.38,0.21c0.87-0.05,1.87-0.12,2.97-0.21 c4.37-0.36,10.21-1.31,14.09-2.98c1.81-0.78,1.85-0.95,2.72-1.52c-0.43,0.8-0.68,1.4-0.68,1.4c0.64-0.64,1.23-1.13,1.77-1.51 c1.52,0.02,2.09,0.86,2.09,0.86s0.78-0.49,1.94-1.54c0.66,0.32,1.24,0.85,1.78,1.39c0,0,0.01-0.03,0.02-0.08 c0.09-0.36,0.43-1.91,0.08-3.19c4.42-4.89,10.68-15.29,7.16-33.02c-1.6-8.06-4.28-14.91-7.77-20.71 c8.84,10.85,9.93,21.05,10.07,23.41c-1.02-33.4-33.84-45.59-40.9-47.83c-5.34-1.96-10.91-3.34-16.51-4.27 c-30.43-5.06-61.73,3.05-61.73,3.05s-4.79,0.39-9.76,3.1l-0.61,0.87C249.5,373.17,254.52,372.77,254.52,372.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M486.08,552.8c-1.49,0.08-2.31-0.66-2.31-2.48c-0.77,1.47-4.02,7.09-4.42,7.77c0,0,0,0,0,0 c-0.02,0.04-0.04,0.07-0.04,0.07c0.1-0.01,0.19-0.02,0.29-0.04c3.52-0.37,5.48-1.49,5.48-1.49c7.18,2.68,8.38-0.86,8.55-1.69 c0.02-0.1,0.03-0.17,0.03-0.17C491.94,555.85,487.57,552.72,486.08,552.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M474.94,595.21c0.07,1.18,2.49-1.56,4.75-2.36c-0.8,0.18-1.74,0.45-2.36,0.79 c-1.65,0.91,0.41-1.32,1.49-1.9s-1.65,1.07-2.81-0.33c-0.61-0.74-1.15-1.57-1.52-2.19c-0.33-0.55-0.54-0.95-0.54-0.95 c0.01,0.03,0.02,0.07,0.04,0.11C474.94,590.77,474.86,593.91,474.94,595.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M301.54,605.98c35.19-1.86,67.89,58.81,80.42,85.83c0,0,19.13,33.76,36.11,46.03 c21.78,15.74,22.12-11.99,22.12-11.99s6.55,5.73,7.37,16.39c0.82,10.65,0,17.2,0,17.2s4.1-18.02,4.1-28.67s4.1-3.28,4.92,6.55 c0.82,9.83,4.1-9.83,3.28-12.29c-0.82-2.46,4.92,0,9.83,4.92c4.92,4.92,21.98,33.48,53.11-3.38c29-34.34,47.29-63.98,52.56-61.29 c-1.39-3.03-3-4.94-4.57-6.17c-0.25-0.19-0.5-0.38-0.75-0.54c-6.41-4.2-15.97,2.02-19.69,4.37 c-68.09,42.96-96.06,55.72-100.87,57.8c-3.6-0.51-12.03-4.01-27.62-22.03c22.53-32.81,40.28-67.63,40.28-67.63 c-0.34-0.94-0.79-1.91-1.32-2.89c0.74-1.11,1.46-2.14,1.91-2.71c0.98-1.23,3.6-3.5,5.73-5.2c0.74-0.59,2.47-1.8,3-2.18 c2.06-1.49,7.45-4.09,9.1-5.17c0.55-0.36,1.11-0.71,1.67-1.07c1.12-0.71,2.26-1.44,3.53-2.31c0.27-0.19,0.57-0.38,0.88-0.58 c1.3-0.81,2.92-1.68,4.19-2.45c0.61-0.37,1.15-0.72,1.52-1.02c1.2-0.97,2.67-2.97,4.29-5.25c0.16-0.23,0.33-0.46,0.49-0.69 c1.82-2.56,6.27-7.01,7.76-8.83c0.02-0.02,0.03-0.04,0.05-0.06c1.44-1.78,1.61-2.87,2.1-6.7c0.41-3.19,1.81-7.04,2.3-8.31 c0.11-0.28,0.17-0.44,0.17-0.44l-2.23,4.62c-0.83-0.58-1.4-1.16-0.99-2.56c0.41-1.4,1.24-3.05,2.39-3.96c0,0-2.48,1.98-2.97,4.13 c-0.49,2.15,1.57,2.39,1.16,3.88s-0.83,6.35-2.06,7.1c-1.24,0.74-2.72,3.47-7.84,8.25c-5.12,4.79-4.46,6.68-10.73,9.82 s-18.48,9.65-26.73,14.27c-1.01,0.56-1.89,1.07-2.66,1.53c-2.41-3.05-5.26-6.05-7.99-8.7c2.47-2.06,5.76-4.31,9.6-5.74 c8.66-3.22,11.61-7.35,8.14-14.4s0.5-13.74,2.85-25c2.35-11.26,2.35-17.45,8.42-24.13c0,0,3.96-5.58,4.75-6.38 c0.79-0.79,3.76,1.29,7.38-3.53c0.24-0.31-4.51,4.32-6.94,2.18c0,0-7.42,6.48-10.76,9.82c-0.46,0.46-0.87,0.85-1.24,1.21 c-2.37,2.27-3.28,2.9-4.45,5.47c0,0,0.28-2.56,0.98-3.83c0.06-0.11,0.13-0.21,0.19-0.3c-0.12,0.13-0.29,0.32-0.51,0.57 c-1.02,1.19-3.04,3.71-5.13,7.27c-0.86,1.48-1.74,2.78-2.65,3.99c-2.21,2.94-4.6,5.21-7.5,7.4c-4.08,3.09-4.95,3.47-4.95,10.64 c0,7.18-1.7,19.9-3.27,24c-0.57,1.5-1.32,2.92-2.04,4.11c1.95,1.66,4.56,4.12,7.36,7.43c0,0-25.36,43.79-32.21,79.14 c0,0-26.05-32.34-36.72-43.08c-0.12,0.1-0.24,0.21-0.36,0.31c-34.14-34.5-58.45-48.07-58.45-48.07c-0.54,0.09-1.07,0.18-1.6,0.27 c-10.14,1.72-19.27,2.78-27.5,3.32C295.25,606.26,298.33,606.15,301.54,605.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M634.47,617.52c-4.62,2.23-7.07-1.9-7.07-1.9s0.92,4.58-2.37,6.63c-3.28,2.04-6.54,6.01-8.15,9.65 s-2.49,3.77-7.08,3.81c-1,0.01-1.77-0.01-2.33-0.03c0.38,0.05,0.84,0.11,1.39,0.21c3.54,0.61-1.56,1.22-5.02,2.72 c1.79-0.61,14.19-2.7,14.19-2.7s0.02-0.12,0.06-0.32c0.04-0.19,0.12-0.47,0.24-0.8c0.21-0.57,0.57-1.29,1.16-2.05 c0.25-0.32,0.52-0.63,0.85-0.95c0.48-0.46,1.13-0.92,1.87-1.4c2.44-1.57,6.01-3.28,8.93-5.39c0.92-0.66,1.7-1.24,2.39-1.77 c2.18-1.68,3.44-2.93,4.84-5.1c1.83-2.84,2.84-5.12,0.92-7.08c-0.01-0.01-0.02-0.03-0.04-0.04 C638.91,612.29,639.08,615.29,634.47,617.52z"
  })))), /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3089.99,
    fill: "#1EBDE4",
    width: 468.97,
    height: 622.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "landscape"
  }, /*#__PURE__*/React.createElement("g", null, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M3183.41,475.89c-23.05-2.56-26.07-19.9-49.05-14.75c-18.22,4.08-26.62-9.17-42.36,0.09 c-2.66,1.56-4.68,3.44-5.73,4.5c3.5,1.17,5.44,3.38,6.38,4.82c4.18-0.69,7.83,0.63,7.83,0.63c3.68-3.88,8.91-3.49,8.91-3.49 c-7.17,1.16-8.72,5.62-8.72,5.62c-9.69-4.46-17.05,3.68-17.05,3.68c2.2-3.87,5.26-5.59,8.17-6.27 c-5.8-4.07-12.7-6.13-22.43-3.53c-4.08,1.38-9.31,3.72-16.24,7.57c-11.48,6.38-44.33,9.88-68.5,10.54l232.94-3.35 C3217.57,481.95,3218.93,479.84,3183.41,475.89z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M3578.88,267.76c-7.4-10.88-23.3-23.82-41.36-15.64c-3.45,1.7-7.29,4.15-11.35,7.67 c0.31,0.08,0.63,0.16,0.95,0.26c4.99,1.57,7.33,4.95,7.33,4.95s15.54-1.25,20.41,11.95c0,0-7.82-12.36-21.33-9.94 c0,0-6-9.69-21.89-4.24c0,0,6.59-4.66,14.08-3.09c1.41-1.91,4.56-5.6,9.8-8.91c-8.62-11.14-18.82-14.52-26.09-15.67 c-19.65-3.1-40.71,3.54-57.89,13.68c-34.4,20.32-65.39,22.22-102.16,33.34l277.61-3.71 C3600.26,277.93,3589.32,261.42,3578.88,267.76z"
  })), /*#__PURE__*/React.createElement("g", null, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D3",
    d: "M3223.97,558.47c0.56,0.24,2.78,0.44,3.39,0.45c1.4,0.02,0.79,2.84,2.14,3.21 c6.95,1.93,6.99,6.67,6.29,11.64c1.9-1.15,5.58-0.82,7.09,0.8c1.51,1.63,2.83,4.86,3.17,7.05c-0.25-1.48,1.26-3.37,2.72-3.7 c1.46-0.34,2.71,0.97,3.12,2.41c2-1.75,4.55-0.3,4.46,2.36c1.71-0.37,3.12,0.23,3.93,1.78c0.84,1.63,1.14,4.59,1.38,6.33 c3.43-0.56,6.69-1.13,8.65,1.96c0.42,0.65,1.51,2.28,1.78,2.99c0.87-0.91,2.02-1.4,3.26-1.34c1.79,0.09,3.44,2.77,2.63,4.37 c0.81-0.69,2.51-2.26,3.57-2.36c1.06-0.11,1.53,0.64,1.38,1.7c0.31-0.97,2.08-0.75,2.9-0.13c0.91,0.68,1.9,2.17,2.81,2.85 c2.55-3.37,5.42-5.15,9.28-3.43c3.99,1.77,3.9,5.13,5.22,9.37c0.62-0.84,0.68-2.92,1.56-2.36c0.67,0.42-0.04,1.65,0.31,2.36 c1.06,2.16,5.88-1.39,6.51,4.46c0.37-0.04,2.04-0.27,2.41-0.31c2.12-0.04,4.25,1.99,5.09,2.81c1.55-4.51,7.6-8.69,12.25-9.88 c-0.93-4.72-0.76-9.88,3.09-12.77c3.85-2.89,7.5-1.39,11.77,0.83c2.18-4.29,9.49-6.61,13.57-4.04 c2.14-6.45,8.07-12.04,14.72-13.44c6.65-1.4,11.12,2.69,15.67,7.73c1.85,2.04,4.23,3.37,6.78,4.4c1.28,0.51,2.16,1.96,3.5,2.26 c3.14,0.71,3.35,3.4,5,6.16c0.58,0.98,3.94-2.03,4.8-1.28c0.2,0.18,4.25,3.67,4.47,3.81c4.02-11.07,14.73-12.72,15.82-14.87 c1.13-2.24,2.5-5.33,3.2-7.73c2.52-8.68,10.38-11.03,19.28-12.97c8.9-1.94,11.89-1.24,17.84,5.59 c0.98,1.12,4.08,1.85,5.47,2.26c4.53-2.75,11.02-2.25,16.3-1.16c1.62,0.34,2.16,0.65,3.69,1.27c2.18,0.79,3.29-0.07,5.11,1.34 c0.75,0.58,0.21,2.72,0.95,3.42c1.52,1.36-1.15,0.1,0.12,1.67c-19.77,10.13-39.49,30.69-39.49,30.69 c18.79-12.84,42.96-18.63,52.34-22.36c3.43-1.26,8.86-3.43,12.61-4.64c35.48-11.47,68.33-16.48,97.31-12.85 c-68.62-54.37-106.28-107.9-46.27-143.82c87.2-52.2-47.31-88.86-40.38-93.43c-27.57,3.61-52.86,23.02-91.34,55.61 c-81.05,68.63-150.12,136-222.98,169.35c0.04,0.04-1.83,1.48-1.79,1.53C3223.11,557.04,3223.14,558.12,3223.97,558.47z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#97B9B8",
    d: "M3129.07,531.98c22.45,1.58,33.03,19.73-1.68,40.95c-34.71,21.21-41.77,33.93-16.06,45.5 c25.71,11.57,8.11,25.06,12.85,36.22c3.59,8.46,29.48,18.75,44.34,20.52c3.37,0,7.48-3.12,10.8-3.12 c4.85-1.22,9.03-2.04,12.49-3.03c0.14-0.15,1.57-0.7,1.72-0.83c1-0.84,2-1.54,3.03-2.34c1.01-0.79,0.56-1.78,1.84-1.7 c0.68,0.04,1.9,0.96,2.53,0.69c0.67-0.29,1.84-1.71,2.11-2.39c0.79-1.97,2.16-2.21,4.16-1.52c0.51-1.7,1.81-2.6,3.21-3.69 c1.4-1.09,1.85-1.97,3.57-1.54c1.94,0.49,1.65,0.92,2.5,2.73c0.66,1.41,1.77,3.28,2.02,4.82c1.01-0.08,4.11-0.29,5.35-0.3 c-0.1-0.58,0.39-2.75,0.48-3.33c0.13-0.93,0.48-2.36,0.3-3.28c-0.41-2.03-1.31-1.29-1.67-3.33c-0.22-1.24,1.67-2.01,1.96-2.68 c0.51-1.18-1.52-4.14-2.2-5.23s-0.11-1.58-0.54-2.8c-0.76-2.19-1.63-3.79-0.77-5.95c0.15-0.39,1.39-0.89,1.37-1.31 c-0.04-0.85-0.43-2.6-0.95-3.27c-1.67-2.17-2.19-3.2,0.18-4.58c2.37-1.38,5.23-2.69,5.23,4.28c0,1.18-0.33,8.03-0.3,14.16 c0.22-0.13,2.34-0.3,2.62-0.3h1.71l0.76-1c-0.03-1.8,0.84-2.4,2.47-3.17c1.63-0.77,3.68,0.49,5.05,1.67 c0.59-2.56,3.3-5.82,5.91-6.08c2.61-0.26,4.62,1.52,6.83,2.94c0.46,0.29,3.24,1.18,3.75,0.98c0.32-0.13,0.44-2.2,0.62-2.5 c1.23-2.05,2.74-3.44,4.28-5.26c1.54-1.82,1.47-2.29,3.84-2.63c2.36-0.34,4.37,0.99,5.35,3.17c1.58-1.2,3.95-2.11,5.89-2.54 c1.94-0.43,3.51-1.87,4.68-0.27c0.93,1.27,1.23,3.64,2.27,4.82c3.36-1.45,7.29-2.92,10.66-1.52c2.06,0.85,3.76,2.42,5.84,3.21 c2.56,0.97,5.28,1.14,8.01,1.25c1.11,0.04,3.16-0.35,4.16,0.18c0.57-1.72,1.49-4.41,1.87-6.2c0.65-3.07,2.12-5.35,5.13-6.25 c0.96-0.29,3.27-0.91,4.26-0.76c-2.36-2.51-3.26-6.63-3.37-10.08c-0.05-1.65-2.51-3.13-1.98-4.68 c-0.84-0.82-2.12-1.34-4.24-1.29c-0.37,0.04-0.75,0.08-1.12,0.12c-0.63-5.85-4.45-1.97-5.51-4.13 c-0.35-0.71-0.33-1.68-1.01-2.1c-0.88-0.55-1.93,0.38-2.55,1.21c-1.32-4.24-0.44-7.19-4.43-8.97c-3.86-1.72-7.3-0.23-9.86,3.13 c-0.91-0.68-1.82-1.36-2.73-2.04c-0.82-0.61-2.29-1.05-2.6-0.07c0.15-1.06-1.07-1.89-2.13-1.79c-1.06,0.11-1.95,0.83-2.76,1.53 c0.81-1.6-0.79-3.64-2.58-3.73c-1.24-0.06-2.39,0.56-3.26,1.46c-0.27-0.71-0.64-1.4-1.05-2.06c-1.97-3.09-5.34-3.98-8.77-3.42 c-0.24-1.75-0.14-3.46-0.97-5.09c-0.8-1.56-2.53-2.78-4.25-2.41c0.09-2.66-3.7-4.46-5.7-2.7c-0.42-1.44-2.06-2.41-3.52-2.07 c-1.46,0.33-2.52,1.92-2.27,3.4c-0.34-2.19-0.96-4.45-2.47-6.08c-1.51-1.63-4.12-2.41-6.02-1.26c0.7-4.97,0.36-11-6.58-12.92 c-1.35-0.37-2.11-2.07-3.5-2.09c-0.61-0.01-1.25,0.18-1.81-0.05c-0.83-0.35-0.86-1.56-1.52-2.18 c-0.04-0.04-0.08-0.08-0.13-0.12c-3.84-3.55-5.05-0.69-6.64-2.87c-1.3-1.78-1.69-3.19-3.15-4.84 c-4.9-5.59-12.45-3.42-16.77-0.93c-1.01-0.02-1.89-0.63-2.84-0.96c-2.02-0.71-4.46,0.01-5.78,1.7 c-3.88-2.51-5.05-4.04-8.59-5.34c-3.13-1.15-8.99-0.74-11.53,1.41c-1.76-2.07-4.78-2.91-7.38-2.18 c-12.72-5.67-24.1-9.04-35.74-9.04c-5.05,0-10.01,0.76-14.98,2.17C3117.67,532.13,3123.59,531.59,3129.07,531.98z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M2938.51,670.59c46.37,0,145.7,0.08,230.47,0.13c-14.86-1.77-38.89-8.95-42.48-17.4 c-4.74-11.16,12.86-23.63-12.85-35.2c-25.71-11.57-16.71-22.5,18-43.71s19.88-40.84-2.57-42.42 c-5.49-0.39-11.41,0.15-18.23,2.04c-18.14,5-42.7,19.51-82.7,51.43c-56.7,45.25-135.25,85.23-135.25,85.23l46.52,0.06 C2938.83,670.64,2938.51,670.59,2938.51,670.59z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#97B9B8",
    d: "M3422.86,600.33c2.13-2.91,5.07-5.23,8.44-6.52c5.39-2.07,11.74-1.47,16.65,1.57 c-2.99-4.62-8.89-7.16-14.3-6.17c-0.17-5.23,3.03-10.43,7.79-12.61c4.76-2.19,10.79-1.25,14.65,2.29 c8.06-5.28,19.39-4.98,27.15,0.73c-2.08-4.31-6.07-7.66-10.68-8.96c1.19-1.52,2.64-2.76,4.26-3.75 c-1.39-0.41-2.42-1.71-3.4-2.83c-5.96-6.83-15.81-10.08-24.71-8.14c-8.9,1.94-16.47,8.98-18.99,17.65 c-0.7,2.41-1.04,4.94-2.18,7.18c-1.09,2.15-11.83,0.31-15.86,11.38c0.75,0.44,1.61,0.69,2.44,1 C3417.73,594.47,3420.83,597.08,3422.86,600.33z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M3571.51,422.73c-60.01,35.92-18.8,88.33,49.83,142.71c-28.98-3.64-61.61-1.78-97.08,9.69 c-3.74,1.21-7.32,2.45-10.74,3.72c-9.38,3.74-26.78,11.54-45.57,24.38c0,0,22.02-17.41,41.79-27.54 c-1.27-1.57-2.67-3.07-4.19-4.42c-0.81-0.72-1.64-1.4-2.51-2.03c-1.8-1.29-3.75-2.37-5.79-3.21c-1.53-0.63-3.11-1.13-4.74-1.46 c-5.28-1.1-11.15-0.4-15.68,2.35c-1.62,0.98-3.07,2.22-4.26,3.75c4.61,1.3,8.6,4.65,10.68,8.96 c-7.76-5.71-19.09-6.02-27.15-0.73c-3.86-3.54-9.89-4.48-14.65-2.29c-4.76,2.19-7.97,7.38-7.79,12.61 c5.41-0.99,11.31,1.55,14.3,6.17c-4.91-3.05-11.26-3.65-16.65-1.57c-3.37,1.29-6.31,3.61-8.44,6.52 c-2.04-3.25-5.13-5.86-8.74-7.19c-0.82-0.3-1.69-0.56-2.44-1c-0.23-0.13-0.45-0.28-0.65-0.46c-0.86-0.75-1.33-1.84-1.91-2.81 c-1.65-2.76-4.46-4.8-7.6-5.51c-1.34-0.3-2.75-0.38-4.02-0.89c-2.55-1.03-4.1-3.56-5.95-5.6c-4.56-5.04-11.87-7.42-18.52-6.02 c-6.65,1.4-12.39,6.52-14.52,12.98c-4.08-2.57-10.2-0.88-12.38,3.41c-4.27-2.23-9.8-1.78-13.65,1.11 c-3.85,2.89-5.84,8.06-4.91,12.79c-4.65,1.19-8.44,4.98-9.99,9.49c-0.53,1.55-0.8,3.18-0.75,4.83c0.11,3.45,1.64,6.75,4,9.27 c2.09,0.32,4.03,1.56,4.91,3.47c0.04,0.02,0.09,0.04,0.13,0.06c0.79-0.18,2.53-0.69,3.31-0.91l2.52-4.12l0.06-1.19l16.18-15.7 l27.12-0.18l1.67-0.12l12.31-0.3h1.9l12.39,1.01l2.54-1.13l11.6,0.42l3.03,0.36l10.44,0.83l1.87-0.71l10.69,0.67l-2.06,9.1 c0.02,0,1.23,0.28,1.25,0.29c-0.02,0.09-1.23-0.38-1.25-0.29c-0.06,0.32,1.29-0.03,1.25,0.29c-2.21-0.38-5.81,0.25-5.65,2.49 c-0.54,0.01,0.15,0.96-0.36,1.13c-0.04,0.01,0.04-0.01,0,0c-1.72,0.63-2.59,2.42-2.99,4.22c-0.04,0.16-1.67,1.38-1.7,1.55 c-0.07,0.41,0.78,0.71,0.58,1.07c-0.28,0.52-1.1,0.87-1.55,1.25c-1.1,0.93-0.38,1.1-1,2.4c-0.22-0.23,0,0-0.24-0.2 c-0.34-0.27-0.21-1.11-0.58-1.33c-1.54-0.89-4.02-1.82-5.78-1.53c-1.69,0.28-4.38,1.66-5.54,2.91 c-0.41,0.44-2.66,1.05-2.96,1.56c-0.05,0.09,0.42,1.26,0.37,1.35c-0.18,0.35,0,0-0.13,0.37c-0.14,0.4-0.29,1.61-0.36,2.03 c-3.36-0.06-6.9,2.61-6.36,5.92c-0.78,0.16-1.25,0.06-1.96,0.42c-1.73,0.87-0.87,1.87-1.78,3.58 c-1.48-1.76-3.43-3.17-5.63-3.64c-0.77-0.16-2.73-0.28-3.53-0.18c-1.39,0.18-4.48,1.93-5.41,2.97c-0.3,0.33-0.86,1.52-1.07,1.9 c-0.6,1.08-1.99,0.94-1.61,2.14c-0.56-0.21,0.58,0.88,0,1.01c-0.38,0.08,0.04,0.7-0.3,0.89c-0.89,0.52-1.97,0.57-2.08,1.61 c-2.05,1.01-3.77,0.05-5.55,1.49c-0.43,0.35-1.59,1.14-2,1.5c-0.28,0.25,0.04,2.16-0.24,2.42c-0.37,0.36-0.07,1.17-0.42,1.55 c-0.12,0.13-1.55-0.13-1.67,0c-2.75,0.76-1.81-0.42-4.82,0.24c-4.33,0.94-4.9,1.87-9.81,2.59c-0.02-5.96-3.48-9.21-3.81-11.91 c-1.2-9.93-5.16-17.75-7.08-27.55c-0.08,0.68-1.63,3.59-1.67,4.28c-0.4,7.01-1.85,9.53-2.97,14.93 c-1.11,5.32-4.63,12.65-2.72,17.67c0.71,1.87-0.51,3.27,0,5.46c-0.78,0.08-1.9-1.46-2.69-1.38c-5.36,0.5-8.36,0.45-14.42,0.71 c-0.36,0.01-1.52,1.68-1.87,1.7c-5.26,0.2-9.61-0.18-15.43-0.18c-0.1,0-0.71,0.71-0.8,0.71c-0.26,0-0.36-0.09-0.62-0.09 c-5.45-0.02-10.74-0.3-16.33-0.62c-0.36-0.02-0.8-0.6-1.16-0.62c-5.58-0.34-10.87-1.11-16.33-1.61 c-0.36-0.03-1.87,0.12-2.23,0.09c-5.31-0.49-10.32-0.82-15.26-1.34c-10.46-1.1-17-0.97-24.18-1.34 c-0.02-3.22-2.41-10.18-2.44-17c-0.03-6.13-0.05-11.64-0.05-12.82c0-6.97-5.65-7.02-8.02-5.64c-2.37,1.38-2.96,4.98-1.29,7.16 c0.52,0.67,1.24,1.3,1.28,2.15c0.02,0.42-0.14,0.82-0.29,1.21c-0.85,2.16-1.76,4.54-1,6.73c0.42,1.22,1.31,2.2,1.99,3.3 c0.68,1.09,1.15,2.47,0.64,3.66c-0.29,0.67-0.88,1.82-0.66,3.06c0.36,2.04,2.01,2.14,2.42,4.16c0.19,0.92-0.17,1.84-0.3,2.77 c-0.08,0.58-0.06,1.17,0.04,1.74c-1.25,0.01-2.38,0.05-3.4,0.13c-0.25-1.55-0.57-3.08-1.24-4.49 c-0.85-1.81-2.35-3.42-4.29-3.91c-1.72-0.43-3.6,0.09-5.01,1.18c-1.4,1.09-2.35,2.69-2.85,4.39c-2.01-0.69-4.46,0.43-5.25,2.4 c-0.27,0.68-0.44,1.51-1.11,1.8c-0.63,0.27-1.33-0.11-2.01-0.15c-1.28-0.08-2.29,0.99-3.31,1.78c-1.03,0.8-2.24,1.37-3.23,2.21 c-0.15,0.13-0.3,0.27-0.44,0.42c-3.46,0.99-7.29,2.09-12.13,3.31c-4.29,1.08-9.38,2.26-15.73,3.54 c-1.98,0.4,337.04,25.44,337.04,25.44l253.46-23.39V445.14c-26.44-18.77-112.56-79.59-137.48-93.13 c-29.57-16.07-51.42-24.43-75.85-22.5c-0.94,0.07-1.55,0.22-1.88,0.43C3531.64,334.51,3658.71,370.53,3571.51,422.73z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M3379.5,658.66c0.27-0.27,0.55-0.53,0.83-0.78h-0.83V658.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 3379.9175,
    y1: 626.1953,
    x2: 3379.9175,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M3379.5,658.66c0.27-0.27,0.55-0.53,0.83-0.78h-0.83V658.66z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M3430.95,603.93v-0.07l-13.73,0.07v-0.07l-13.88,0.07v-0.07l-13.88,0.07v-0.07l-13.59,0.07v-0.07 l-31.61,0.16l-15.66,17.73h-0.38l-0.36,7.46c0.32-0.09,1.12,0.15,1.45,0.09c2.16-0.38,1.93-0.39,3.57,1.07 c1.64,1.46,2.81,3.28,2.68,5.47c-0.02,0.37,2.14,0.88,2.41,1.14c0.29,0.29,1.02,0.94,1.43,0.89c1.95-0.23,2.06-0.42,2.93,1.34 c0.77,1.55-0.36,2.2-0.5,3.93l-11.09-1.52l-2.42,0.89l-78.14-0.27l-18.87,1.71h-2.01c-0.27,0-0.52,0.08-0.74,0.21 c0.03,6.82,0.07,14.41,0.08,17.62c7.18,0.37,16.55,1.4,27.01,2.5v-0.04c4.94,0.52,10.13,1.06,15.44,1.55v0.04 c0.36,0.03,0.72,0.07,1.07,0.1c5.45,0.5,11.03,0.95,16.61,1.29c0.36,0.02,0.72,0.04,1.07,0.06c5.58,0.32,11.16,0.52,16.61,0.54 c0.26,0,0.53,0,0.79,0c0.1,0,0.19,0,0.28,0c5.83,0,11.35-0.11,16.61-0.31c0.36-0.01,0.72-0.03,1.07-0.04 c6.06-0.25,11.75-0.63,17.11-1.13c0.8-0.07,1.59-0.15,2.37-0.23c-0.5-2.2-0.46-4.7-0.47-6.7c-0.02-5.46,2-12.21,3.11-17.52 c1.12-5.4,1.77-7.88,2.18-14.89c0.04-0.69,0.2-1.36,0.28-2.05c1.92,9.8,3.88,16.29,5.07,26.22c0.33,2.7,0.73,7.63,0.74,13.59 c4.92-0.72,9.53-1.56,13.85-2.5c3-0.66,5.87-1.36,8.62-2.12c0.12-0.13,0.23-0.26,0.35-0.39c0.35-0.37,0.71-0.74,1.07-1.09 v-0.78h0.83c0.41-0.37,0.82-0.73,1.25-1.07c1.78-1.44,3.71-2.68,5.76-3.69c0.11-1.03,0.8-1.92,1.69-2.44 c0.33-0.2,0.7-0.34,1.07-0.42c0.58-0.13,1.18-0.11,1.75,0.1c-0.38-1.2-0.16-2.44,0.44-3.52c0.21-0.38,0.47-0.74,0.76-1.07 c0.93-1.04,2.24-1.8,3.62-1.98c0.8-0.1,1.59-0.06,2.36,0.11c2.21,0.47,4.24,1.9,5.72,3.66c0.92-1.71,2.39-3.1,4.13-3.97 c0.71-0.36,1.46-0.63,2.24-0.8c-0.53-3.31,2.44-6.73,5.8-6.67c0.07-0.42,0.17-0.82,0.31-1.22h-8.29v-1.07h8.76 c0.05-0.1,0.11-0.19,0.16-0.28c0.3-0.52,0.66-1,1.07-1.44c1.16-1.25,2.71-2.14,4.4-2.42c1.76-0.29,3.59,0.11,5.13,1 c0.38,0.22,0.74,0.46,1.07,0.74c0.24,0.2,0.47,0.41,0.69,0.64c0.62-1.3,1.51-2.48,2.61-3.41c0.45-0.38,0.95-0.74,1.23-1.25 c0.2-0.36,0.28-0.78,0.35-1.19c0.03-0.17,0.06-0.33,0.1-0.5c0.4-1.8,1.81-3.31,3.54-3.94l0.11-0.04 c0.51-0.17,1.04-0.28,1.57-0.28c-0.16-2.24,2.12-4.31,4.34-3.93c0.04-0.32,0.1-0.63,0.15-0.95v-0.29v-12.41L3430.95,603.93z  M3271.07,661.37h-15.44v-0.04h15.44V661.37z M3271.07,654.39h-15.44v-0.04h15.44V654.39z M3288.75,661.37h-16.61v-0.04h16.61 V661.37z M3288.75,654.39h-16.61v-0.04h16.61V654.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 3413.3853,
    y1: 626.1953,
    x2: 3413.3853,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M3408.9,626.2v17.38c0.71-0.36,1.46-0.63,2.24-0.8c-0.53-3.31,2.44-6.73,5.8-6.67 c0.07-0.42,0.17-0.82,0.31-1.22h-8.29v-1.07h8.76c0.05-0.1,0.11-0.19,0.16-0.28v-7.34H3408.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 3423.7144,
    y1: 626.1953,
    x2: 3423.7144,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M3418.95,626.2v5.9c1.16-1.25,2.71-2.14,4.4-2.42c1.76-0.29,3.59,0.11,5.13,1v-4.47H3418.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 3431.998,
    y1: 626.1953,
    x2: 3431.998,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M3429.56,626.2v5.21c0.24,0.2,0.47,0.41,0.69,0.64c0.62-1.3,1.51-2.48,2.61-3.41 c0.45-0.38,0.95-0.74,1.23-1.25c0.2-0.36,0.28-0.78,0.35-1.19H3429.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 3394.5806,
    y1: 626.1953,
    x2: 3394.5806,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M3399.05,626.2h-8.94v7.62h8.9v1.07h-8.9v10.86h2.95c0.93-1.04,2.24-1.8,3.62-1.98 c0.8-0.1,1.59-0.06,2.36,0.11V626.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 3373.9412,
    y1: 626.1953,
    x2: 3373.9412,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M3369.5,657.88v-1.07h8.92v-9.98h-8.92v-1.07h8.92v-10.86h-8.92v-1.07h8.92v-7.62h-8.97v36.06 c3-0.66,5.87-1.36,8.62-2.12c0.12-0.13,0.23-0.26,0.35-0.39v-1.87H3369.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 3384.2703,
    y1: 626.1953,
    x2: 3384.2703,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M3379.5,646.82v9.98h2.08c1.78-1.44,3.71-2.68,5.76-3.69c0.11-1.03,0.8-1.92,1.69-2.44v-3.85 H3379.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 3391.2053,
    y1: 626.1953,
    x2: 3391.2053,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M3390.11,650.25c0.58-0.13,1.18-0.11,1.75,0.1c-0.38-1.2-0.16-2.44,0.44-3.52h-2.19V650.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 3384.2703,
    y1: 626.1953,
    x2: 3384.2703,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3379.5,
    y: 626.2,
    fill: "url(#SVGID_16_)",
    width: 9.54,
    height: 7.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 3384.2703,
    y1: 626.1953,
    x2: 3384.2703,
    y2: 666.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507,
    style: {
      stopColor: "#E9F8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1867,
    style: {
      stopColor: "#B5E8F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#88D9EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    style: {
      stopColor: "#63CEE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5987,
    style: {
      stopColor: "#46C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    style: {
      stopColor: "#31BEE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#25BAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3379.5,
    y: 634.89,
    fill: "url(#SVGID_17_)",
    width: 9.54,
    height: 10.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 3263.3428,
    y1: 648.1558,
    x2: 3263.3428,
    y2: 670.5804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M3255.62,662.47v1.84c4.94,0.52,10.13,1.06,15.44,1.55v-3.39H3255.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 3280.4475,
    y1: 648.1335,
    x2: 3280.4475,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3272.14,
    y: 648.13,
    fill: "url(#SVGID_19_)",
    width: 16.61,
    height: 6.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 3298.1309,
    y1: 648.1335,
    x2: 3298.1309,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3289.83,
    y: 655.47,
    fill: "url(#SVGID_20_)",
    width: 16.61,
    height: 5.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 3315.814,
    y1: 648.1335,
    x2: 3315.814,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3307.51,
    y: 655.47,
    fill: "url(#SVGID_21_)",
    width: 16.61,
    height: 5.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 3298.1309,
    y1: 648.1335,
    x2: 3298.1309,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3289.83,
    y: 648.13,
    fill: "url(#SVGID_22_)",
    width: 16.61,
    height: 6.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 3280.4475,
    y1: 648.1335,
    x2: 3280.4475,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 3272.14,
    y: 655.47,
    fill: "url(#SVGID_23_)",
    width: 16.61,
    height: 5.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 3263.3428,
    y1: 648.1335,
    x2: 3263.3428,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3255.62,
    y: 655.47,
    fill: "url(#SVGID_24_)",
    width: 15.44,
    height: 5.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 3280.4399,
    y1: 648.1558,
    x2: 3280.4399,
    y2: 670.5804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M3272.13,662.47v3.49c5.45,0.5,11.03,0.95,16.61,1.29v-4.78H3272.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 3298.1309,
    y1: 648.1558,
    x2: 3298.1309,
    y2: 670.5804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M3289.83,662.47v4.84c5.58,0.32,11.16,0.52,16.61,0.54v-5.38H3289.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 3315.814,
    y1: 648.1549,
    x2: 3315.814,
    y2: 670.5796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M3307.51,662.46v5.39c5.83,0,11.35-0.11,16.61-0.31v-5.07H3307.51z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 3263.3503,
    y1: 648.1335,
    x2: 3263.3503,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3255.63,
    y: 648.13,
    fill: "url(#SVGID_28_)",
    width: 15.44,
    height: 6.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 3333.7488,
    y1: 648.1335,
    x2: 3333.7488,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 3325.19,
    y: 648.13,
    fill: "url(#SVGID_29_)",
    width: 17.11,
    height: 6.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 3315.814,
    y1: 648.1335,
    x2: 3315.814,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 3307.51,
    y: 648.13,
    fill: "url(#SVGID_30_)",
    width: 16.61,
    height: 6.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 3333.7488,
    y1: 648.1335,
    x2: 3333.7488,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 3325.19,
    y: 655.47,
    fill: "url(#SVGID_31_)",
    width: 17.11,
    height: 5.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 3333.7488,
    y1: 648.1335,
    x2: 3333.7488,
    y2: 670.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0188,
    style: {
      stopColor: "#EDF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684,
    style: {
      stopColor: "#C3ECF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#9CE0F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#7AD5EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    style: {
      stopColor: "#5ECCE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    style: {
      stopColor: "#48C5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    style: {
      stopColor: "#36C0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#2ABCE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6505,
    style: {
      stopColor: "#23BAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21B9E0"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M3325.19,662.44v5.03c6.06-0.25,11.75-0.63,17.11-1.13v-3.9H3325.19z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED4D3",
    d: "M3313.64,640.76c2.11-1.09,5.03-0.15,6.11,1.96c0.91-0.73,1.93-1.3,3.09-1.45 c2.05-0.27,4.79,1.64,4.14,2.58l1.27,0l16.23,0.03c0.14-1.72,0.26-3.55-0.5-5.1c-0.87-1.76-2.91-2.86-4.85-2.63 c-0.41,0.05-0.88,0.13-1.17-0.16c-0.27-0.26-0.24-0.69-0.21-1.06c0.13-2.19-0.79-4.42-2.43-5.87 c-1.64-1.46-3.96-2.11-6.12-1.73c-0.33,0.06-0.65,0.14-0.98,0.23c-0.78,0.22-1.54,0.5-2.33,0.67 c-0.03,0.01-0.06,0.02-0.09,0.02c-0.01-0.03-0.03-0.05-0.04-0.08c-0.88-1.91-2.82-3.15-4.91-3.47 c-0.99-0.15-2.02-0.1-2.98,0.18c-3.01,0.89-5.22,3.71-5.87,6.78c-0.38,1.79-0.31,3.71-0.87,5.43 C3312.59,637.88,3313.7,639.13,3313.64,640.76z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M3326.97,643.88c0,0,0-0.01,0.01-0.01c0.66-0.94-2.08-2.85-4.14-2.58c-1.15,0.15-2.18,0.72-3.09,1.45 c-1.08-2.12-4-3.05-6.11-1.96c0.07-1.63-1.04-2.88-2.53-3.65c-1.01-0.52-2.19-0.83-3.29-0.87c-2.73-0.11-5.59,0.62-8.14-0.35 c-2.08-0.79-3.64-2.61-5.7-3.46c-3.38-1.4-7.19,0.06-10.55,1.51c-1.05-1.18-1.17-2.94-2.1-4.21c-1.18-1.6-3.45-2.08-5.39-1.65 s-3.62,1.61-5.2,2.81c-0.98-2.18-3.64-3.26-6-2.92c-2.36,0.34-4.42,1.86-5.96,3.69c-1.54,1.82-2.66,3.96-3.89,6.01 c-0.18,0.3-0.39,0.62-0.71,0.75c-0.5,0.2-1.05-0.13-1.51-0.42c-2.21-1.43-4.8-2.44-7.42-2.17c-2.61,0.26-5.18,2.04-5.77,4.6 c-1.37-1.17-3.44-1.45-5.07-0.69c-1.63,0.77-3.17,2.35-3.14,4.16v0.07L3326.97,643.88z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M3408.95,634.89h8.29c0.13-0.37,0.28-0.73,0.47-1.07h-8.76V634.89z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEE7F5",
    d: "M3778.61,744.88v-13.06c0-6.01,0,0,0-6.01v-0.23c0,0-0.08-34.71,0-56.67c0,0-131.92,4.46-153.89,3.76 c-97.12,0-210.46,1.74-238.05,1.74c-79.88,0-57.81-4.75-92.04-4.75c-25.62,0-26.16,3.01-32.09,3.01 c-3.28,0-12.97-3.85-27.86-3.85c-18.07,0-56.56-1.24-108.75-1.24c-33.11,0-69.12,1.06-95.77,1.06 c-28.13,0-56.56-3.92-64.59-5.12l-47.86-0.26c0,0,92.16,12.15,184.19,124.63c70.96,86.73,103.97,113.03,124.89,127.59 c194.4,135.36,457.8,74.45,551.81,45.56V757.12C3778.61,744.88,3778.61,757.12,3778.61,744.88z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 3246.84,
    cy: 379.97,
    r: 44.95
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    opacity: 0.3,
    d: "M3332.15,654.3h-16.5h-75.69c0.8,0,1.45,0.65,1.45,1.45v17.89 c1.21,0.13,2.44,0.26,3.68,0.39v-1.79h14.99v3.3c0.35,0.03,0.69,0.06,1.04,0.1v-3.39h16.13v4.64c0.35,0.02,0.69,0.04,1.04,0.06 v-4.7h16.13v5.23c0.26,0,0.51,0,0.77,0c0.09,0,0.18,0,0.28,0v-5.23h16.13v4.92c0.35-0.01,0.7-0.03,1.04-0.04v-4.88h16.62v3.78 c0.77-0.07,1.54-0.15,2.31-0.22c-0.49-2.13-0.45-4.56-0.45-6.51c-0.01-4.44,1.36-9.75,2.43-14.39 C3333.19,654.53,3332.7,654.3,3332.15,654.3z M3260.09,671.21h-14.99v-5.73h14.99V671.21z M3245.1,664.43v-6.08h14.99v6.08 H3245.1z M3277.26,671.21h-16.13v-5.73h16.13V671.21z M3261.13,664.43v-6.08h16.13v6.08H3261.13z M3294.42,671.21h-16.13v-5.73 h16.13V671.21z M3278.3,664.43v-6.08h16.13v6.08H3278.3z M3311.59,671.21h-16.13v-5.73h16.13V671.21z M3295.47,664.43v-6.08 h16.13v6.08H3295.47z M3312.64,671.21v-5.73h16.62v5.73H3312.64z M3329.25,664.43h-16.62v-6.08h16.62V664.43z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3230.82,647.87v14.04c5.03,0.33,10.97,0.92,17.5,1.6v-15.64H3230.82z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3361.84,621.8h0.06v41.96c2.61-0.46,5.13-0.95,7.56-1.48v-36.06h8.97v7.62h-8.92v1.07h8.92v10.86h-8.92 v1.07h8.92v9.98h-8.92v1.07h8.92v1.87c0.35-0.37,0.71-0.74,1.07-1.09v-0.78h0.83c0.41-0.37,0.82-0.73,1.25-1.07h-2.08v-9.98 h9.54v3.85c0.33-0.2,0.7-0.34,1.07-0.42v-3.42h2.19c0.21-0.38,0.47-0.74,0.76-1.07h-2.95V634.9h8.9v-1.07h-8.9v-7.62h8.94v17.69 c2.21,0.47,4.24,1.9,5.72,3.66c0.92-1.71,2.39-3.1,4.13-3.97v-17.38h8.97v7.34c0.3-0.52,0.66-1,1.07-1.44v-5.9h9.54v4.47 c0.38,0.22,0.74,0.46,1.07,0.74v-5.21h4.88c0.03-0.17,0.06-0.33,0.1-0.5c0.52-2.37,2.8-4.23,5.23-4.27 c-0.16-2.24,2.12-4.31,4.34-3.93c0.02-0.15,0.05-0.29,0.07-0.44l-0.03-13.21v0l0,0l-13.19,17v0.85l-0.07,0l-0.03-17.85v0l0,0 l-13.63,17.55v0.29l-0.07,0l-0.03-17.85v0l0,0l-13.77,17.74v0.11l-0.07,0l-0.03-17.85v0l0,0l-13.77,17.74v0.11l-0.07,0 l-0.03-17.85v0l0,0l-13.48,17.37v0.48l-0.07,0l-0.03-17.85v0l0,0L3361.84,621.8z M3389.04,645.76h-9.54V634.9h9.54V645.76z  M3389.04,633.83h-9.54v-7.62h9.54V633.83z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3385.99,722.98c-17.49,0-39.83,0-61.21,0c-21.37,0-5.54,7.64,15.97,7.64c0.97,0,1.73,0,2.31,0 c0.04,0,0.48,0,1.71,0c1.84,0,5.44,0,12.07,0C3395.7,730.63,3403.48,722.98,3385.99,722.98z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3409.37,764.53c27.79,0,295.17,0,344.41,0v-12.24c-47.96,0-305.43,0-339.85,0 C3375.95,752.29,3378.75,764.53,3409.37,764.53z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3513.19,739.23c25.56,0,201.32,0,240.59,0v-6.01c-37.93,0-204.69,0-236.31,0 C3481.75,733.22,3484.38,739.23,3513.19,739.23z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3163.28,674.26c6.35-1.28,11.44-2.46,15.73-3.54c-3.32,0-6.66,0-10.03-0.01 c-84.77-0.05-184.1-0.13-230.47-0.13c0,0,0.31,0.05,0.9,0.14c0.35,0.05,0.8,0.12,1.33,0.2c8.03,1.2,36.45,5.12,64.59,5.12 c26.64,0,62.09,3.71,95.2,3.71c52.2,0,92.38,0,110.45,0c14.88,0,35.89,4.73,21.22,4.73c-6.52,0-13.77,0.29-23.59,0.29 c-24.72,0-23.79,6.76,1.82,6.76c34.23,0,86.59,0,166.47,0c27.59,0,17.46,6.67,7.33,6.67c-10.55,0-26.63,0.47-35.62,0.47 c-14.26,0-29.2,4.27-20.19,6.52c5.4,1.35,28.81,1.16,39.86,1.16c15.17,0,118.92,0,216.04,0c43.93,1.41,25.54,7.21,3.98,7.21 c-24.54,0-32.04,1.16-40.9,1.16s-21.13,8.68,12.27,8.68c16.82,0,67.91,0,114.49,0c16.76,1.65,12.68,9.12-7.72,9.59h87.33v-56.67 l-249.26-2.05C3504.52,674.26,3161.3,674.66,3163.28,674.26z M3283.73,684.56c-16.56,0-21.84-1.92,3.76-1.92 C3309.33,682.64,3300.3,684.56,3283.73,684.56z M3311.18,687.96c-6.56,0-8.65-1.2,1.49-1.2 C3321.32,686.76,3317.74,687.96,3311.18,687.96z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3166.57,708.24c-0.01,0.43-0.02,0.86-0.03,1.29c0.88-1.05,1.8-2.14,2.76-3.22 c-0.85,0.22-1.76,0.46-2.7,0.72C3166.58,707.43,3166.58,707.83,3166.57,708.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3167.81,937.5c-1.54-0.94-3.05-1.9-4.54-2.87c2.33,1.86,4.74,3.71,7.23,5.56 C3169.56,939.3,3168.67,938.4,3167.81,937.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3184.02,720.56c2.18,3.8,4.41,8.11,5.03,9.32c3.01,1.87,5.74,2.84,8.38,3.65 c-4-7.25-10.12-10.16-11.16-17.1C3186.27,716.44,3185.58,717.99,3184.02,720.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2976.64,383.37c-0.46,4.21-0.92,8.56-1.36,13.07C2975.88,392.55,2976.31,388.72,2976.64,383.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3008.53,809.26c-13.79-2.04-27-3.8-37.49-6.33C2979.27,805.35,2990.98,807.47,3008.53,809.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3073.59,827.87c3.47,2.76,6.76,5.89,10.27,9.45C3081.15,833.71,3077.66,830.59,3073.59,827.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3360.26,937c32.19,4.36,63.92,7.93,94.09,10.62c-35.24-4.35-77.87-12.22-108.21-26.38 c-37.13-17.33-27.17-46.9-14.43-67.29c0,0-0.06,0.08-0.17,0.21c-5.62,9.51-16.61,20.42-27.13,36.38 C3289.15,913.73,3310.93,927.76,3360.26,937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M2895.08,726.38c31.19,5.88,31.77,40.88,54.77,64.23c4.58,4.65,9.2,8.79,21.18,12.32 c10.49,2.54,23.71,4.29,37.49,6.33c1.04,0.11,2.09,0.21,3.17,0.31c34.95,3.35,49.57,8.5,61.89,18.3 c4.07,2.71,7.56,5.83,10.27,9.45c0.4,0.4,0.79,0.81,1.19,1.22c11.35,11.65,26.32,54.75,78.22,96.09 c1.49,0.97,3.01,1.93,4.54,2.87c-48.84-51.34,23.21-113.99-18.1-150.85c-3.46-4.07-4.97-9.56-5.74-14.93 c-0.02-0.11-0.17-0.11-0.19,0c-0.27,2.3-0.46,4.6-0.57,6.91c0,0.09-0.12,0.12-0.17,0.04c-1.95-3.18-2.93-6.85-3.85-10.48 c-0.03-0.1-0.17-0.09-0.18,0.01c-0.26,2.54-0.38,5.09-0.35,7.64c0,0.1-0.15,0.14-0.17,0.04c-1.75-6.16-3.87-9.3-4.33-9.1 c-0.2,0.09,1.3,3.66,1.35,6.26c0,0.08-0.1,0.13-0.16,0.07c-1.72-1.56-2.68-4.45-3.14-6.39c-0.02-0.1-0.18-0.08-0.18,0.02 c-0.05,2.57,0.27,5.15,0.96,7.64c0.03,0.1-0.1,0.16-0.16,0.08c-1.29-1.68-2.38-3.53-3.22-5.47c-0.04-0.09-0.17-0.07-0.18,0.03 c-0.11,1.99,0.2,3.94,0.81,5.82c-7.55-3.23-16.68-6.12-27.7-8.62c-36.58-8.3-61.53-19.96-77.68-33.21 c-0.94-1.66-1.47-3.61-1.73-5.51c-0.44-3.28-0.27-6.67-1.08-9.87c-0.03-0.12-0.21-0.12-0.24,0c-0.73,2.67-1.22,5.41-1.45,8.18 c-0.01,0.13-0.2,0.15-0.23,0.03c-0.76-2.6-1.32-5.26-1.67-7.95c-0.02-0.14-0.22-0.14-0.23,0l-0.36,3.87 c-0.01,0.12-0.19,0.15-0.23,0.04c-1.27-3.09-1.87-6.45-1.74-9.78c0.01-0.14-0.2-0.17-0.24-0.03c-0.83,2.94-1.06,6.05-0.68,9.09 c0.02,0.14-0.18,0.19-0.23,0.06c-0.89-2.36-1.6-4.78-2.12-7.25c-0.03-0.14-0.24-0.12-0.23,0.03l0.13,3.96 c0,0.12-0.15,0.17-0.22,0.07c-1.49-2.19-2.36-4.8-2.47-7.45c-0.01-0.14-0.21-0.16-0.24-0.02c-0.42,1.9-0.47,3.84-0.24,5.77 c-9.69-14.54-11.37-29.98-8.05-44.42c12.12-52.72-45.62-53.45-18.77-52.8c6.42,0.15,12.56,0.54,18.46,1.12 c19.54,2.52,34.25,6.06,44.71,9.3c4.25,1.42,8.34,2.95,12.28,4.59c0.02-0.07,0.04-0.15,0.06-0.22c5.57,2.27,8.16,3.84,8.16,3.84 c-1.13-5.97-3.08-10.59-5.45-14.17c4.43-18.89,6.49-39.41,6.04-55.26c-0.85-30.1-3.22-72.83-14.29-118.92 c-6.93-28.84-7.27-50.24-9.78-64.63c-1.5-8.62-1.5-14.65-3.01-6.03c-1.5,8.62-11.07,20.83-10.53,49.98 c0.38,20.8-3.05,29.09-5.42,45.11c-0.78-9-1.71-17.24-2.77-24.31c-8.08-53.46-10.55-54.04-17.05-93.56 c-8.2-49.86-5.81-58.48-9.45-62.58c-4.27,7.54-11.97,36.96-17.84,90.08c-0.33,5.35-0.76,9.18-1.36,13.07 c-4.14,42.48-7.03,98.25-6.48,168.07c-0.58,0.02-1.17,0.06-1.76,0.11c0.01,0.07-0.01-0.07,0,0c-2.79,0.14-5.78,0.9-9.03,1.92 c-22.86,7.2-20.13,33.9-20.13,33.9s-12.58,0.24-16.74,16.58c0,0-19.42-7.86-37.09,8.79c-10.1,9.52-11.49,26.04-11.49,26.04 s-15.83,4.87-20.45,31.36c-19.18,22.62-38.26,48.43-65.71,72.57c-1.33,1.17-4.27,5,8.22,2.05 C2864.73,736.76,2869.91,721.63,2895.08,726.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M3223.81,777.23c0.08,0.23,0.15,0.47,0.23,0.7c-0.01-0.58-0.01-1.01-0.28-1.29 c-0.01,0.03-0.02,0.05-0.02,0.08C3223.71,776.89,3223.76,777.07,3223.81,777.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M3224.54,779.19c-0.04-0.03-0.08-0.06-0.12-0.09c0.01,0.03,0.02,0.05,0.02,0.08 C3224.48,779.18,3224.51,779.19,3224.54,779.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M3222.86,780.17c0.05-0.03,0.1-0.07,0.14-0.11c0.05-0.05,0.08-0.11,0.1-0.17 c-0.12-0.01-0.24-0.03-0.34-0.08C3222.79,779.93,3222.83,780.05,3222.86,780.17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0DAC7",
    points: "3222.9,778.6 3222.9,778.6 3222.9,778.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M3221.85,776.97c-0.17-0.09-0.34-0.18-0.5-0.27c-0.09-0.05-0.17-0.12-0.25-0.19 c0.03,0.12,0.06,0.24,0.13,0.34C3221.38,777.06,3221.63,777.11,3221.85,776.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C3B4A",
    d: "M3053.21,709.24c0,0-0.76-3.56-2.39-7.72c-1.58-4.04-3.98-8.64-7.31-11.11 c-6.89-5.1,0.04,2.22,2.19,11.06c0.3,1.22,0.51,2.47,0.57,3.73L3053.21,709.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M3137.56,705.43c1.13,8.12-1.54,12.69-2.42,18.3c-0.76,3.03-0.77,6.04,0.37,8.76 c0,0.01,0.01,0.01,0.01,0.02c4.42,2.02,12.57,5.82,20.83,10.07c0.37,3.01,0.64,4.92,1.61,7c0.07,0.14,0.13,0.28,0.21,0.43 c0.76,1.5,2.84,0.95,4.24,0.36c0.16-0.07,0.29-0.15,0.43-0.24c0.53-0.38,0.85-0.98,0.81-1.62c-0.04-0.62-0.05-1.33-0.04-2.1 c0.01-1.3,0.09-2.8,0.2-4.45c2.05-0.85,4.05-2.19,6.21-4.11c0.03,0.03,0.04,0.04,0.04,0.04c1.35-1.15,2.51-2.14,3.53-3.01 c0.09-0.12,0.19-0.25,0.32-0.37c1.67-1.56,3.82-5.12,6.94-5.87c3.61-0.87,8.12,1.2,8.08,1.17c0.04,0.03,0.08,0.05,0.12,0.07 c-0.62-1.21-2.84-5.52-5.03-9.32c1.56-2.58,2.25-4.12,2.25-4.12c1.04,6.93,7.15,9.85,11.16,17.1c3.33,1.03,6.51,1.83,9.89,3.9 c0.14,0.06,0.26,0.11,0.35,0.14c-5.01-7.82-8.28-29.22-14.77-38.36c-1.66-2.34-3.54-3.88-5.71-4.17 c-2.74-0.37-5.58,0.68-8.38,2.51c-0.14-0.08-0.29-0.14-0.46-0.18c-3.1-0.68-7.26-0.43-11.65,0.04 c-0.06-6.72-0.6-8.68-2.19-10.99c0.02-0.03,0.03-0.05,0.03-0.05c-0.21-0.26-0.42-0.51-0.61-0.75c-0.22-0.3-0.46-0.61-0.72-0.94 c-0.04-0.05-0.09-0.1-0.13-0.15c-1.24-1.61-2.34-3.02-4.48-4.58c-0.17,0.3-0.34,0.62-0.49,0.95c-0.36,0.97-0.77,2.17-1.16,4.05 c-0.7,3.45-0.34,6.11-0.34,6.11s-0.85-3.23,0.69-8.49c-0.19,0.53-2.43,6.87-1.62,10.22c0,0-0.44-0.62-0.67-2 c-0.08,1.26-0.03,2.1-0.03,2.1s-0.58,0-1.52-0.09c-0.01-0.82,0.02-3.6,0.92-6.17c0,0-1.29,2.27-1.26,6.14 c-0.43-0.05-0.91-0.11-1.43-0.2c-3.29-0.56-8.19-2.11-10.62-6.34c-2.9-3.1-1.77-8.4,1.94-9.91c1.35-0.55,2.21-1.38,2.74-2.35 c-4.79-1.05-8.45,0.34-9.95,7.07c-0.7,3.16-0.97,5.25-0.93,7.21C3134.93,692.13,3136.17,695.46,3137.56,705.43z M3166.53,709.54 c0.01-0.43,0.03-0.87,0.03-1.29c0.01-0.41,0.02-0.81,0.02-1.21c0.94-0.26,1.85-0.5,2.7-0.72 C3168.34,707.4,3167.42,708.48,3166.53,709.54z M3181.56,700.09c1.92,1.32,1.92,1.89,2.31,3.2c0.39,1.32,1.03,2.74,0.96,3.42 c-0.05,0.45-0.35,0.96-0.54,1.25c0.04,0.75-0.14,1.41-0.59,2.06c0,0-1.36,1.7-1.49,1.08c-0.14-0.61,0.68-1.83,0.47-2.71 c-0.19-0.8-1.36-4.81-1.22-3.93c0.14,0.88,0.81,2.71,0.68,3.66c-0.09,0.6-0.12,1.68-0.21,2.69c-0.06,0.59-0.14,1.16-0.26,1.59 c-0.34,1.15-1.1,0.47-1.16,0.16c-0.09-0.54,0-0.29-0.06-1.72c-0.07-1.42-0.68-6.37-0.68-6.37s0.27,2.31,0.34,4.07 c0.07,1.76-0.22,3.29-0.56,3.56c-0.26,0.21-0.54,0.39-0.73-0.22c0-0.03-0.01-0.06-0.01-0.1c-0.17-0.99-0.02-2.66-0.17-3.45 c-0.11-0.59-0.24-2.39-0.35-3.54c-0.05-1.02-0.16-1.53-0.48-0.93c-0.47,0.88-0.41,2.58-0.41,4c0,1.42-1.29,2.31-1.15,1.15 c0.14-1.15,0-2.1-0.54-3.46c-0.54-1.36,0-3.12,0.14-4.2s1.5-3.4,3.12-3.25C3180.12,698.19,3179.64,698.77,3181.56,700.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3207.93,737.83c-0.03-0.06-0.06-0.11-0.09-0.17c0,0-0.07-0.03-0.18-0.08 c-0.09-0.04-0.21-0.09-0.35-0.14C3207.51,737.56,3207.72,737.69,3207.93,737.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3226.01,745.56c0.01,0.01,0.01,0.02,0.02,0.02c-0.01-0.11-0.01-0.22,0-0.34 C3226.02,745.35,3226.02,745.46,3226.01,745.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3163.64,748.51c0.04,0.64-0.28,1.23-0.81,1.62c0.19,0.57,0.41,0.94,0.59,1.23 c0.38,0.6,0.73,0.71,1.01,1.38c0.28,0.66,0.75,1.57,1.56,1.83c1.53,0.5,2.57,0.36,1.87,0.89c-0.67,0.51-1.79,0.55-3.3,0.17 c-1.49-0.37-1.87-0.75-2.43-0.5c-1.09,0.79-1.25,1.33-1.55,2.47c-0.48,1.77-0.53,2.59-1.27,4.32c-0.22,0.51-0.29,1.49-0.99,1.39 c-0.95-0.2-0.14-1.6-0.02-2.08c0.5-2.01,0.54-2.61,1.04-4.62c-1.21,0.56-1.34,3.94-3.43,6.68c-0.26,0.12-0.87-0.01-0.92-0.45 c-0.05-0.45,0.47-1.69,0.63-2.14c0.95-2.56,0.94-2.43,1.88-4.99c-1.03,1.8-1.63,2.23-2.66,4.03c-0.47,0.81-0.91,1.92-1.67,1.46 c-0.5-0.59,0.14-1.49,0.44-2.02c1.11-1.92,0.93-1.66,2.04-3.58c-1.45,1.74-2.95,4.14-3.64,2.87c-0.25-0.78,2.69-3.01,4.06-5.59 c0.43-0.8,0.66-1.66,1.16-2.44c0.2-0.3,0.45-0.6,0.74-0.85c-0.97-2.08-1.23-3.98-1.61-7c-8.26-4.24-16.42-8.05-20.83-10.07 c0-0.01-0.01-0.01-0.01-0.02c-24.15-11-42.82-18.31-63.04-25.53c-9.46-3.38-16.55-4.99-21.65-5.44 c1.63,4.16,2.39,7.72,2.39,7.72l-6.93-4.04c-0.07-1.25-0.28-2.5-0.57-3.73c-3.25,0.32-4.99,1.39-5.48,2.75 c-0.03-0.01-0.05-0.02-0.05-0.02c-1.58,2.18-0.85,9.26,12,18.89c9.62,7.21,30.81,17.62,59.93,30.07 c20.42,4.35,37.68,8.58,50.81,16.16c6.37,3.68,12.51,7.81,18.41,11.71c0.4,0.15,0.8,0.31,1.2,0.46 c22.39,8.61,30.17,8.54,30.39,5.2c0.07-0.37,0.03-0.82-0.13-1.37c-3.56-11.95-27.71-27.25-47.95-38.24 c-0.41-0.23-0.82-0.45-1.23-0.68C3163.59,747.18,3163.6,747.88,3163.64,748.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3157.21,750.43c-0.5,0.78-0.73,1.64-1.16,2.44c-1.37,2.57-4.31,4.8-4.06,5.59 c0.69,1.27,2.2-1.13,3.64-2.87c-1.11,1.92-0.93,1.66-2.04,3.58c-0.31,0.53-0.94,1.43-0.44,2.02c0.76,0.46,1.21-0.65,1.67-1.46 c1.03-1.8,1.63-2.23,2.66-4.03c-0.95,2.56-0.94,2.43-1.88,4.99c-0.17,0.45-0.69,1.69-0.63,2.14c0.05,0.45,0.66,0.57,0.92,0.45 c2.1-2.74,2.22-6.12,3.43-6.68c-0.5,2.01-0.54,2.61-1.04,4.62c-0.12,0.48-0.93,1.87,0.02,2.08c0.7,0.1,0.77-0.88,0.99-1.39 c0.75-1.73,0.8-2.55,1.27-4.32c0.31-1.13,0.46-1.68,1.55-2.47c0.56-0.25,0.93,0.12,2.43,0.5c1.51,0.38,2.63,0.35,3.3-0.17 c0.7-0.53-0.34-0.39-1.87-0.89c-0.81-0.26-1.28-1.17-1.56-1.83c-0.28-0.67-0.63-0.78-1.01-1.38c-0.18-0.29-0.4-0.66-0.59-1.23 c-0.13,0.09-0.27,0.18-0.43,0.24c-1.4,0.59-3.48,1.14-4.24-0.36c-0.07-0.14-0.14-0.29-0.21-0.43 C3157.66,749.83,3157.41,750.12,3157.21,750.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3164.62,666.22c-0.2,0.36-0.39,0.69-0.56,1.01c-0.43-0.71-0.99-0.75-1.33-0.34 c-0.3,0.37-0.54,2.29-0.03,3.86c-0.04,0.24-0.07,0.48-0.08,0.74c-0.23,3.36-1.69,4.96-3.08,6.97c2.76,0.14,3.79-0.85,4.28-3.12 c0.31-1.42,1.12-2.62,1.3-4.04c0.18-1.42-0.04-1.9,0.53-4.46c0.2-0.9,0.25-1.55,0.23-2.11 C3165.58,665.24,3165.17,665.75,3164.62,666.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3178.96,698.09c-1.62-0.14-2.98,2.17-3.12,3.25s-0.68,2.85-0.14,4.2c0.54,1.36,0.68,2.31,0.54,3.46 c-0.14,1.15,1.15,0.27,1.15-1.15c0-1.42-0.07-3.12,0.41-4c0.32-0.59,0.42-0.08,0.48,0.93c0.12,1.15,0.24,2.94,0.35,3.54 c0.15,0.79,0,2.46,0.17,3.45c0.01,0.04,0.01,0.07,0.01,0.1c0.18,0.61,0.47,0.43,0.73,0.22c0.34-0.27,0.63-1.8,0.56-3.56 c-0.07-1.76-0.34-4.07-0.34-4.07s0.61,4.95,0.68,6.37c0.07,1.42-0.03,1.18,0.06,1.72c0.05,0.31,0.82,0.99,1.16-0.16 c0.13-0.43,0.2-0.99,0.26-1.59c0.1-1.01,0.13-2.09,0.21-2.69c0.14-0.95-0.54-2.78-0.68-3.66c-0.14-0.88,1.03,3.13,1.22,3.93 c0.2,0.88-0.61,2.1-0.47,2.71c0.14,0.61,1.49-1.08,1.49-1.08c0.45-0.66,0.63-1.32,0.59-2.06c0.2-0.29,0.49-0.8,0.54-1.25 c0.07-0.68-0.57-2.1-0.96-3.42c-0.39-1.32-0.39-1.89-2.31-3.2S3180.12,698.19,3178.96,698.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M3143,676.34c-3.71,1.51-4.84,6.81-1.94,9.91c2.43,4.23,7.33,5.78,10.62,6.34 c0.52,0.09,1.01,0.15,1.43,0.2c-0.03-3.87,1.26-6.14,1.26-6.14c-0.9,2.57-0.94,5.35-0.92,6.17c0.94,0.09,1.52,0.09,1.52,0.09 s-0.05-0.85,0.03-2.1c0.22,1.37,0.67,2,0.67,2c-0.81-3.35,1.43-9.69,1.62-10.22c-1.54,5.25-0.69,8.49-0.69,8.49 s-0.37-2.66,0.34-6.11c0.38-1.88,0.79-3.08,1.16-4.05c0.16-0.34,0.32-0.65,0.49-0.95c0.3-0.54,0.62-1.03,0.95-1.5 c1.4-2.01,2.85-3.61,3.08-6.97c0.02-0.26,0.05-0.5,0.08-0.74c-0.52-1.57-0.28-3.49,0.03-3.86c0.34-0.41,0.91-0.36,1.33,0.34 c0.17-0.32,0.36-0.65,0.56-1.01c0.55-0.47,0.96-0.98,1.26-1.5c1.23-2.12,0.72-4.55,0.14-6.02c-0.03-0.09-0.07-0.19-0.1-0.29 c0,0-1.33-3.71-5.16-4.92c-1.38-0.43-2.12-0.74-4.2-0.73c-8.33,0.04-11.43,6.21-10.39,15.33l-0.01,0 c0.01,0.05,0.01,0.09,0.02,0.14c0.05,0.43,0.11,0.87,0.18,1.32c0.16,1.55,0.07,3.13-0.64,4.44 C3145.21,674.96,3144.36,675.79,3143,676.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0DAC7",
    d: "M3589.13,953.41c-21.36,0.49-46,0.01-72.87-1.37c-5.11-0.5-10.45-0.91-16.06-1.23 c-10.3-0.58-20.28-1.19-29.92-1.83c-5.26-0.42-10.57-0.87-15.93-1.35c-30.18-2.69-61.9-6.26-94.09-10.62 c-49.32-9.24-71.11-23.27-55.84-46.45c10.52-15.97,21.5-26.88,27.13-36.38c4.45-7.53,5.54-14.17,0.36-21.76 c-8.5-16.18-30.81-37.18-48.34-43.59c-14.29-5.22-18.16-3.88-22.97-5.51c-0.81-0.53-1.61-1.06-2.42-1.59 c0.01,0.03,0.01,0.06,0.02,0.1c-25.05-16.03-35.12-26.75-37.54-29.55c-1.75-2.69-3.61-5.5-6.3-8.63 c-2.27-2.65-4.39-4.47-6.42-5.8c-0.21-0.14-0.42-0.27-0.62-0.39c-3.37-2.07-6.55-2.86-9.89-3.9c-2.63-0.82-5.37-1.78-8.38-3.65 c-0.04-0.03-0.08-0.05-0.12-0.07c0.04,0.03-4.47-2.04-8.08-1.17c-3.13,0.75-5.27,4.31-6.94,5.87c-0.13,0.12-0.23,0.24-0.32,0.37 c-1.01,0.86-2.18,1.85-3.53,3.01c0,0-0.02-0.02-0.04-0.04c-2.16,1.92-4.17,3.26-6.21,4.11c-0.12,1.65-0.19,3.15-0.2,4.45 c0.41,0.23,0.83,0.45,1.23,0.68c20.24,11,42.36,25.56,46.47,35.11c0.22,0.52,0.2,4,0.13,4.37c-0.22,3.34-6.51,3.53-28.91-5.07 c-0.4-0.15-0.8-0.31-1.2-0.46c-5.9-3.9-12.04-8.02-18.41-11.71c-13.13-7.59-30.39-11.81-50.81-16.16 c-29.11-12.45-50.31-22.86-59.93-30.07c-12.85-9.63-13.59-16.71-12-18.89c0,0,0.02,0.01,0.05,0.02 c0.49-1.36,2.22-2.43,5.48-2.75c-2.16-8.84-9.08-16.16-2.19-11.06c3.33,2.47,5.73,7.07,7.31,11.11 c5.1,0.46,12.19,2.06,21.65,5.44c20.22,7.22,38.89,14.54,63.04,25.53c-1.15-2.73-1.13-5.73-0.37-8.76 c0.88-5.62,3.55-10.18,2.42-18.3c-1.39-9.97-2.63-13.3-2.7-17.16c-20.59-18.92-43.36-40.28-76.89-54.23 c-3.94-1.64-8.03-3.17-12.28-4.59c-10.46-3.24-25.17-6.78-44.71-9.3c-5.91-0.58-12.05-0.96-18.46-1.12 c-26.85-0.65,30.9,0.08,18.77,52.8c-3.32,14.43-1.64,29.87,8.05,44.42c-0.23-1.93-0.18-3.88,0.24-5.77 c0.03-0.14,0.23-0.12,0.24,0.02c0.12,2.65,0.98,5.26,2.47,7.45c0.07,0.1,0.22,0.05,0.22-0.07l-0.13-3.96 c0-0.15,0.2-0.17,0.23-0.03c0.52,2.47,1.22,4.89,2.12,7.25c0.05,0.13,0.25,0.08,0.23-0.06c-0.39-3.03-0.15-6.15,0.68-9.09 c0.04-0.14,0.24-0.11,0.24,0.03c-0.12,3.33,0.47,6.69,1.74,9.78c0.05,0.12,0.22,0.09,0.23-0.04l0.36-3.87 c0.01-0.14,0.22-0.14,0.23,0c0.35,2.69,0.9,5.35,1.67,7.95c0.04,0.13,0.22,0.11,0.23-0.03c0.23-2.76,0.71-5.5,1.45-8.18 c0.03-0.12,0.21-0.12,0.24,0c0.81,3.2,0.64,6.59,1.08,9.87c0.25,1.9,0.79,3.85,1.73,5.51c16.16,13.24,41.11,24.91,77.68,33.21 c11.02,2.5,20.15,5.39,27.7,8.62c-0.61-1.88-0.92-3.84-0.81-5.82c0.01-0.1,0.14-0.12,0.18-0.03c0.84,1.95,1.93,3.79,3.22,5.47 c0.06,0.08,0.19,0.02,0.16-0.08c-0.69-2.48-1.01-5.06-0.96-7.64c0-0.11,0.16-0.12,0.18-0.02c0.45,1.95,1.42,4.84,3.14,6.39 c0.06,0.06,0.16,0.01,0.16-0.07c-0.05-2.6-1.55-6.17-1.35-6.26c0.46-0.2,2.58,2.94,4.33,9.1c0.03,0.09,0.18,0.05,0.17-0.04 c-0.03-2.55,0.09-5.11,0.35-7.64c0.01-0.1,0.16-0.11,0.18-0.01c0.91,3.63,1.9,7.3,3.85,10.48c0.05,0.08,0.17,0.05,0.17-0.04 c0.11-2.31,0.3-4.61,0.57-6.91c0.01-0.11,0.17-0.11,0.19,0c0.77,5.37,2.28,10.86,5.74,14.93c41.3,36.86-30.74,99.51,18.1,150.85 c0.86,0.9,1.76,1.8,2.69,2.69c12.35,9.18,26.61,18.2,43.16,26.69l-0.34-0.61c20.3,10.56,120.39,51.16,271.19,51.16 c234.04,0,291.71-43.47,305.9-64.06C3772.9,953.17,3656.65,951.86,3589.13,953.41z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3078.94,704.95c-2.41,0.44-1.5,3.53-0.41,4.25l10.9,4c0,0,9.99,7.09,13.99,9.99 c4,2.91,35.09,36.07,35.64,36.43s5.17,1.38,5.79,1.9c1.19,1.01,23.26,23.44,24.35,26.17c1.09,2.73-2,1.82-1.09,4 s5.09,1.09,8.72,0.55s3.09-3.27,0.36-3.27c-2.73,0-4.18-4.36-4.18-4.36l-58.33-54.87l-17.44-15.26L3078.94,704.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M3109.58,723.12c-1.27-1.24-2.18-2.66-3.1-5.4c-0.92-2.74-5.29-12.53-9.18-16.48 c-3.89-3.95-8.74-4.08-13.15-3.36c-4.41,0.72-10.46,2.51-5.21,7.08c5.25,4.57,20.33,13.58,24.35,16.3 c4.02,2.72,6.52,5.27,9.03,7.82s28.72,27.31,33.81,32.32c5.09,5.01,28.45,26.8,28.45,26.8s-2.58,0.52-1.7,1.69 c0.87,1.17,2.03,0.66,4.27,0.25c2.24-0.41,4.4-0.98,3.45-2.06s-2.96,0.28-3.48-0.48 C3177.11,787.6,3113.03,726.49,3109.58,723.12z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3025.65,592.59c8.35,4.98,11.61,14.58,11.9,18.67c0,0,4.88-0.34,10.68,1.97 c1.76-14.04,2.91-33.85,1.61-60.33c-1.34-27.43-10.28-44.73-10.28-61.21s7.54-29.82,4.8-50.22c-2.69-20.03-5.33-56.46-3.18-66.34 c0.04-0.18,0.08-0.36,0.12-0.52c0,0-0.05,0.16-0.15,0.43c-0.27,0.79-0.9,2.61-1.75,4.95c-1.42,3.92-3.43,9.27-5.32,13.62 c-1.52,3.49-2.78,9.01-3.64,15.71c-0.75,5.82-1.2,12.54-1.28,19.62c-0.02,1.65-0.02,3.32,0.01,5c0.02,1.46,0.06,2.93,0.11,4.4 c0.4,11.05-1.79,18.06-4.09,26.87c-0.54,2.09-1.09,4.28-1.62,6.65C3026.83,507.96,3027.66,557.16,3025.65,592.59z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3170.78,774.13c8.36,5.33,16.28,10.94,23.74,15.19c10.04,4.1,15.41,1.08,16.54-0.77 c0.72-1.06,0.18-5.48,0.23-6.35C3210.11,786.44,3192.99,782.63,3170.78,774.13z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3053.21,709.24l-6.93-4.04l-4.04,3.95c-1.03-1.25-1.96-2.43-2.13-3.72c-0.06-0.42-0.01-0.83,0.12-1.21 c-0.03-0.01-0.05-0.02-0.05-0.02c-0.27,0.37-0.47,0.89-0.56,1.54c-5.14,4.01,4.78,24.54,34.26,38.46 c5.17,1.62,10.71,3.13,16.51,4.38c12,2.59,26.38,5.6,36.62,7.98c-36.97-15.29-68.07-31.49-80.02-42.9L3053.21,709.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3060.03,634.67c-1.12-4.55-2.93-14.6-11.63-18.78c-14.36-6.9-26.85,5.45-24.89,1.1 c1.43-3.17,3.79-5.29,4.97-6.2c0.41-0.32,0.44-0.85,0.25-1.33c-1.98-5.13-6.49-12.66-18.08-12.59 c-12.65,0.08-19.29,12.89-19.29,12.89c1.87-8.13,5.67-12.9,7.15-14.51c0.01,0.03,0.02,0.05,0.02,0.08 c2.72-2.84,6.42-4.97,11.44-5.61c4.23-0.54,7.87-0.17,10.99,0.8c-0.05-33.77-3.98-76.25-7.41-109.83 c-5.61-54.8-15.49-115.49-17.71-132.59c-3.52-27.18-1.78-46.59-1.04-54.39c0-0.03,0.01-0.06,0.01-0.09 c-0.04-0.02-0.08-0.04-0.12-0.06c-0.1-0.05-0.21-0.09-0.31-0.11c-4.42,8.03-12.41,39.06-18.3,95.04 c-0.12,1.28-0.25,2.58-0.4,3.89c-4.35,42.96-7.45,100.06-6.89,172.13c26.83-1.54,29.24,15.53,29.43,16.08 c0.12,0.36-5.61-7.83-17.01-10.33c-6.02-1.32-14.55-1.14-22.26,3.87c-13.61,8.85-12.33,25.89-12.33,25.89 c9,1.12,13.95,5.45,16.78,8.13c0.24,0.23-0.07,0.61-0.35,0.42c-7.24-4.85-14.62-5.17-18.56-4.9 c-19.89,2.06-23.81,20.39-24.32,23.42c-30.31,12.77-52.66,36.87-61.48,48.28c-4.09,5.3-11.56,14.2-20.07,24.08 c-13.8,16.02-30.36,34.64-39.79,44.75c-3.13,3.35-5.48,5.77-6.68,6.84c-3.91,3.49-7.11,5.92-7,7c0.02,0.15,0.09,0.27,0.24,0.36 c0.7,0.47,3.02,0.33,7.71-0.51c1.62-0.29,3.67-0.79,6.01-1.45c65.82-20.34,71.32-34.71,95.95-30.07 c31.19,5.88,31.77,40.88,54.77,64.23c7.91,8.03,15.94,14.56,61.84,18.96c-66.22-29.1-43.74-59.99-56.17-85.36 s-15.25-36.11,12.18-55.26c27.43-19.15,17.75-48.36-0.48-49.88c-0.24-0.02-0.47-0.03-0.71-0.05 c10.83-0.24,15.99,0.01,15.99,0.01c33.89,0.93,63.1,10.42,73.5,14.21c0.76,0.28,1.42,0.52,1.97,0.73 c1.36,0.52,2.08,0.82,2.08,0.82C3060.05,634.76,3060.04,634.71,3060.03,634.67z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2982.5,619.07c0,0.01-0.01,0.01-0.01,0.02C2982.5,619.08,2982.5,619.07,2982.5,619.07z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2982.52,619.04c0,0.01-0.01,0.02-0.01,0.03C2982.51,619.05,2982.52,619.04,2982.52,619.04z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2982.47,619.14C2982.47,619.15,2982.47,619.15,2982.47,619.14L2982.47,619.14z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2982.47,619.14c0-0.01,0.01-0.03,0.02-0.05C2982.48,619.11,2982.48,619.13,2982.47,619.14z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3135.49,693.41c0.12,0.7,0.25,1.4,0.4,2.1c0.4,1.88,0.9,3.72,1.45,5.45c2.74,8.59,1.09,16.17-0.59,22.31 c-1.62,5.9-0.98,6.68-0.48,9.34c-0.29-0.12-0.57-0.23-0.85-0.34c-0.12-0.04-0.23-0.09-0.34-0.13c0,0-0.03,0.05-0.07,0.13 c-0.47,0.91-3.07,6.76,4.56,12.22c5.41,3.88,11.86,4.83,18.27,4.84c-0.89-2-1.14-3.89-1.51-6.83c-1.64-0.88-3.36-1.79-5.11-2.69 l5.23,2.41c0,0,0.68,8.49,3.21,8.65c0.43,0.03,0.82,0.03,1.18,0c-1.08,0.22-2.17,0.14-2.68-0.86c-0.07-0.14-0.14-0.29-0.21-0.43 c-0.3,0.25-0.55,0.55-0.74,0.85c-0.5,0.78-0.73,1.64-1.16,2.44c-1.37,2.57-4.31,4.8-4.06,5.59c0.13,0.23,0.28,0.34,0.45,0.35 c-0.6,1.03-0.64,1.64-0.27,1.92c0.61,0.46,1.24,1.3,1.96,1.88s1.36,1.62,2.48,1.24c1.13-0.38,2.57-0.06,3.09-1.1 c0.52-1.04,1.99-5.6,2.65-6.23c0.66-0.63,3.66-0.06,4.67-0.32s1.44-0.58,0.82-0.75c0.19-0.15,0.23-0.18,0.17-0.16 c-0.17,0.05-1.12,0.47-2.22,0.11c-0.81-0.27-1.6-1.5-1.88-2.16c-0.28-0.67-0.7-1.12-1.08-1.72c-0.17-0.28-0.26-0.67-0.31-1.24 c-0.04,0.02-0.08,0.05-0.13,0.06c-0.02,0.01-0.05,0.02-0.07,0.03c0.7-0.48,1.07-1.36,1.2-2.79c0.02-0.18,0.04-0.45,0.06-0.8 c0,0.62,0.01,1.19,0.05,1.7c0.01,0.22-0.02,0.43-0.08,0.64c1.46-0.09,2.9-0.2,4.31-0.3c1.88,0.99,4.18,2.24,6.5,3.64 c0.07,0.04,0.12,0.06,0.16,0.06c0.18,0.01,0.24-0.25,0.61-0.63c2.05-2.21,17.19-17.76,32.43-14.31c0.09,0.02,0.18,0.03,0.26,0.05 c0,0,0,0,0,0s-0.08-0.06-0.23-0.15c-0.57-0.37-2.15-1.35-4.18-2.28c-0.16-1.27-0.82-5.66-2.9-13.91 c-5.54-21.88-9.08-24.46-11.43-25.54c-2.21-1.02-5.6,0.43-9.04,2.93c-0.05-0.05-0.09-0.09-0.13-0.13 c-0.2-0.19-0.36-0.31-0.49-0.39c-0.36-0.22-0.49-0.1-0.49-0.1s-0.43-0.09-0.61,0.06c-0.02,0.02-0.04,0.04-0.05,0.07 c0,0-0.02-0.01-0.07-0.02c-0.31-0.1-1.76-0.49-5.19-0.34c-3.62,0.15-6.37,0.5-6.37,0.5l0.04,8.63c0,0,3.29-0.92,5.97-1.39 c-0.88,1.03-1.69,2.05-2.37,3.03c-1.93,2.76-3.41,5.16-3.41,5.16l-2.13,27.68c-0.3,0.13-0.6,0.24-0.88,0.32 c0.46-8.52,1.19-23.72,1.5-30.22c0.42-8.76,0.07-14.71-1.55-20.26c-1.49-5.09-4.6-8.88-5.69-10.14c-0.03-0.04-0.07-0.08-0.1-0.12 c0.02-0.05,0.04-0.1,0.05-0.15c0.16-0.34,0.32-0.65,0.49-0.95c0.3-0.54,0.62-1.03,0.95-1.5c1.4-2.01,2.85-3.61,3.08-6.97 c0.02-0.26,0.05-0.5,0.08-0.74c-0.52-1.57-0.28-3.49,0.03-3.86c0.34-0.41,0.91-0.36,1.33,0.34c0.17-0.32,0.36-0.65,0.56-1.01 c0.55-0.47,0.96-0.98,1.26-1.5c1.23-2.12,0.72-4.55,0.14-6.02c-0.03-0.09-0.07-0.19-0.1-0.29c0,0-1.33-3.71-5.16-4.92 c-1.38-0.43-14.33,0.12-14.39,16.06c0.16,1.55,0.07,3.13-0.64,4.44c-0.21,0.4-0.48,0.77-0.82,1.11 c-3.72-0.36-5.33-1.12-6.91,0.94c-0.5,0.65-0.92,1.35-1.29,2.08c-1.17,2.35-1.7,5.12-1.79,8.05 C3134.87,688.53,3135.09,690.99,3135.49,693.41z M3154.85,716.1c1.21-3.49,2.03-6.83,2.45-10.22l0.04,0.94 c0,0-1.08,9.41-1.12,10.37c-0.11,2.19,0.21,7.99,0.44,11.35c0.08,0.59,0.14,1.19,0.17,1.82c0.08,1.53-0.02,0.37-0.17-1.82 C3155.96,723.14,3153.75,719.25,3154.85,716.1z M3187.28,719.82c0.52,1.06,1.29,2.32,2.48,3.72c0.75,0.89,1.45,1.76,2.1,2.6 c2.35,3.02,4.06,5.59,5.34,7.14c-0.15-0.02-0.3-0.04-0.45-0.05c0,0-0.08,0.01-0.22,0.02c-1.6,0.17-11.72,1.47-19.77,7.62 c2.03-3.24,5.78-6.89,12.47-10.65c0.11-0.06,0.06-0.17-0.1-0.29c-0.02-0.02-0.05-0.04-0.08-0.05c-0.56-0.37-2.08-0.9-3.83-1.19 c-1.03-0.17-2.13-0.27-3.17-0.2c-0.4,0.03-0.76,0.07-1.09,0.13c-1.15,0.21-1.93,0.66-2.84,1.46c-0.56,0.49-1.17,1.12-1.95,1.91 c0.2-0.22,0.4-0.44,0.61-0.66c0.05-0.07,0.1-0.13,0.15-0.2c3.58-5.07,6.51-9.44,8.27-12.59c0.34-0.6,0.63-1.16,0.87-1.67 c0.07-0.14,0.14-0.29,0.2-0.42C3186.27,716.44,3186.26,717.74,3187.28,719.82z M3184.84,706.71c-0.01,0.11-0.04,0.23-0.08,0.34 c0.05-0.15,0.07-0.3,0.08-0.44C3184.83,706.64,3184.84,706.68,3184.84,706.71z M3179.89,705.57c-0.07-0.66-0.12-1.11-0.12-1.11 s0,0.01,0,0.01C3179.77,704.51,3179.83,704.94,3179.89,705.57z M3180.11,708.53c0.06,1.54-0.16,2.91-0.44,3.41 c-0.04,0.07-0.08,0.12-0.12,0.16c-0.07,0.06-0.15,0.12-0.23,0.15c0.08-0.04,0.15-0.09,0.23-0.15c0.04-0.03,0.08-0.09,0.12-0.16 C3179.95,711.44,3180.17,710.08,3180.11,708.53z M3178.83,711.9c0.03,0.1,0.06,0.17,0.1,0.23 C3178.89,712.07,3178.86,712,3178.83,711.9z M3179.25,712.28c-0.03,0.01-0.06,0.01-0.08,0.01 C3179.19,712.29,3179.22,712.29,3179.25,712.28z M3175.65,705.37c0.02,0.06,0.03,0.12,0.05,0.18c0.05,0.12,0.09,0.24,0.13,0.36 c-0.04-0.12-0.08-0.23-0.13-0.36C3175.68,705.49,3175.67,705.43,3175.65,705.37L3175.65,705.37z M3180.47,712.01 c0,0.16,0,0.29,0.02,0.4C3180.46,712.24,3180.47,712.16,3180.47,712.01z M3183.01,710.8c-0.31,0.3-0.64,0.55-0.76,0.4 C3182.37,711.35,3182.7,711.1,3183.01,710.8z M3182.59,709.48c-0.06,0.22-0.14,0.44-0.2,0.64 C3182.45,709.92,3182.53,709.7,3182.59,709.48z M3182.2,710.85c0,0,0,0.01,0,0.01C3182.2,710.86,3182.2,710.86,3182.2,710.85z  M3182.68,709.11c0.04-0.24,0.05-0.47,0.01-0.68C3182.73,708.64,3182.72,708.87,3182.68,709.11z M3181.47,704.46 c0.07,0.44,0.27,1.12,0.44,1.81C3181.74,705.58,3181.53,704.9,3181.47,704.46c-0.01-0.06-0.01-0.09-0.01-0.11 C3181.45,704.37,3181.46,704.41,3181.47,704.46z M3184.36,707.86c0-0.01,0-0.02,0-0.03c0.13-0.18,0.22-0.35,0.3-0.52 C3184.57,707.51,3184.46,707.7,3184.36,707.86z M3184.36,704.73c0.15,0.43,0.29,0.84,0.38,1.2 C3184.59,705.49,3184.47,705.09,3184.36,704.73z M3184.75,707.06c-0.03,0.08-0.05,0.15-0.09,0.23 C3184.7,707.21,3184.73,707.14,3184.75,707.06z M3180.51,712.56c0.02,0.08,0.08,0.18,0.16,0.28 C3180.59,712.74,3180.52,712.64,3180.51,712.56z M3180.45,710.85c0,0,0-0.01,0-0.01c0,0,0-0.01,0-0.01c0,0,0,0.01,0,0.01 C3180.45,710.84,3180.45,710.85,3180.45,710.85z M3175.28,705.33c-0.11,0.01-0.22,0.01-0.34,0c-0.04,0-0.09,0-0.14-0.01 C3174.96,705.32,3175.12,705.32,3175.28,705.33z M3181.36,699.94c-0.29-0.19-0.54-0.36-0.7-0.56c-0.01-0.01-0.01-0.01-0.02-0.02 C3180.82,699.53,3181.06,699.73,3181.36,699.94z M3167.35,739.94c-0.75,0.54-1.48,0.99-2.16,1.33 C3165.63,741.02,3166.39,740.57,3167.35,739.94z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3228.53,774.58c-0.14,0.2-0.28,0.41-0.41,0.61c0.39-0.32,0.69-0.56,0.81-0.87 c-0.05-0.01-0.09-0.02-0.14-0.04C3228.68,774.37,3228.6,774.47,3228.53,774.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3238.3,779.55c0.02,0,0.05,0,0.08,0.01C3238.35,779.55,3238.33,779.55,3238.3,779.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3225.62,775.64c0.05,0.02,0.11,0.04,0.18,0.04c0.07,0.01,0.13,0,0.2-0.02c-0.07-0.1-0.12-0.21-0.15-0.32 C3225.77,775.44,3225.7,775.54,3225.62,775.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3238.15,779.57c0.04-0.02,0.09-0.02,0.13-0.03c-0.08,0-0.15,0.02-0.23,0.06 C3238.08,779.6,3238.11,779.59,3238.15,779.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3227.46,772.84c0.02-0.02,0.04-0.03,0.05-0.05c-0.03-0.16-0.07-0.32-0.09-0.48 c-0.01-0.1-0.01-0.21-0.01-0.32c-0.07,0.1-0.15,0.19-0.18,0.31C3227.17,772.53,3227.26,772.73,3227.46,772.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M3227.43,776.36c0-0.05-0.01-0.1,0-0.15c-0.02,0.02-0.03,0.04-0.05,0.07 C3227.4,776.31,3227.42,776.33,3227.43,776.36z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    points: "3226.89,774.7 3226.89,774.7 3226.89,774.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M3237.84,750.35c0.05-0.1,0.11-0.2,0.17-0.3c0,0,0-0.01,0-0.01c-0.08,0.05-0.17,0.1-0.25,0.15 C3237.79,750.24,3237.82,750.3,3237.84,750.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M3234.86,752.81c0.89-2.26,2.39-3.22,2.81-2.76c0.11-0.04,0.22-0.06,0.33-0.06 c-0.03-0.22,0-0.43,0.15-0.63c1.03-1.36,2.72-2.01,2.72-2.01s0.01,0.01,0.01,0.02c2.24-1.45,4.11-2.03,5.88-2.13 c0.01-0.02,0.01-0.03,0.01-0.03s-0.63-0.96-1.03-1.91c-1.61,0.84-4.14,1.37-7.85,1.39c-0.87,0.01-1.67-0.01-2.45-0.05 c0,0.06,0,0.12-0.01,0.18c-0.09,0.91-0.35,1.29-0.6,1.44c0.01,0.09,0.03,0.19,0.03,0.29c0,1.16-0.08,3.01-0.16,4.63 c-0.33-0.05-0.65-0.14-0.86-0.34c-0.21-0.19-0.36-0.28-0.5-0.33c0.03,1.22-0.19,2.55-0.77,4c0.74,0.15,1.39,0.29,1.99,0.34 C3234.54,754.16,3234.6,753.49,3234.86,752.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3268.73,784.83c0.09-2.91-1.83-2.38-2.98-3.36c-1.12-0.96-0.63-1.3-3.36-3.29 c-1.21,1.59-2.97,2.9-5.78,3.54c-1.18,0.27-2.22,0.38-3.14,0.36c4.11,1.54,8.54,2.79,9.42,3.37c1.33,0.88,2.24,6.55,3.79,8.81 c1.55,2.26,1.85,1.45,2.73,0.39c0.57-0.69,1.34-0.88,1.41-2.52C3270.91,790.5,3268.61,788.88,3268.73,784.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3228.82,744.32c0.01,0.01,0.01,0.02,0.02,0.02c-0.01-0.11-0.01-0.22,0-0.34 C3228.83,744.11,3228.83,744.22,3228.82,744.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3234.7,751.19c0.08-1.62,0.16-3.47,0.16-4.63c0-0.1-0.01-0.19-0.03-0.29c0.25-0.15,0.51-0.53,0.6-1.44 c0.01-0.06,0-0.12,0.01-0.18c-0.89-0.04-1.72-0.1-2.49-0.18c0.1,0.65,0.35,1.3,0.59,1.92c-0.39-0.44-0.73-0.93-0.99-1.45 c-0.01,0.52,0.11,1.04,0.35,1.51c-0.62-0.77-1.41-1.4-2.29-1.85c0.02,0.12,0.03,0.25,0.05,0.37c-0.38-0.18-0.72-0.43-1.02-0.72 c0.1,0.25,0.12,0.53,0.04,0.79c-0.17-0.29-0.37-0.56-0.6-0.8c0.01,0.16,0.01,0.33,0.02,0.49c0.39,0.55,0.78,1.1,0.97,1.51 c0.35,0.74,0.74,0.79,1.04,0.99c0.3,0.2,0.74,2.23,1.34,2.82c0.4,0.4,0.6,0.35,0.89,0.46c0.14,0.05,0.29,0.14,0.5,0.33 C3234.06,751.05,3234.37,751.14,3234.7,751.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3258.53,753.83c0.18,1.27,0.71,2.37,1.13,3.1l0.03-0.02c0,0,0.89,1.37,2.66,3.76 c0.69-1.4,0.68-2.15-0.39-4.11c-1.21-2.21-4.21-6.67-5.85-8.74c-0.03-0.04-0.07-0.08-0.1-0.13c-0.13-0.16-0.26-0.32-0.37-0.44 c0,0-0.01,0.01-0.01,0.02c-0.57-0.59-1.26-1.01-2.09-1.19c-0.52-0.11-0.99-0.2-1.43-0.28 C3253.49,748.87,3258.21,751.57,3258.53,753.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3240.89,747.38c0.26,0.44,5.06,8.38,9.66,5.8c4.72-2.65-3.39-7.91-3.39-7.91 c0.3-0.02,0.63-0.02,0.98-0.01c-0.45-0.03-0.91-0.04-1.37-0.01C3245,745.35,3243.12,745.93,3240.89,747.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3246.26,770.55c-0.41-4.82-0.92-3.49-2.55-5.73c-0.73-0.78-1.38-1.57-1.94-2.34 c-0.34-2.57-1.12-5.29-1.71-7.3c0.01-0.04,0.02-0.09,0.03-0.13c0.43-2.1-1.85-3.78-2.08-5.01c-0.06,0.1-0.12,0.2-0.17,0.3 c-0.03-0.05-0.06-0.11-0.08-0.16c0.08-0.05,0.17-0.1,0.25-0.15c0-0.02,0-0.03-0.01-0.05c-0.11,0-0.22,0.02-0.33,0.06 c-0.43-0.46-1.93,0.5-2.81,2.76c-0.26,0.68-0.33,1.35-0.29,2.05c0.07,1.24,0.47,2.56,0.75,4.09c-0.69,0.14-1.26,0.74-1.54,2.23 c-0.2,1.07-0.01,2.77,0.45,4.76c-1.08,1.31-2.77,3.03-4.21,4.45c0.4,0.23,0.79,0.48,1.15,0.76c0.14,0.11,0.29,0.23,0.37,0.39 c0.2,0.4-0.06,0.87-0.33,1.23c-0.46,0.62-1.03,1.25-1.79,1.34c-0.18,0.02-0.38,0.01-0.54,0.1c-0.04,0.02-0.07,0.05-0.1,0.08 c0.04,0.01,0.09,0.03,0.14,0.04c-0.11,0.31-0.42,0.55-0.81,0.87c-0.23,0.34-0.46,0.68-0.68,1.02c0,0.05,0,0.1,0,0.15 c0.1,0.17,0.2,0.34,0.31,0.51c0.08,0.01,0.17-0.03,0.26-0.15c0.42-0.59,1.4-1.36,2.52-1.62c1.12-0.26,1.18-0.74,1.89-1.74 l-0.12-0.06c0.22-0.15,0.46-0.32,0.7-0.52c0.62-0.49,1.72-0.87,2.92-1.29c1.09,2.99,2.47,6.02,3.85,8.38 c-0.2,0.01-0.32,0.02-0.32,0.02c-0.21-0.04-0.5-0.19-0.77-0.28c-0.08-0.02-0.15-0.04-0.2-0.05c-0.03-0.01-0.07-0.01-0.1-0.02 c-0.03,0-0.05-0.01-0.08-0.01c-0.01,0-0.01,0-0.02,0c-0.05,0-0.09,0.01-0.13,0.03c-0.04,0.01-0.06,0.02-0.1,0.04 c-0.03,0.01-0.05,0.03-0.08,0.05c-0.16,0.12-0.13,0.47-0.03,0.64c-0.24-0.07-0.7-0.02-0.76,0.23c-0.01,0.05-0.05,0.1-0.04,0.16 c0.05,0.25-0.16,0.28-0.14,0.34c-0.18,0.12-0.09,0.38-0.17,0.54c-0.1,0.2-0.34,0.31-0.37,0.57c0.03-0.08,0.02-0.17,0.01-0.25 c-0.02,0.11-0.03,0.22-0.04,0.35c-0.06,0.78-0.2,0.43,1.28,0.99c1.56,0.6,3.55,1.06,5.36,1.39c1.76,0.31,2.84,0.02,1.75-2.2 c-0.25-1.15-0.69-3.22-0.86-4.65l0,0.04c0,0-3.92-4.29-5.42-7.26c-0.01-0.02-0.03-0.05-0.04-0.07c0.22-0.11,0.44-0.22,0.66-0.34 c0.22,0.31,0.44,0.63,0.66,0.97c1.59,2.52,3.47,3.54,4.23,5.09c0,0,2.07,2.51,4.93,4.02 C3246.7,777.79,3246.51,773.47,3246.26,770.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M3239.16,770.14c-0.21,0.12-0.43,0.23-0.66,0.34c0.01,0.02,0.03,0.05,0.04,0.07 c1.51,2.97,5.42,7.26,5.42,7.26l0-0.04l0.08-1.56c-0.75-1.55-2.64-2.57-4.23-5.09C3239.6,770.77,3239.38,770.45,3239.16,770.14z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1B",
    d: "M3229.69,745.05c0.08-0.26,0.06-0.54-0.04-0.79c0.3,0.29,0.64,0.54,1.02,0.72 c-0.02-0.12-0.03-0.25-0.05-0.37c0.88,0.45,1.67,1.08,2.29,1.85c-0.24-0.46-0.36-0.99-0.35-1.51c0.27,0.52,0.6,1.01,0.99,1.45 c-0.25-0.62-0.49-1.27-0.59-1.92c-1.98-0.21-3.59-0.56-4.88-1.01c0.09,0.2,0.19,0.39,0.26,0.6c0.18,0.51,0.34,1.03,0.53,1.55 c-0.06-0.42-0.07-0.86-0.04-1.28c0.01-0.1,0-0.21,0.02-0.31c-0.01,0.11-0.01,0.22,0,0.34c0.02,0.35,0.12,0.7,0.29,1.01 c-0.01-0.21-0.01-0.42-0.02-0.63c-0.01-0.16-0.01-0.33-0.02-0.49C3229.32,744.49,3229.52,744.76,3229.69,745.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659896",
    d: "M3232.95,744.48c0.77,0.08,1.6,0.15,2.49,0.18c0.77,0.03,1.58,0.05,2.45,0.05 c3.71-0.02,6.24-0.56,7.85-1.39c3.84-2,2.38-5.7-1.12-8.13c-0.17-2.53-0.64-5.1-1.84-5.9c-2.5-1.67-7.25-1.64-10.58-1.55 c-3.38,0.09-4.47,3.44-4.77,6.38c-0.71,0.4-1.29,0.81-1.81,1.15c-2.72,1.82-3.67,6.08,2.44,8.2 C3229.37,743.91,3230.98,744.26,3232.95,744.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3262.4,778.19c1.48-1.96,2.11-4.36,2.73-6.51c1.13-3.9,0.21-7.08-2.05-10.05 c-0.26-0.34-0.5-0.66-0.72-0.96c-1.77-2.38-2.66-3.76-2.66-3.76l-0.03,0.02c-0.43-0.73-0.95-1.83-1.13-3.1 c-0.32-2.26-5.04-4.95-6.41-8.05c0-0.01-0.01-0.02-0.02-0.03c0,0-2.19-0.43-3.97-0.49c-0.35-0.01-0.69-0.01-0.98,0.01 c0,0,8.11,5.26,3.39,7.91c-4.59,2.58-9.4-5.36-9.66-5.8c-0.01-0.01-0.01-0.02-0.01-0.02s-1.68,0.65-2.72,2.01 c-0.15,0.19-0.18,0.4-0.15,0.63c0,0.02,0,0.03,0.01,0.05c0,0,0,0.01,0,0.01c0.24,1.22,2.51,2.91,2.08,5.01 c-0.01,0.05-0.02,0.09-0.03,0.13c0.59,2.01,1.38,4.73,1.71,7.3c0.56,0.76,1.2,1.56,1.94,2.34c1.62,2.24,2.14,0.91,2.55,5.73 c0.25,2.93,0.43,7.24,2.71,9.68c1.02,1.09,2.46,1.81,4.51,1.86c0.92,0.02,1.96-0.09,3.14-0.36 C3259.43,781.08,3261.2,779.78,3262.4,778.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3227.39,776.28c0.02-0.02,0.03-0.04,0.05-0.07c0.23-0.34,0.46-0.68,0.68-1.02 c0.14-0.2,0.28-0.41,0.41-0.61c0.07-0.11,0.16-0.21,0.26-0.29c0.03-0.03,0.06-0.06,0.1-0.08c0.16-0.08,0.36-0.08,0.54-0.1 c0.76-0.09,1.33-0.72,1.79-1.34c0.27-0.36,0.53-0.83,0.33-1.23c-0.08-0.16-0.23-0.28-0.37-0.39c-0.37-0.28-0.75-0.53-1.15-0.76 c-0.25-0.15-0.51-0.29-0.78-0.42c-0.19-0.09-0.39-0.17-0.59-0.15c-0.21,0.03-0.39,0.17-0.54,0.32c-0.28,0.3-0.49,0.67-0.6,1.06 c-0.04,0.12-0.05,0.25-0.07,0.38c0.08,0.04,0.12,0.11,0.09,0.2c-0.02,0.07-0.07,0.13-0.11,0.19c0,0.11-0.01,0.21,0.01,0.32 c0.02,0.16,0.06,0.32,0.09,0.48c0.01,0.03,0.01,0.06,0.02,0.09c0,0,0,0,0,0c0.24,0.08,0.52,0.04,0.73,0.19 c0.16,0.12,0.23,0.34,0.17,0.52c-0.06,0.19-0.25,0.32-0.45,0.32c0.26,0.03,0.4,0.36,0.29,0.6c-0.11,0.24-0.38,0.36-0.64,0.37 c-0.26,0-0.51-0.09-0.75-0.18c0,0,0,0,0,0c0.13,0.42,0.03,0.91-0.27,1.24c-0.03,0.03-0.07,0.07-0.11,0.08 c-0.06,0.01-0.12-0.01-0.17-0.04c-0.14-0.08-0.25-0.19-0.34-0.32c-0.06,0.02-0.13,0.03-0.2,0.02c-0.06,0-0.12-0.02-0.18-0.04 c-0.09,0.12-0.17,0.23-0.26,0.35c-0.18-0.11-0.33-0.28-0.37-0.48c-0.03-0.12,0-0.25,0.05-0.36c-0.15-0.16-0.32-0.32-0.53-0.37 c-0.37-0.1-0.76,0.16-0.94,0.49c-0.18,0.33-0.21,0.73-0.23,1.11c-0.02,0.35-0.04,0.7-0.06,1.04c-0.03,0.5-0.05,1.01,0.12,1.48 c0.16,0.43,0.47,0.79,0.81,1.11c0.47,0.44,0.89,0.78,1.42,1.13c0.61,0.4,1.06,0.69,1.77,1c0.48-0.77,0.88-1.59,1.19-2.44 c0.11-0.3,0.2-0.62,0.15-0.94c-0.04-0.25-0.17-0.47-0.3-0.68c-0.24-0.4-0.48-0.8-0.71-1.2c-0.1-0.17-0.2-0.34-0.31-0.51 C3227.42,776.33,3227.4,776.31,3227.39,776.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC7D61",
    d: "M3224.99,775.51c0.05,0.2,0.2,0.37,0.37,0.48c0.09-0.12,0.17-0.23,0.26-0.35c0.07-0.1,0.15-0.2,0.22-0.3 c0.03,0.12,0.08,0.22,0.15,0.32c0.09,0.13,0.2,0.24,0.34,0.32c0.05,0.03,0.11,0.05,0.17,0.04c0.04-0.01,0.08-0.05,0.11-0.08 c0.3-0.33,0.41-0.82,0.27-1.24c0,0,0,0,0,0c0,0,0,0,0,0c0.24,0.09,0.49,0.18,0.75,0.18c0.26,0,0.53-0.13,0.64-0.37 c0.11-0.24-0.04-0.57-0.29-0.6c0.2,0,0.39-0.13,0.45-0.32c0.06-0.19-0.01-0.41-0.17-0.52c-0.21-0.15-0.49-0.12-0.73-0.19 c0,0,0,0,0,0c0-0.03-0.01-0.06-0.02-0.09c-0.02,0.02-0.04,0.04-0.05,0.05c-0.2-0.1-0.29-0.31-0.23-0.54 c0.03-0.12,0.11-0.21,0.18-0.31c0.05-0.06,0.09-0.12,0.11-0.19c0.03-0.1-0.01-0.16-0.09-0.2c-0.09-0.05-0.22-0.07-0.31-0.06 c-0.31,0.05-0.48,0.37-0.57,0.64c-0.09,0.28-0.13,0.58-0.11,0.88c0,0.06,0.01,0.13-0.02,0.19c-0.04,0.08-0.13,0.12-0.2,0.18 c-0.16,0.13-0.2,0.4-0.07,0.57c-0.18-0.05-0.32,0.16-0.36,0.34c-0.04,0.18-0.05,0.39-0.2,0.51c-0.11,0.08-0.26,0.08-0.38,0.14 c-0.08,0.04-0.13,0.1-0.17,0.18C3224.99,775.26,3224.96,775.38,3224.99,775.51z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3268.94,787.08c0.25,1.14,0.68,2.04,1.08,2.79C3269.8,788.97,3269.43,788.02,3268.94,787.08z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3265.6,791.93c0.93,2.03,1.94,4.04,2.95,3.59c0.34-0.15-1.18-1.26-1.38-2.64 c-0.2-1.38-0.97-4.86-1.58-6.08c-1.76-3.49-0.56-4.51-1.1-4.4c-1.55,0.32-3.46-1.96-4.08-2.28c0.2-0.15,0.39-0.3,0.57-0.46 c0.98-0.86,1.78-1.9,2.36-3.01c0.12-0.22,0.23-0.45,0.34-0.67c1.64-3.42,2.24-7.07,1.81-9.18c-0.39-1.95-0.83-2.9-1.88-4.42 c-0.16-0.24-0.34-0.49-0.54-0.76c-0.47-0.64-0.6-0.99-0.59-1.25c0.02-0.55,0.65-0.71,0.07-2.47c-0.26-0.77-1.8-3.36-3.32-5.72 c-1.16-1.8-2.31-3.45-2.87-4.05c-0.01-0.01-0.02-0.03-0.04-0.04c-0.6-0.62-2.18-1.18-3.84-1.61c-1.81-0.47-3.7-0.78-4.51-0.85 c-0.13-0.01-0.24-0.03-0.35-0.04c-0.57-0.07-0.94-0.19-1.17-0.34c-0.74-0.46-0.22-1.22-1.13-1.76c0,0,0,0,0,0 c0.27-0.12,0.4-0.2,0.4-0.2c1.5-3.46-1.15-7.5-1.15-7.5c-0.46,0.98-1.62,1.67-1.62,1.67c1.04-0.98,0.87-2.02,0.87-2.02 c-0.58-5.08-2.15-4.65-7.04-4.97c-4.88-0.33-1.92-2.06-4.1-2.21c-2.95-0.21-4.09,2.34-4.49,4.88c-0.4,2.54-0.29,5.65-0.29,5.65 s-2.65,3.17-1.44,3.98c0.01,0.01,0.02,0.01,0.03,0.02c0.47,0.31,1.05,0.54,1.6,0.71c0.26,0.08,0.51,0.15,0.73,0.2 c0.07,0.02,0.14,0.03,0.21,0.05c0,0,0,0.01,0,0.01c0.04,0.22,0.14,0.48,0.29,0.76c0.25,0.46,0.65,0.96,1.22,1.32 c0.96,0.61,1.36,0.9,1.62,2c0.26,1.1,1.68,1.65,1.74,2.63c0.02,0.37,0.37,0.53,0.8,0.65c0.3,0.08,0.64,0.14,0.93,0.22 c0.88-1.28,1.88-1.7,2.11-1.18c-1.55,0.63-2.42,2.88-1.38,6.53c1.04,3.65,0,6.43,0.52,7.3c0.52,0.87,1.04,1.65,1.04,1.65 s-1.04-0.52-2.26,1.04c-1.05,1.34-3.57,3.33-4.92,4.19c-0.22,0.14-0.41,0.25-0.56,0.33c-1.04,0.52-1.23,1.79-1.93,1.88 s-1.15,0.53-1.37,1.25c-0.21,0.72-0.12,0.37-0.61,0.87c-0.12,0.12-0.27,0.18-0.42,0.22c-0.03,0.01-0.06,0.02-0.1,0.03 c-0.22,0.06-0.46,0.11-0.66,0.32c-0.19,0.19-0.35,0.51-0.47,1.08c-0.35,1.74-0.41,3.17-0.41,3.17s0.13,0.12,0.34,0.31 c0,0,0,0,0,0c0.62,0.54,1.94,1.62,2.85,1.82c0,0,1.04-1.5,1.19-2.44c0.07-0.46,0.09-0.9,0.01-1.33 c-0.08-0.43-0.26-0.86-0.59-1.27c-0.08-0.1-0.13-0.18-0.18-0.24c-0.32-0.48,0.15-0.14,0.15-0.14s0.02-0.18,0.41-0.46 c0.12-0.09,0.28-0.18,0.49-0.29c0.79-0.39,1.71-0.72,2.27-1.1c0.06-0.04,0.11-0.08,0.16-0.12c0.21-0.17,0.42-0.43,0.6-0.67 c0.28-0.37,0.48-0.72,0.48-0.72s1.32-1.04,3.15-1.73c0.12-0.04,0.24-0.09,0.36-0.13c0.55-0.21,1.12-0.4,1.67-0.62 c-0.34,0.14-0.68,0.26-1.02,0.39c0.84,1.51,1.79,3.01,2.62,4.39c1.92,3.19,2.33,4.77,2.41,5.39c-0.78-0.71-2.14-1.99-2.99-3.31 c-0.03-0.05-0.06-0.09-0.09-0.14c0.6,1.29,0.98,1.87,1.15,2.1c0.08,0.1,0.11,0.14,0.11,0.14c1.37,0.97,1.26,1.07,1.84,1.46 c0,0.06,0,0.09,0,0.09s-4.13,0.16-5.2,0.98c0-0.04,0.01-0.08,0.01-0.13c0.01-0.09,0.02-0.17,0.03-0.26 c-0.61,0.17-1.16,0.35-1.61,0.51c-2.81,0.99-3.66,2.25-1.51,3.84c-1.14,0.24-2.7-0.49-2.96-1.18c-0.2-0.53,0.26-1.3-0.92-1.68 c-1.18-0.38-3.76-1.14-5.49,0.75c0,0,0,0,0,1.72c0,3.78,13.76,3.77,20.81,2.8c19.33-1.81,18.87,6.51,22.44,6.24 c-0.16-0.19-0.33-0.42-0.52-0.7C3266.3,793.68,3265.93,792.85,3265.6,791.93z M3241.09,758.9c0.11,0.47,0.22,0.94,0.32,1.42 c0.54,0.99,1.2,2.01,2.03,3.03c3.8,4.67,2.79,4.3,2.7,6c-0.01,0.14-0.01,0.29,0,0.45c0.01,0.33,0.03,0.81,0.05,1.37 c-0.08-1.02-0.08-1.76-0.07-2c0-0.06,0-0.09,0-0.09c-0.01-0.01-0.01-0.01-0.01-0.02c-1.46-1.57-2.84-3.11-4.11-4.41 c-0.02-0.49-0.07-1-0.16-1.55C3241.67,762.1,3241.39,760.5,3241.09,758.9z M3240.98,768.65c-0.1,0.14-0.21,0.28-0.33,0.4 c-0.13,0.13-0.26,0.25-0.41,0.37c0.14-0.12,0.28-0.24,0.41-0.37C3240.77,768.92,3240.88,768.79,3240.98,768.65z M3244.53,780.31 c-0.26-1.11-0.49-2.24-0.53-3.14c-0.02-0.36-0.01-0.69,0.05-0.96c0,0,0.03,0.03,0.07,0.08c0.02,0.02,0.04,0.05,0.07,0.08 c0.01,0.01,0.03,0.03,0.04,0.04c0.5,0.57,2.06,2.26,3.94,3.46C3246.91,779.99,3245.69,780.14,3244.53,780.31z M3237.87,770.76 c-0.06,0.03-0.13,0.05-0.19,0.08C3237.74,770.82,3237.8,770.79,3237.87,770.76z M3243.07,784.62c-0.34-0.06-0.7-0.13-1.05-0.2 c2.14,0.34,3.13,0.35,3.24-0.58C3245.27,784.75,3244.35,784.84,3243.07,784.62z M3248.97,780.23c-0.01,0-0.02-0.01-0.02-0.01 c-0.01-0.02-0.02-0.03-0.03-0.05c-0.03-0.04-0.06-0.09-0.09-0.13c0.75,0.85,1.72,1.49,2.97,1.77c0.68,0.15,1.33,0.24,1.96,0.28 C3251.56,782.09,3250.04,781.36,3248.97,780.23z M3259.99,784.32c-1.72-0.58-3.95-1.3-6.13-2.1 C3255.33,782.63,3257.94,783.56,3259.99,784.32z M3263.03,785.56c-0.04-0.04-0.08-0.08-0.12-0.11 C3262.95,785.48,3262.99,785.51,3263.03,785.56z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3235.58,761.92c-0.16,0.14-0.31,0.31-0.46,0.51c-0.69,0.94-0.87,2.06-0.71,3.28 c0.51-0.63,0.85-1.15,0.91-1.47C3235.5,763.42,3235.57,762.65,3235.58,761.92z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "father"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M3787.34,707.97c4.25-8.95,18.58-23.9,23.58-16.22c-1.87-4.48-2.5-1.92-6.25-16 c-3.69-13.88-12.89-27.74-21.29-28.34c0.65,21.3,1.18,42.93,1.57,64.69C3785.82,710.78,3786.64,709.44,3787.34,707.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3725.31,634.94c13.08,9.01,28.93,59.96,46.63,96.03c0.79,1.62,1.49,3.1,2.1,4.49 c2.49-12.74,7.26-17.88,10.91-23.35c-0.39-21.76-0.92-43.39-1.57-64.69c-3.44-112.03-10.31-214.88-17.91-279.52 c-9.58-81.49-32.64-141.41-47.28-172.85c-10.62-22.83-35.91-17.96-35.16,9.42c0.64,23.47,7.81,166.17,3.47,417.87 C3704.42,621.65,3717.26,625.92,3725.31,634.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EBDE4",
    d: "M3739.68,821.67c-8.13-8.32-14.56-13.1-18.61-16.02c-0.37,1.16-0.73,2.32-1.09,3.49 c-2.94,9.61-5.27,20.23-7.09,30.37c-1.67,18.02-2.69,33.71-3.26,47.19c-0.87,34.67,9.76,99.78,11.29,121.23 c0.18,2.51,0.44,5.51,0.77,8.86c23.13,0,42.74,0,56.58,0c4.29-54.3,6.53-116.01,7.2-179.91 C3769.38,852.09,3753.4,835.72,3739.68,821.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M3543.22,512.64l0.15-0.05c-0.74-3.31-1.54-6.83-2.35-10.61c-4.7-21.96-1.24-10.65-9.79-19.13 c-0.56,1.5-1.11,3.03-1.63,4.62c-2.77,8.48-4.03,14.2-4.41,18.3c0.21-0.35,0.47-0.49,0.74-0.26c0,0,1.14-0.24,2.26,1.49 c1.11,1.73,3,9.8,3,9.8s-3.85-2.63-5.76-4.49c-0.01-0.01-0.02-0.02-0.02-0.03c1.13,5.41,4.4,6.51,2.4,16.12 c-2.1,10.14-1.52,20.54-0.34,30.18c1.7-5.84,5.35-16.6,9.41-24.91C3542.57,522.09,3544.95,522.75,3543.22,512.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M3666.54,545.72c-0.95,2.95-1.84,5.81-2.68,8.58C3664.84,551.48,3665.74,548.62,3666.54,545.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M3531.2,516.8c0,0-1.89-8.07-3-9.8c-1.11-1.73-2.26-1.49-2.26-1.49c-0.27-0.22-0.53-0.09-0.74,0.26 c-0.75,1.25-1,5.26,0.22,6.51c0.01,0.01,0.01,0.02,0.02,0.03C3527.35,514.17,3531.2,516.8,3531.2,516.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6BDAF",
    d: "M3652.53,601.56c0.06-2,0.22-4.15,0.48-6.46c-28.04,16.69-58.06,11.97-72.65-18.03 c-6.07-12.48-8.83-24.47-10.62-34.01c0-0.04,0-0.08,0-0.12c0.4-15.18-1.06-23.21-7.8-26.59c-7.38-3.69-12.28,6.44-11.13,16.61 c1.15,10.18-1.46,19.07,0,28.05c1.22,7.51,6.3,8.74,9.48,6.82c0.18,1.21,0.36,2.59,0.52,4.17c5.04,49.64-6.02,44.2-6.02,44.2 s-0.14,0.04-0.39,0.09c3.01,0.44,6.35,0.58,10.09,0.32c3.2-0.22,5.69,1.55,7.65,4.46c5.4-0.99,57.06-10.55,74.98-15.15 C3650.16,605.13,3651.97,602.85,3652.53,601.56z M3556.42,557.39c-1.24,2.63-2.93,0.42-1.77-3.97c1.16-4.38-0.01-5.27-1.02-7.47 c-1.01-2.2-0.24-2.86-0.24-2.86c1.96,3.31,4.06,2,5.26,3.55S3557.66,554.77,3556.42,557.39z M3558.53,563.2 c0,0,6.78-12.91,6.3-23.46C3564.83,539.75,3565.9,558.42,3558.53,563.2z M3557.87,523.67c-2.3,0.92-3.6,5.47-0.95,9 c2.65,3.53,3.63,5.08,4.44,7.94s-0.42,5.71-0.42,5.71s-0.55-2.2-1.35-4.84c-0.8-2.64-2.77,1.3-5.41-1.79s-2.03-12.31-1.34-14.5 c0.69-2.19,2.12-5.7,5.79-4.79c3.67,0.9,5.06,6.62,6.26,10.58C3564.89,530.96,3561.1,522.37,3557.87,523.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M3525.09,444.69c0,0,0.8-0.8,2.36-2.16C3525.39,443.7,3525.09,444.69,3525.09,444.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M3560.79,572c-0.16-1.58-0.33-2.95-0.52-4.17c-3.18,1.91-8.25,0.69-9.48-6.82 c-1.46-8.98,1.15-17.87,0-28.05c-1.15-10.18,3.76-20.31,11.13-16.61c6.74,3.38,8.2,11.41,7.8,26.59c0,0.04,0,0.08,0,0.12 c1.8,9.54,4.55,21.53,10.62,34.01c14.59,29.99,44.61,34.72,72.65,18.03c0.1-0.06,0.2-0.11,0.29-0.17c0,0,3.23-16.51,10.56-40.64 c0.84-2.76,1.73-5.63,2.68-8.58c0.6-1.87,1.22-3.77,1.87-5.7c6.45-19.34,12.25-40.31,12.17-53.05 c1.55-17.16-0.56-30.1-3.55-38.06c-3.98-10.61-1.99-3.32-1.99-3.32s0.45,11.19,0.98,18.5c-1.88-5.84-4.79-11.93-10.19-18.53 c-2.81-5.06-6.16-10.04-10.02-13.89c-11.32-11.32-8.6-10.98-4.71-0.35c-5.75-4.66-12-8.36-17.73-8.56 c-19.15-0.68-31.04-7.36-43.04-6.64c-4.14-0.32-11.52,1.02-18.5,3.71c-0.06-0.15-0.1-0.24-0.1-0.24 c-9.82,5.4-20.63,6.28-30.94,13c-6.35,4.14-10.83,7.77-13.33,9.95c2.5-1.42,7.59-3.12,17.89-3.63c-1.96,0.09-3.81,0.51-5.53,1.2 c-6.63,2.08-12.01,6.46-15.3,13.18c0,0,1.17-1.91,5.01-4.1c-0.51,0.81-0.98,1.65-1.42,2.51c-0.99,1.14-1.99,2.48-2.91,4.05 c-1.71,2.18-3.04,4.61-3.78,7.31c-3.1,11.37-4.68,11.13,1.22,7.26c0.06,3.33,0.93,6.8,2.82,10.04c4.16,7.12,3.09,4.95,1.98-2.04 c0.51,0.84,1.09,1.63,1.74,2.36c0.76,0.85,1.45,1.57,2.07,2.19c8.56,8.48,5.1-2.83,9.79,19.13c0.81,3.78,1.61,7.3,2.35,10.61 l-0.15,0.05c1.73,10.11-0.66,9.44-6.33,21.03c-4.07,8.31-7.71,19.07-9.41,24.91c-0.25,0.85-0.46,1.6-0.62,2.22 c-0.26,1.01-0.08,3.79,0.24,4.78c0.36,1.11,0.91,3.03,1.66,6.28c1.48,6.41,1.15,6.11,1.15,12.52c0,6.41-2.37,21.75,12.82,29.34 c6.33,3.17,10.44,2.78,11.66,2.55c0.25-0.05,0.39-0.09,0.39-0.09S3565.83,621.64,3560.79,572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M3558.63,520.38c-3.67-0.9-5.09,2.6-5.79,4.79c-0.69,2.19-1.3,11.41,1.34,14.5s4.61-0.85,5.41,1.79 c0.8,2.64,1.35,4.84,1.35,4.84s1.23-2.85,0.42-5.71s-1.79-4.4-4.44-7.94c-2.65-3.53-1.35-8.07,0.95-9 c3.23-1.3,7.01,7.29,7.01,7.29C3563.69,527,3562.3,521.28,3558.63,520.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M3558.65,546.65c-1.2-1.55-3.3-0.24-5.26-3.55c0,0-0.76,0.65,0.24,2.86c1.01,2.2,2.18,3.09,1.02,7.47 c-1.16,4.38,0.52,6.59,1.77,3.97C3557.66,554.77,3559.86,548.19,3558.65,546.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C1C",
    d: "M3558.53,563.2c7.37-4.78,6.3-23.46,6.3-23.46C3565.31,550.29,3558.53,563.2,3558.53,563.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42637C",
    d: "M3810.91,691.75c-5-7.68-19.33,7.27-23.58,16.22c-0.7,1.47-1.51,2.81-2.39,4.13 c-3.64,5.47-8.42,10.61-10.91,23.35c-0.61-1.38-1.31-2.87-2.1-4.49c-17.69-36.08-33.55-87.02-46.63-96.03 c-8.06-9.02-20.89-13.29-38.82-12.61c-6.46,0.25-13.58,1.13-21.37,2.68c-5.53-7.62-11.27-16.96-12.41-24.14 c0,0.16-0.06,0.41-0.19,0.69c-0.56,1.3-2.36,3.57-5.42,4.35c-17.92,4.6-69.59,14.15-74.98,15.15c-0.3,0.06-0.47,0.09-0.47,0.09 s8.18,12.35-7.3,19.03c-1.27,0.43-2.6,0.9-4,1.43c-7.56,2.87-14.22,6.37-20.08,10.44c-2.02,1.06-3.7,1.98-5.15,2.83 c-26.54,15.48-47.76,33.84-43.49,73.72c4.4,41.11-7.24,41.82-7.24,131.32c0,24.98-31.33,82.63-30.96,156.88 c17.08,0,36.98,0,58.45,0c5.87-20.33,14.41-46.64,24.45-67.89c10.92-23.11,17.63-37.1,20.77-105.32c0-0.05,0-0.08,0-0.08 c0-0.05,0.01-0.11,0.01-0.17c0.03-0.71,0.07-1.42,0.1-2.15c0.1-2.21,0.24-4.44,0.41-6.69c0.77-21.56-1.59-44.57-1.76-72.36 c-0.2-31.69,8.55-0.65,8.64,15.19c0.05,7.98,1.23,5.83,3.06-0.93c3.29-14.17,6.25-25.42,6.95-30.47 c0.23-1.64,0.02-0.11-0.49,3.85c0.13-0.51,0.26-1.03,0.38-1.54c1.82-7.24,1.74-4.76,0.62,3.35c0.9-4.6,1.44-7.03,1.44-7.03 s-3.96,23.28-8.29,53.36c-1.4,12.34-2.87,25.9-4.2,39.58c-0.54,20.28,1.89,40.33,13.29,56.62 c11.41,16.31,50.88,24.52,69.66,31.5c1.65,0.61,1.51,2.88-0.15,3.44c-47.93,16.11-75.29-10.81-75.03,4.63 c1.23,2.77,17.03,13.84,47.9,15.43c5.04,0.26-36.29,13.56-56.85,21.27c-16.56,4.67-27.56,6.22-34.46,19.4 c-0.07-0.08-0.14-0.16-0.21-0.24c-0.07,0.19-0.14,0.38-0.21,0.57c-0.12,0.34-0.24,0.68-0.36,1.02c0.03,0.01,0.07,0.02,0.1,0.03 c-0.01,0.02-0.02,0.04-0.03,0.05c-0.03-0.01-0.06-0.02-0.09-0.03c-0.12,0.34-0.24,0.68-0.36,1.01 c-0.35,0.79-0.69,1.61-1.01,2.48c-0.69,1.83-1.26,3.65-1.74,5.45c-2.08,6.07-3.9,11.64-5.49,16.66c62.56,0,136.95,0,193.51,0 c-0.93-39.93-13.52-52.28-13.79-75.12c-0.12-10.06-0.47-18.14-1.14-24.45l-2.34,13.53c1.01-5.86,1.8-11.02,2.13-15.38 c-1.18-9.53-3.19-14.57-6.39-15.93c-3.86-0.76-9.69,0.56-18.21,4.26c-27.06,11.74-59.73,5.62-34.72,3.57 c25.02-2.04,54.63-16.85,60.75-45.44c6.13-28.59,22.46-68.41,27.06-90.36c0,0,0.13,0.13,0.27,0.52 c5.42-26.89,4.93-48.43,4.23-58.42c-0.03-0.46,0.64-0.55,0.73-0.09c8.76,42.78-1.59,65.85-9.95,92.18 c4.05,2.92,10.48,7.69,18.61,16.02c13.71,14.04,29.7,30.42,45.79,15.21c0.77-0.73,1.55-1.53,2.32-2.41 c4.1-4.66,7.08-9.71,9.19-14.77c0.2,0.39,0.3,0.59,0.3,0.59c7.71-20.43,12.37-35.74,14.87-57.5c2.5-21.76,3.12-35.84,5-48.64 C3819.04,701.35,3815.91,699.43,3810.91,691.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M3524.43,1000.13c0.48-1.8,1.06-3.62,1.74-5.45c0.32-0.87,0.66-1.69,1.01-2.48 c0.12-0.34,0.24-0.67,0.36-1.01c0.03,0.01,0.06,0.02,0.09,0.03c0.01-0.02,0.02-0.04,0.03-0.05c-0.03-0.01-0.07-0.02-0.1-0.03 c0.12-0.34,0.24-0.68,0.36-1.02c0.07-0.19,0.14-0.38,0.21-0.57c0.07,0.08,0.14,0.16,0.21,0.24c6.9-13.18,17.89-14.73,34.46-19.4 c20.56-7.71,61.89-21.01,56.85-21.27c-30.87-1.6-46.66-12.67-47.9-15.43c-0.26-15.44,27.1,11.48,75.03-4.63 c1.66-0.56,1.8-2.82,0.15-3.44c-18.78-6.97-58.26-15.18-69.66-31.5c-11.4-16.3-13.83-36.35-13.29-56.62 c1.33-13.68,2.8-27.24,4.2-39.58c4.33-30.08,8.29-53.36,8.29-53.36s-0.54,2.43-1.44,7.03c1.13-8.11,1.2-10.59-0.62-3.35 c-0.13,0.51-0.26,1.02-0.38,1.54c0.51-3.95,0.72-5.49,0.49-3.85c-0.7,5.06-3.66,16.3-6.95,30.47c-1.83,6.76-3.01,8.91-3.06,0.93 c-0.1-15.84-8.84-46.88-8.64-15.19c0.17,27.79,2.53,50.8,1.76,72.36c-0.18,2.25-0.32,4.49-0.41,6.69 c-0.03,0.72-0.06,1.43-0.1,2.15c0,0.05-0.01,0.11-0.01,0.17c0,0,0,0.03,0,0.08c-3.14,68.22-9.85,82.21-20.77,105.32 c-10.04,21.25-18.57,47.55-24.45,67.89c2.33,0,4.68,0,7.05,0C3520.53,1011.77,3522.35,1006.2,3524.43,1000.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141616",
    d: "M3720.93,1007.94c-1.53-21.45-12.16-86.56-11.29-121.23c0.57-13.48,1.59-29.18,3.26-47.19 c1.82-10.15,4.15-20.77,7.09-30.37c0.36-1.17,0.72-2.33,1.09-3.49c8.36-26.33,18.71-49.4,9.95-92.18 c-0.09-0.45-0.76-0.37-0.73,0.09c0.71,9.99,1.2,31.53-4.23,58.42c-0.14-0.39-0.27-0.52-0.27-0.52 c-4.59,21.95-20.93,61.77-27.06,90.36c-6.13,28.59-35.74,43.39-60.75,45.44c-25.02,2.04,7.66,8.17,34.72-3.57 c8.52-3.7,14.35-5.01,18.21-4.26c3.19,1.36,5.21,6.4,6.39,15.93c-0.33,4.36-1.11,9.52-2.13,15.38l2.34-13.53 c0.67,6.31,1.03,14.4,1.14,24.45c0.27,22.84,12.86,35.19,13.79,75.12c3.14,0,6.23,0,9.26,0 C3721.37,1013.45,3721.11,1010.44,3720.93,1007.94z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3817.8,704.83c-0.83-7.25-6.88-13.07-6.88-13.07c2.08,7.68,4.58,13.23-3.75,31.14s-15.83,35.84-15,55.04 c0,0,1.07,6.88,0.98,15.58c-2.8-21.01-10.72-40.45-18.95-58.82c3.15-15.19,9.6-19.27,13.14-26.73 c4.25-8.95,18.58-23.9,23.58-16.22c-1.87-4.48-2.5-1.92-6.25-16c-3.61-13.54-12.45-27.07-20.68-28.28 c-0.44-17.72-0.93-34.24-1.43-49.14c-3.55-105.09-10.02-181.6-18.05-238.19c-1.38-9.75-2.81-18.92-4.28-27.53 c-0.59-3.45-1.18-6.8-1.78-10.07c-11.69-64.07-25.11-95.61-34.91-115.54c-2.72-5.54-5.17-10.19-7.22-14.39 c-6.11-12.53-16.53-11.53-15.41-0.57c3.82,37.19,12.1,209.44,8.2,432.58c-6.28-1.98-13.09-2.55-20.14-2.35 c-6.92,0.2-14.07,1.13-21.21,2.24c-0.87,0.13-1.74,0.27-2.61,0.41c0,0-0.25-0.29-0.69-0.83c-1.41-1.75-4.73-6.19-7.69-12.27 c-1.5-3.08-2.9-6.59-3.91-10.38c0.33-4.57,1.7-14.21,6.8-32.02c7.85-27.41,19.54-56.01,20.68-75.72 c0.86-14.78,1.84-24.83-1.19-37.47c-0.55-2.28-1.23-4.65-2.06-7.15c-0.66-1.97-1.41-4.02-2.27-6.17c0,0,0.01,0.22,0.03,0.61 c0.02,0.39,0.05,0.96,0.09,1.68c0.19,3.65,0.57,11.05,0.93,17.69c0,0-1.5-4.72-5.69-11.33c-0.05-0.08-0.1-0.15-0.15-0.23 c-1.25-1.96-2.74-4.07-4.49-6.27c-0.1-0.13-0.2-0.26-0.3-0.38c-8.01-9.97-10.95-9.97-18.57-13.29c-7.62-3.32,0.4,1.18,7.14,8.9 c6.74,7.72-87.09-14.47-96.49,46.49c-3.32,21.53-1.78,29.88-1.78,29.88c0.07-0.02,0.14-0.04,0.22-0.06 c4.37-1.25,12.02,2.9,12.86,19.12c0.45,8.73-1.61,9.56-3.94,23.25c-1.47,8.69-5.89,9.76-9,9.37c-0.47-0.06-0.92-0.15-1.31-0.25 c0,0,1.72,1.97,5.61,0.99c-0.4,0.9,2.78,50.61-19.28,43.51c-0.39-0.12-0.78-0.26-1.18-0.42c0,0,2.14,1.98,7.65,3.35 c1.42,0.35,3.07,0.66,4.95,0.89c3.32,0.4,7.4,0.54,12.36,0.18c0.41-0.03,0.8-0.06,1.18-0.1c0.31,0.07,0.66,0.16,1.02,0.28 c0.9,0.29,1.91,0.74,2.81,1.37c0.61,0.43,1.17,0.94,1.61,1.55c0.31,0.42,0.57,0.89,0.75,1.41c0.08,0.22,0.14,0.44,0.19,0.68 c0.04,0.17,0.06,0.35,0.08,0.54l0.18-0.04l1.67-0.36c3,7.3,9.62,11.82-1.06,16.44c0,0,12.95-2.63,27.82-3.03 c0.88-0.02,1.07,1.22,0.23,1.46c-10.71,3.09-33.18,7.28-61.91,33.45c-33.23,30.27-5.7,91.85-17.09,128.17 c-11.39,36.31-12.1,56.25-12.1,78.32c0,19.55-23.23,74.51-37.5,140.06c95.43,0,251.74,0,307.38,0 c3.98-50.37,5.74-114.72,6.16-180.31c-2.9,2.84-5.8,4.64-8.69,5.61c5.21-2.21,10.38-6.66,15.01-13.4 c1.74-2.54,3.41-5.41,4.97-8.61c0.31-0.63,0.62-1.28,0.92-1.94c2.38-5.2,4.49-11.21,6.24-18.03c0.56-2.19,1.09-4.45,1.57-6.81 c4.43-21.6,6.34-33.36,7.68-43.99c0.55-4.38,1-8.57,1.49-13.18C3816.74,720.34,3818.63,712.08,3817.8,704.83z"
  })))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "line",
    x: 900,
    y: 309,
    width: 1927,
    height: 15
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2492.7227 390.417)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "Since 2020, the electricity for all"), /*#__PURE__*/React.createElement("tspan", {
    x: -113.79,
    y: 36,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "BMW Group plants has been sourced from"), /*#__PURE__*/React.createElement("tspan", {
    x: -53.83,
    y: 72,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "30px"
  }, "100% RENEWABLE ENERGIES.")))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-left"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 725.0015 274.1221)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "127px",
    letterSpacing: -2
  }, "promised"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 895.834 396.4404)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "We aim to reduce"), /*#__PURE__*/React.createElement("tspan", {
    x: 182.92,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "24px"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 187.25,
    y: 0,
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "30px"
  }, " CO2 EMISSIONS"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36,
    fontFamily: "BMWGroupSerif, sans-serif",
    fontSize: "24px"
  }, "per vehicle produced.")))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "story-header-text-right"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2651.5776 267.3643)",
    fontFamily: "BMWGroupCondensed, sans-serif",
    fontSize: "127px",
    letterSpacing: -2
  }, "delivered"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeDesktop);
export default __webpack_public_path__ + "static/media/large-desktop.c6cc7dca.svg";
export { ForwardRef as ReactComponent };